export default {
  key1000000: `标题：`,
  key1000001: `链接地址：`,
  key1000002: `复制成功！`,
  key1000003: `复制`,
  key1000004: `请输入正确的关键词`,
  key1000005: `请输入关键词`,
  key1000006: `请输入菜单关键词`,
  key1000007: `上架工具`,
  key1000008: `通途Listing`,
  key1000009: `商城`,
  key1000010: `请输入关键字`,
  key1000011: `搜索`,
  key1000012: `全部商品类目`,
  key1000013: `运营系统`,
  key1000014: `供应商系统`,
  key1000015: `分销商系统`,
  key1000016: `商户编号：`,
  key1000017: `通途客户编号：`,
  key1000018: `正在退出...`,
  key1000019: `当前有 `,
  key1000020: ` 条订单超时未发，`,
  key1000021: `请点击处理`,
  key1000022: `查看更多`,
  key1000023: `时区：`,
  key1000024: `您当前的时间：`,
  key1000025: `世界标准时间：`,
  key1000026: `登出`,
  key1000027: `帮助中心`,
  key1000028: `上传文件格式有误,`,
  key1000029: `请选择jpg、jpeg、png格式文件`,
  key1000030: `文件大小受限,文件`,
  key1000031: `太大,`,
  key1000032: `不能超过20M`,
  key1000033: `全部商品`,
  key1000034: `请输入要搜索的关键词`,
  key1000035: `上传图片搜索`,
  key1000036: `售卖国/地区`,
  key1000037: `消息中心`,
  key1000038: `个人中心`,
  key1000039: `我的收藏`,
  key1000040: `退出登录`,
  key1000041: `你好，欢迎！`,
  key1000042: `免费注册`,
  key1000043: `登录`,
  key1000044: `原材料`,
  key1000045: `我们的产品采用最佳可用材料制成。`,
  key1000046: `设计`,
  key1000047: `新产品研发、测试与开发。`,
  key1000048: `质量控制`,
  key1000049: `交付前进行100%检验。`,
  key1000050: `市场`,
  key1000051: `美国、欧洲、北美、澳大利亚、印度等。`,
  key1000052: `备案号：`,
  key1000053: `多`,
  key1000054: `海量优质货源`,
  key1000055: `20w+SKU，每日上新500+`,
  key1000056: `快`,
  key1000057: `一键上传全平台`,
  key1000058: `开店必备，5分钟开好店铺`,
  key1000059: `好`,
  key1000060: `专业团队品质保障`,
  key1000061: `专业拣货、分拣、打包、发货等服务`,
  key1000062: `省`,
  key1000063: `0库存开店，无资金压力`,
  key1000064: `无需囤货备货，先出单后付款`,
  key1000065: `商城介绍`,
  key1000066: `电话：`,
  key1000067: `手机号：`,
  key1000068: `邮箱：`,
  key1000069: `成为分销商`,
  key1000070: `立即注册`,
  key1000071: `成为供应商`,
  key1000072: `供应商入驻`,
  key1000073: `入驻指南`,
  key1000074: `供应商登录`,
  key1000075: `常见问题`,
  key1000076: `法律声明`,
  key1000077: `服务条款`,
  key1000078: `隐私政策`,
  key1000079: `关于我们`,
  key1000080: `平台业务`,
  key1000081: `联系我们`,
  key1000082: `业务咨询`,
  key1000083: `一站式跨境服装分销`,
  key1000084: `已停售`,
  key1000085: `Hi，欢迎来到`,
  key1000086: `商城！`,
  key1000087: `Hi，欢迎来到TONGTOOL！`,
  key1000088: `售卖国/地区：`,
  key1000089: `商品发货地：`,
  key1000090: `商户号：`,
  key1000091: `退出`,
  key1000092: `请登录`,
  key1000093: `消息`,
  key1000094: `入门指引`,
  key1000095: `我的订单`,
  key1000096: `我的购物车`,
  key1000097: `操作成功!`,
  key1000098: `搜全站`,
  key1000099: `搜本店`,
  key1000100: `商品名称：`,
  key1000101: `请选择`,
  key1000102: `无匹配数据`,
  key1000103: `加载中`,
  key1000104: `暂无数据`,
  key1000105: `删除`,
  key1000106: `更多`,
  key1000107: `暂无筛选结果`,
  key1000108: `筛选`,
  key1000109: `重置`,
  key1000110: `全部`,
  key1000111: `确定`,
  key1000112: `取消`,
  key1000113: `保存成功`,
  key1000114: `自定义列展示`,
  key1000115: `自定义列显示`,
  key1000116: `恢复默认`,
  key1000117: `保存为默认`,
  key1000118: `订单总金额：`,
  key1000119: `商品总金额：`,
  key1000120: `处理费：`,
  key1000121: `运费：`,
  key1000122: `物流渠道名称：`,
  key1000123: `运费：待选择物流渠道`,
  key1000124: `订单-`,
  key1000125: `当前账户`,
  key1000126: `余额充足`,
  key1000127: `请问是否确认提交订单，系统会自动使用账户余额进行抵扣。`,
  key1000128: `余额不足`,
  key1000129: `点击去充值`,
  key1000130: `（若有自有库存，则忽略此提示）`,
  key1000131: `请问是否确认提交订单，系统会自动为您创建“待付款”状态的订单，需要您进行支付后，平台才会进行订单履约。`,
  key1000132: `（若已充值则关闭窗口重新提交）`,
  key1000133: `更多筛选项`,
  key1000134: `最近一周`,
  key1000135: `最近一个月`,
  key1000136: `最近三个月`,
  key1000137: `现货一件代发`,
  key1000138: `文件大小超出限制，最大为10M`,
  key1000139: `系统繁忙，上传文件失败！`,
  key1000140: `文件格式有误`,
  key1000141: `收起`,
  key1000142: `没有相关记录`,
  key1000143: `密码不能为空`,
  key1000144: `密码不能包含中文`,
  key1000145: `请填写邮件地址`,
  key1000146: `不是有效的邮箱或者邮箱格式不正确`,
  key1000147: `手机号码不能为空`,
  key1000148: `手机号码格式不正确`,
  key1000149: `只允许输入数字格式号码`,
  key1000150: `固定电话号码格式不正确`,
  key1000151: `省市区地址不能为空`,
  key1000152: `请选择完整的省市区地址`,
  key1000153: `确认是否删除`,
  key1000154: `温馨提示`,
  key1000155: `操作成功`,
  key1000156: `包裹号`,
  key1000157: `资料覆盖提醒`,
  key1000158: `新的售卖产品资料将覆盖已经生成过的售卖产品资料，生成后不可恢复，是否生成？`,
  key1000159: `立即生成`,
  key1000160: `请先勾选要生成售卖资料的数据！`,
  key1000161: `任务生成成功，请至生成售卖资料模块中查看结果。`,
  key1000162: `调价`,
  key1000163: `跳转失败！`,
  key1000164: `订单提交确认`,
  key1000165: `1天`,
  key1000166: `2天`,
  key1000167: `3天`,
  key1000168: `4天`,
  key1000169: `5天`,
  key1000170: `6天`,
  key1000171: `7天`,
  key1000172: `基础属性的可选值最多只能选取5个!`,
  key1000173: `此属性已存在，请输入其他属性名。`,
  key1000174: `属性值已被停用，请更换为相近的属性值`,
  key1000175: `属性值异常，请更换属性值`,
  key1000176: `属性值比例不能为空`,
  key1000177: `属性值比例必须是大于0的正整数`,
  key1000178: `每个属性的属性值比例总和要等于100%`,
  key1000179: `规格属性存在已停用属性值，更换为相近的属性值后重试。`,
  key1000180: `规格属性属性值异常，请更换属性值后重试。`,
  key1000181: `基础属性的属性值异常，请更换属性值后重试。`,
  key1000182: ` 相同`,
  key1000183: `商品规格不可为空，必须选择填写一种商品规格信息`,
  key1000184: `未匹配`,
  key1000185: `指定产品`,
  key1000186: `指定站点`,
  key1000187: `指定店铺`,
  key1000188: `并且`,
  key1000189: `或者`,
  key1000190: `以`,
  key1000191: `不以`,
  key1000192: `系统繁忙，请重新尝试`,
  key1000193: `运输类型为空`,
  key1000194: `添加成功`,
  key1000195: `操作失败，请重新尝试`,
  key1000196: `删除失败,请重新尝试`,
  key1000197: `指定国家`,
  key1000198: `指定分类`,
  key1000199: `请将邮编段填写完整`,
  key1000200: `指定内容`,
  key1000201: `指定基础物流`,
  key1000202: `多品`,
  key1000203: `单品`,
  key1000204: `拣货单:`,
  key1000205: `拣货仓库：`,
  key1000206: `物流商:`,
  key1000207: `拣货单类型：`,
  key1000208: `出库单数量：`,
  key1000209: `创建时间：：`,
  key1000210: `SKU总数：`,
  key1000211: `拣货人员：`,
  key1000212: `SKU种类：`,
  key1000213: `所在库区`,
  key1000214: `所在库位`,
  key1000215: `需拣货数量`,
  key1000216: `中文描述`,
  key1000217: `产品规格`,
  key1000218: `英文描述`,
  key1000219: `批次号`,
  key1000220: `物流商`,
  key1000221: `等`,
  key1000222: `物流渠道`,
  key1000223: `多种物流渠道`,
  key1000224: `购物车`,
  key1000225: `微信咨询`,
  key1000226: `电话咨询`,
  key1000227: `返回顶部`,
  key1000228: `物流单作废费收取提示`,
  key1000229: `“物流单作废费用：`,
  key1000230: `订单已成功下发物流且获取到运单号，此操作会将此订单将取消作废并生成新的订单，当前已超过获取运单号时间`,
  key1000231: `取消订单需要收取`,
  key1000232: `（实际扣费以操作取消时对应时间为准）`,
  key1000233: `订单原费用：`,
  key1000234: `退款金额：`,
  key1000235: `物流渠道名称不能为空`,
  key1000236: `选择引用的渠道`,
  key1000237: `请选择物流商：`,
  key1000238: `请选择物流渠道：`,
  key1000239: `SKU信息`,
  key1000240: `规格：`,
  key1000241: `仓库名称`,
  key1000242: `分配数量`,
  key1000243: `可用数量`,
  key1000244: `可用数量必须是大于等于0的整数`,
  key1000245: `供应商库存详情`,
  key1000246: `中心仓库存详情`,
  key1000247: `处理中...`,
  key1000248: `关闭`,
  key1000249: `文件大小超出限制，最大为100M`,
  key1000250: `上传文件失败，请重新尝试`,
  key1000251: `上传成功`,
  key1000252: `请先选择分类！`,
  key1000253: `请先选择商品发货仓！`,
  key1000254: `请先选择上传文件`,
  key1000255: `下载中...`,
  key1000256: `下载模板成功！`,
  key1000257: `导入商品`,
  key1000258: `选择分类：`,
  key1000259: `选择商品发货仓：`,
  key1000260: `供货仓需配置具体目标集货仓，直发仓需配置具体可用物流，否则无法使用`,
  key1000261: `模板：`,
  key1000262: `上传文件：`,
  key1000263: `第1步：下载模板`,
  key1000264: `模板下载`,
  key1000265: `第2步：上传资料`,
  key1000266: `请选择文件`,
  key1000267: `导入数据发现相同SPU时：`,
  key1000268: `覆盖`,
  key1000269: `忽略`,
  key1000270: `提示:`,
  key1000271: `1.请按照模板中的导入说明文档进行商品信息上传。`,
  key1000272: `2.仅支持拓展名：.zip。`,
  key1000273: `3.当导入数据存在异常时，数据导入失败。`,
  key1000274: `4.导入操作后，请稍后在“导入/导出任务-导入查看”中查看导入结果。`,
  key1000275: `5.暂无法对组装商品进行导入或覆盖。`,
  key1000276: `无合规责任人信息？点击`,
  key1000277: `无制造商信息？点击`,
  key1000278: `关联合规负责人`,
  key1000279: `关联制造商`,
  key1000280: `关联成功！`,
  key1000281: `负责人：`,
  key1000282: `制造商：`,
  key1000283: `新建`,
  key1000284: `选择类目`,
  key1000285: `已选类名：`,
  key1000286: `属性`,
  key1000287: `属性值`,
  key1000288: `操作日志`,
  key1000289: `操作类型`,
  key1000290: `操作内容描述`,
  key1000291: `操作时间`,
  key1000292: `操作人`,
  key1000293: `分销商操作`,
  key1000294: `运营工作人员`,
  key1000295: `供应商`,
  key1000296: `查看详情`,
  key1000297: `处理费修改：`,
  key1000298: `物流费修改：`,
  key1000299: `原价：`,
  key1000300: `修改后：`,
  key1000301: `货品金额修改：`,
  key1000302: `原值：`,
  key1000303: `编辑属性`,
  key1000304: `必填`,
  key1000305: `非必填`,
  key1000306: `推荐填写`,
  key1000307: `规格属性`,
  key1000308: `普通属性`,
  key1000309: `属性值多选`,
  key1000310: `属性值单选`,
  key1000311: `是尺码属性`,
  key1000312: `不是尺码属性`,
  key1000313: `允许自定义属性值`,
  key1000314: `不允许自定义属性值`,
  key1000315: `编辑属性值`,
  key1000316: `知道了`,
  key1000317: `订单所需数量`,
  key1000318: `打印数量`,
  key1000319: `操作`,
  key1000320: `打印`,
  key1000321: `打印数量不能为空！`,
  key1000322: `获取打印标签链接地址异常！`,
  key1000323: `打印合规标签`,
  key1000324: `请输入`,
  key1000325: `快捷搜索侧边栏菜单`,
  key1000326: `菜单设置`,
  key1000327: `导入成功，当前导入的ymsSku不存在：`,
  key1000328: `仓库`,
  key1000329: `导入`,
  key1000330: `提示`,
  key1000331: `下载文件模板失败！`,
  key1000332: `请先选择仓库`,
  key1000333: `仓库：`,
  key1000334: `文件名称：`,
  key1000335: `选择仓库：`,
  key1000336: `导入的数据已存在时：`,
  key1000337: `更新`,
  key1000338: `追加`,
  key1000339: `当前定制商品SKU`,
  key1000340: `此前设计的商品SKU`,
  key1000341: `设计重复提示`,
  key1000342: `以下定制商品存在与“我设计的商品”列表中商品对应设计内容一致，请勿重复设计。`,
  key1000343: `序号`,
  key1000344: `任务编号`,
  key1000345: `导出类型`,
  key1000346: `导出时间`,
  key1000347: `导出状态`,
  key1000348: `正在导出`,
  key1000349: `系统操作`,
  key1000350: `备注`,
  key1000351: `文件保留7天，超过7天将不能下载！`,
  key1000352: `下载文件`,
  key1000353: `导出中`,
  key1000354: `导出完成`,
  key1000355: `导出失败`,
  key1000356: `日期格式有误`,
  key1000357: `导出类型：`,
  key1000358: `任务编号：`,
  key1000359: `导出时间：`,
  key1000360: `选择日期`,
  key1000361: `查询`,
  key1000362: `查看全部通知`,
  key1000363: `其他`,
  key1000364: `必填项不能为空！`,
  key1000365: `已选`,
  key1000366: `项`,
  key1000367: `提交`,
  key1000368: `跳过`,
  key1000369: `全部分类`,
  key1000370: `请输入类目关键词`,
  key1000371: `商品可售卖国/地区`,
  key1000372: `设置售卖国成功！`,
  key1000373: `编辑售卖国成功！`,
  key1000374: `商品可售卖国/地区：`,
  key1000375: `无可用选项`,
  key1000376: `工厂SPU`,
  key1000377: `请输入工厂SPU`,
  key1000378: `工厂SKU`,
  key1000379: `请输入工厂SKU`,
  key1000380: `商品名称`,
  key1000381: `请输入商品名称`,
  key1000382: `工厂不能为空`,
  key1000383: `商品信息`,
  key1000384: `工厂SPU：`,
  key1000385: `工厂SKU：`,
  key1000386: `所属分类`,
  key1000387: `POD平台未绑定`,
  key1000388: `暂未绑定POD平台，请绑定后重试。`,
  key1000389: `前往绑定`,
  key1000390: `主料选择`,
  key1000391: `工厂：`,
  key1000392: `是`,
  key1000393: `否`,
  key1000394: `单选`,
  key1000395: `多选`,
  key1000396: `属性中文名称`,
  key1000397: `属性值类型`,
  key1000398: `是否自定义`,
  key1000399: `填写要求`,
  key1000400: `单选/多选`,
  key1000401: `查看`,
  key1000402: `移除`,
  key1000403: `是否确认将该属性移出关联属性列表？`,
  key1000404: `关联属性管理`,
  key1000405: `新增关联属性`,
  key1000406: `从属性池选择`,
  key1000407: `选择配送方式`,
  key1000408: `物流渠道名称`,
  key1000409: `物流方案代码`,
  key1000410: `物流时效`,
  key1000411: `(天)`,
  key1000412: `修改配送方式`,
  key1000413: `请先勾选要配送方式的数据！`,
  key1000414: `当前的收货地址不支持配送！`,
  key1000415: `承运人`,
  key1000416: `承运商名称`,
  key1000417: `承运人电话`,
  key1000418: `是否可用`,
  key1000419: `可用`,
  key1000420: `不可用`,
  key1000421: `选取`,
  key1000422: `承运商的名称不能为空!`,
  key1000423: `请输入承运商名称`,
  key1000424: `承运商名称：`,
  key1000425: `属性已被使用，不可进行修改。`,
  key1000426: `属性值已被使用，不可进行修改。`,
  key1000427: `属性单位（`,
  key1000428: `新增属性`,
  key1000429: `中文名称`,
  key1000430: `英文-US`,
  key1000431: `英文-UK`,
  key1000432: `英文-AU`,
  key1000433: `英文-EU`,
  key1000434: `法语名称`,
  key1000435: `德语名称`,
  key1000436: `西班牙语名称`,
  key1000437: `荷兰语名称`,
  key1000438: `波兰语名称`,
  key1000439: `葡萄牙语名称`,
  key1000440: `意大利语名称`,
  key1000441: `罗马尼亚语名称`,
  key1000442: `语`,
  key1000443: `码`,
  key1000444: `法`,
  key1000445: `德`,
  key1000446: `西班牙`,
  key1000447: `荷兰`,
  key1000448: `波兰`,
  key1000449: `葡萄牙`,
  key1000450: `意大利`,
  key1000451: `罗马尼亚`,
  key1000452: `已存在相同名称的属性，请修改属性名称后再提交！`,
  key1000453: `中文、英文-US属性名称不能为空!`,
  key1000454: `同语种的属性值都要必填!`,
  key1000455: `同一个语种下的属性值不能相同！`,
  key1000456: `新增成功`,
  key1000457: `上传失败`,
  key1000458: `是否取消该尺码组别？`,
  key1000459: `是否确认取消该尺码组别？确认后该尺码组别不会显示在属性值里，所填写的数据也会清空。`,
  key1000460: `确定取消`,
  key1000461: `状态`,
  key1000462: `启用`,
  key1000463: `停用`,
  key1000464: `参考图片`,
  key1000465: `上传图片`,
  key1000466: `简介`,
  key1000467: `请填写属性单位`,
  key1000468: `同语种下属性单位不能相同`,
  key1000469: `请填写国家尺码信息`,
  key1000470: `请填写国家语种名称`,
  key1000471: `同语种下属性值不能相同`,
  key1000472: `所属站点：`,
  key1000473: `规格/普通属性：`,
  key1000474: `属性值类型：`,
  key1000475: `属性值单选/多选：`,
  key1000476: `填写要求：`,
  key1000477: `是否尺码属性：`,
  key1000478: `是否需填写比例：`,
  key1000479: `属性名称`,
  key1000480: `属性单位`,
  key1000481: `尺码组名：`,
  key1000482: `添加属性单位`,
  key1000483: `可选值`,
  key1000484: `允许自定义`,
  key1000485: `添加属性值`,
  key1000486: `审核成功，系统将在指定时间发送公告`,
  key1000487: `退回成功`,
  key1000488: `取消成功`,
  key1000489: `操作成功！`,
  key1000490: `稍后提醒`,
  key1000491: `更新完成提示`,
  key1000492: `年`,
  key1000493: `月`,
  key1000494: `客户账单`,
  key1000495: `平台账单`,
  key1000496: `账单`,
  key1000497: `客户“`,
  key1000498: `”的“`,
  key1000499: `账单已更新完毕，请问是否跳转查看？`,
  key1000500: `图片加载失败`,
  key1000501: `文件大小超出限制，最大为5M！`,
  key1000502: `上传图片格式错误！系统仅支持JPG、JPEG、PNG、WEBP、BMP格式图片上传`,
  key1000503: `上传图片中...`,
  key1000504: `添加多张图片`,
  key1000505: `已选择上传图片：`,
  key1000506: `图片要求：`,
  key1000507: `建议上传800*800像素以上正方形实拍大图，比如：800*800px，1000*1000px，1500*1500px，最大不超过5MB，，若不符合该尺寸则会导致上传失败。`,
  key1000508: `图片清晰无水印；`,
  key1000509: `包含商品整体款式和商品细节，比如：自拍模特图、海报图、白底图、3D图、细节图等。`,
  key1000510: `4.点击图片可使用系统提供的裁切工具助您更好的展示商品的特点！`,
  key1000511: `点击裁剪`,
  key1000512: `删除图片`,
  key1000513: `确定上传`,
  key1000514: `加载中...`,
  key1000515: `没有更多了`,
  key1000516: `上拉加载更多`,
  key1000517: `开通成功！`,
  key1000518: `需阅读并接受服务条款和隐私政策`,
  key1000519: `已阅读并接受`,
  key1000520: `和`,
  key1000521: `超时订单处理`,
  key1000522: `订单号`,
  key1000523: `数量`,
  key1000524: `缺货数量`,
  key1000525: `预计到货时间`,
  key1000526: `标记缺货`,
  key1000527: `以下订单已超时，请更新预计发货时间。`,
  key1000528: `所选订单商品信息如下：`,
  key1000529: `预计到货时间要大于今天的日期！`,
  key1000530: `标记成功！`,
  key1000531: `缺货数量不能为空`,
  key1000532: `预计到货时间不能为空`,
  key1000533: `请选择预计到货时间`,
  key1000534: `按订单查看`,
  key1000535: `按SKU查看`,
  key1000536: `缺货`,
  key1000537: `不缺货`,
  key1000538: `补货`,
  key1000539: `停售`,
  key1000540: `系统将自动将此SKU进行停售`,
  key1000541: `弹窗内单次最多可处理100行订单数据`,
  key1000542: `稍后处理`,
  key1000543: `确认`,
  key1000544: `国家相同覆盖，不同追加`,
  key1000545: `覆盖原有数据`,
  key1000546: `选择上传文件`,
  key1000547: `导入运费模板`,
  key1000548: `计费方式：`,
  key1000549: `计重方式：`,
  key1000550: `选择文件：`,
  key1000551: `导入处理：`,
  key1000552: `（材积重：`,
  key1000553: `批量上传`,
  key1000554: `下载`,
  key1000555: `保存`,
  key1000556: `物流选择不能为空`,
  key1000557: `万邑通3PL物流`,
  key1000558: `米雲仓平台物流`,
  key1000559: `绑定成功！`,
  key1000560: `请先选择要绑定的3PL物流！`,
  key1000561: `海外仓平台物流绑定`,
  key1000562: `物流选择：`,
  key1000563: `(已启用)`,
  key1000564: `平台基础物流`,
  key1000565: `关联绑定`,
  key1000566: `选择指定异常`,
  key1000567: `本条件用于筛选异常状况，以下条件符合任何一项，即认为符合本条件。`,
  key1000568: `姓名字符中空格数小于`,
  key1000569: `俄罗斯邮政要求收件人地址为全名，此处可输入2`,
  key1000570: `姓名字符数小于`,
  key1000571: `输入1时，相当于收件人姓名为空`,
  key1000572: `地址字符数小于`,
  key1000573: `地址1+地址2的总字符长度`,
  key1000574: `城市名字字符数小于`,
  key1000575: `输入1时，相当于城市名称为空`,
  key1000576: `省/州名字字符数小于`,
  key1000577: `输入1时，相当于省州名称为空`,
  key1000578: `邮编字符数小于`,
  key1000579: `输入1时，相当于邮编为空`,
  key1000580: `电话号码数字字符个数小于`,
  key1000581: `电话、手机两个号码必须都小于该值才认为该条件成立`,
  key1000582: `仓库直发价（`,
  key1000583: `供货价（`,
  key1000584: `是否确认删除？`,
  key1000585: `图片`,
  key1000586: `供应商SKU`,
  key1000587: `规格`,
  key1000588: `包装尺寸（长，宽，高cm）`,
  key1000589: `重量(g)`,
  key1000590: `商品状态`,
  key1000591: `已删除`,
  key1000592: `该仓库不支持直接发货`,
  key1000593: `上架`,
  key1000594: `打印条码`,
  key1000595: `打印二维码`,
  key1000596: `审核通过后，自动生成`,
  key1000597: `分类：`,
  key1000598: `商品状态：`,
  key1000599: `中文标题：`,
  key1000600: `供应商SPU：`,
  key1000601: `SKU数量：`,
  key1000602: `商品总可用数量：`,
  key1000603: `驳回原因`,
  key1000604: `大量现货`,
  key1000605: `放心推广`,
  key1000606: `平台会根据订单的应付总额使用账户余额进行预扣，请确保账户有足够的余额。`,
  key1000607: `平台会在“付款管理”列表中发起一条付款信息，可于此处上传支付凭证。`,
  key1000608: `付款成功`,
  key1000609: `付款`,
  key1000610: `勾选中`,
  key1000611: `条订单`,
  key1000612: `支付方式：`,
  key1000613: `账户余额支付`,
  key1000614: `上传支付凭证`,
  key1000615: `平台提示：`,
  key1000616: `面单`,
  key1000617: `获取面单地址失败！`,
  key1000618: `打印提示`,
  key1000619: `SKU中包含中文，暂不支持条形码打印，请使用二维码打印!`,
  key1000620: `打印数量必须大于0`,
  key1000621: `面单尺寸选择：`,
  key1000622: `样式预览：`,
  key1000623: `黑色·XL`,
  key1000624: `打印数量：`,
  key1000625: `图片尺寸至少要≥`,
  key1000626: `且`,
  key1000627: `文件大小超出限制，最大为`,
  key1000628: `加载图片中...`,
  key1000629: `裁剪图片.jpeg`,
  key1000630: `图片裁剪`,
  key1000631: `裁切须知`,
  key1000632: `1.为了保证您的商品可以更好的展示给分销商并带来更多的订单，上传的商品图片长宽尺码必须≥800。`,
  key1000633: `2.若原始上传的图片尺码长宽≤800，则需要重新上传图片。`,
  key1000634: `3.商户可通过裁切，调整已上传图片的展示比例，突出商品的特点。`,
  key1000635: `图片宽度：`,
  key1000636: `图片高度：`,
  key1000637: `预览`,
  key1000638: `+重新上传图片`,
  key1000639: `退回说明不能为空`,
  key1000640: `退回`,
  key1000641: `退回说明：`,
  key1000642: `请输入退回说明`,
  key1000643: `退回后此公告将流转为待修改状态，请确认是否退回修改？`,
  key1000644: `日志内容`,
  key1000645: `改为`,
  key1000646: `操作日期`,
  key1000647: `运营系统操作`,
  key1000648: `供应商系统操作`,
  key1000649: `SPU价格调整`,
  key1000650: `部分SKU价格调整`,
  key1000651: `SKU价格调整`,
  key1000652: `允许不同库区组的出库单进入同一张拣货单？`,
  key1000653: `允许不同库区的出库单进入同一张拣货单？`,
  key1000654: `允许不同物流商的包裹进入同一张拣货单？`,
  key1000655: `允许相同物流商不同邮寄方式的包裹进入同一张拣货单？`,
  key1000656: `每张常规拣货单最大包裹数`,
  key1000657: `每张备货拣货单最大包裹数`,
  key1000658: `允许`,
  key1000659: `不允许`,
  key1000660: `请选择刊登店铺`,
  key1000661: `请选择刊登模版`,
  key1000662: `请选择商品发货仓`,
  key1000663: `刊登草稿失败`,
  key1000664: `选择要刊登的店铺`,
  key1000665: `站点：`,
  key1000666: `刊登店铺：`,
  key1000667: `刊登模版：`,
  key1000668: `商品发货仓：`,
  key1000669: `设置`,
  key1000670: `您的商品：`,
  key1000671: `，审核未通过，驳回原因：`,
  key1000672: `处理中`,
  key1000673: `操作成功，系统正在处理中...`,
  key1000674: `已标记已读！`,
  key1000675: `消息通知`,
  key1000676: `点击去授权`,
  key1000677: `没有更多数据了...`,
  key1000678: `稍后再看`,
  key1000679: `第`,
  key1000680: `项：`,
  key1000681: `不能为空`,
  key1000682: `上传`,
  key1000683: `成功`,
  key1000684: `失败`,
  key1000685: `商品选择`,
  key1000686: `选择需要定制的商品及其规格`,
  key1000687: `定制信息配置`,
  key1000688: `选择商品定制部位并上传您需要定制的素材图片`,
  key1000689: `商品SPU：`,
  key1000690: `相同`,
  key1000691: `配置定制内容`,
  key1000692: `定制部位`,
  key1000693: `素材图`,
  key1000694: `成品预览图`,
  key1000695: `SKU数量`,
  key1000696: `供应商库存(件)`,
  key1000697: `价格`,
  key1000698: `定制我的设计`,
  key1000699: `新增设计`,
  key1000700: `查看&编辑定制信息`,
  key1000701: `内容未保存提醒`,
  key1000702: `未保存的内容将丢失，请确认是否退出？`,
  key1000703: `请先选择需要定制的商品！`,
  key1000704: `定制商品的配置定制信息不能为空！`,
  key1000705: `保存成功！`,
  key1000706: `设计成功提示`,
  key1000707: `新增成功提示`,
  key1000708: `配置成功！`,
  key1000709: `请勾选信息后进行操作`,
  key1000710: `上传图片格式有误, 只能上传jpg、png、jpeg格式图片!`,
  key1000711: `上传单张图片大小不能超过 5MB!`,
  key1000712: `删除图片成功`,
  key1000713: `全部定制类目`,
  key1000714: `商品SPU`,
  key1000715: `选择您需要定制的商品。`,
  key1000716: `商品定制信息配置`,
  key1000717: `选择您所需求定制的具体部位，上传对应的素材图以及成品预览图。`,
  key1000718: `添加`,
  key1000719: `请选择定制部位`,
  key1000720: `点击查看大图`,
  key1000721: `商品规格`,
  key1000722: `选择您需要定制商品的规格信息。`,
  key1000723: `可选择批量/单个配置商品的定制信息`,
  key1000724: `批量配置`,
  key1000725: `上一步`,
  key1000726: `设计成功！已为您新增SPU为“`,
  key1000727: `的商品至`,
  key1000728: `分销后台-我设计的商品`,
  key1000729: `”列表中，请问是否跳转至对应列表查看？`,
  key1000730: `新增设计成功！已为您新增SPU为“`,
  key1000731: `”列表中。`,
  key1000732: `我知道了`,
  key1000733: `供应商币种`,
  key1000734: `添加供应商币种`,
  key1000735: `添加分销商币种`,
  key1000736: `更换币种`,
  key1000737: `分销商币种`,
  key1000738: `币种`,
  key1000739: `问题汇总`,
  key1000740: `可用库存变化`,
  key1000741: `已分配库存变化`,
  key1000742: `事务类型`,
  key1000743: `可用库存结存`,
  key1000744: `分配库存变化`,
  key1000745: `分配库存结存`,
  key1000746: `作废库存变化`,
  key1000747: `作废库存结存`,
  key1000748: `相关单据号`,
  key1000749: `收货`,
  key1000750: `分配`,
  key1000751: `取消分配`,
  key1000752: `库存移动`,
  key1000753: `库存冻结`,
  key1000754: `取消冻结`,
  key1000755: `库存调整`,
  key1000756: `调拨出库`,
  key1000757: `收货上架`,
  key1000758: `调整顺序`,
  key1000759: `取消出库`,
  key1000760: `同步库存`,
  key1000761: `取消收货`,
  key1000762: `回收库存`,
  key1000763: `归库`,
  key1000764: `出库`,
  key1000765: `导入库存`,
  key1000766: `更新库存`,
  key1000767: `获取列表数据失败`,
  key1000768: `库存事务明细`,
  key1000769: `库存变化类型：`,
  key1000770: `操作时间：`,
  key1000771: `选择开始日期`,
  key1000772: `选择结束日期`,
  key1000773: `到`,
  key1000774: `excel导出`,
  key1000775: `未选择`,
  key1000776: `新增成功！`,
  key1000777: `模板名称不能为空！`,
  key1000778: `是否要删除当前模板？`,
  key1000779: `删除成功`,
  key1000780: `选择日期时间`,
  key1000781: `请输入模板名称`,
  key1000782: `已生成的报表文件，系统最多保留7天，超过7天不支持下载。`,
  key1000783: `查看导出列表`,
  key1000784: `导出模板：`,
  key1000785: `管理导出模板`,
  key1000786: `返回`,
  key1000787: `时间范围：`,
  key1000788: `请选择导出维度：`,
  key1000789: `请勾选需导出的字段：`,
  key1000790: `全选`,
  key1000791: `存为新模板`,
  key1000792: `导出`,
  key1000793: `选择邮寄方式`,
  key1000794: `全部收起`,
  key1000795: `全部展开`,
  key1000796: `图片上传规范`,
  key1000797: `轮播图上传规范`,
  key1000798: `推荐按以下顺序上传图片，合理清晰的图片顺序方便查看商品。`,
  key1000799: `单张图片尺寸`,
  key1000800: `尺寸建议800*800px以上（800*800px，1000*1000px，1500*1500px）最大不超过5MB。`,
  key1000801: `比例为正方形，合适的尺寸能看清楚细节。`,
  key1000802: `供货价格分层数值不能为空！`,
  key1000803: `价格库存列表必填项不能为空！`,
  key1000804: `供应商仓直发价格配置`,
  key1000805: `供应商直发仓`,
  key1000806: `加价金额（`,
  key1000807: `服务费（`,
  key1000808: `价（`,
  key1000809: `供应商直发仓批发价格`,
  key1000810: `批发价（`,
  key1000811: `此价格仅适用于供应商供货仓供货/备货到平台`,
  key1000812: `集货仓`,
  key1000813: `中心仓价格配置`,
  key1000814: `中心仓`,
  key1000815: `中心仓批发价格`,
  key1000816: `该商品类目成功匹配`,
  key1000817: `商品类目信息`,
  key1000818: `“，确认选择该主料后将会替换当前商品类目信息，商品规格等设置信息会被新类目对应的信息覆盖。`,
  key1000819: `该主料商品类目不属于`,
  key1000820: `商品类目表中类目内容，请更换选择主料，或手动绑定工厂加工商品。`,
  key1000821: `商品分类不能为空`,
  key1000822: `商品货号/SPU不能为空`,
  key1000823: `商品原产地不能为空`,
  key1000824: `商品发货仓不能为空`,
  key1000825: `商品轮播图不能为空`,
  key1000826: `图片类型不能为空`,
  key1000827: `累计购买数量`,
  key1000828: `至`,
  key1000829: `不可小于等于左区间`,
  key1000830: `优惠金额`,
  key1000831: `折扣系数`,
  key1000832: `请输入优惠金额,如：1.00`,
  key1000833: `请输入折扣系数,如：0.1`,
  key1000834: `分层价格参考`,
  key1000835: `优惠价：`,
  key1000836: `无限`,
  key1000837: `删除分层`,
  key1000838: `商品`,
  key1000839: `更新成功`,
  key1000840: `选项未填写完整`,
  key1000841: `商品属性的输入框仅限输入数字及小数点！`,
  key1000842: `商品中文名称不能为空！`,
  key1000843: `新品审核成功!`,
  key1000844: `在售商品修改审核成功!`,
  key1000845: `均码`,
  key1000846: `、输入值后enter`,
  key1000847: ` 自动生成`,
  key1000848: `自动生成sku规则：商品货号/SPU + 规格属性`,
  key1000849: `主料尺寸（长、宽、高cm）：`,
  key1000850: `长`,
  key1000851: `宽`,
  key1000852: `高`,
  key1000853: `长宽高`,
  key1000854: `重量`,
  key1000855: `主料重量（g）：`,
  key1000856: `主料SKU信息`,
  key1000857: `点击选择加工主料`,
  key1000858: `加工主料未选择`,
  key1000859: `辅料工艺`,
  key1000860: `请先选择主料信息`,
  key1000861: `点击选择辅料工艺`,
  key1000862: `辅料工艺未选择`,
  key1000863: `位置&素材`,
  key1000864: `设置第一列'位置&素材'信息后，勾选可使拥有相同可用打印位置的商品获得相同'位置&素材'设置，但您需自行判断，不同规格的商品，是否存在信息需要微调。`,
  key1000865: `位置&素材未设置`,
  key1000866: `定制信息`,
  key1000867: `定制信息不能为空`,
  key1000868: `(属性值已被停用)`,
  key1000869: `预览图`,
  key1000870: `活动价`,
  key1000871: `活动价（`,
  key1000872: `仓库直发价（CNY）`,
  key1000873: `仓库直发价`,
  key1000874: `此价格适用于供应商仓直发至买家手中`,
  key1000875: `供应商直发`,
  key1000876: `价：此价格适用于供应商仓直发至买家手中时`,
  key1000877: `价\n`,
  key1000878: `价=仓库直发价+商品加价金额+商品服务费`,
  key1000879: `供应商直发批发价：此价格适用于供应商仓直发至买家手中时批发价\n`,
  key1000880: `商品批发价=仓库直发价+商品加价金额+商品服务费`,
  key1000881: `供货价（CNY）`,
  key1000882: `供货价`,
  key1000883: `中心仓价格（CNY）`,
  key1000884: `价：此商品经过`,
  key1000885: `中心仓发出时`,
  key1000886: `价=商品供货价+商品加价金额+商品服务费`,
  key1000887: `中心仓批发价：此商品经过`,
  key1000888: `中心仓发出时批发价\n`,
  key1000889: `商品批发价=商品供货价+商品加价金额+商品服务费`,
  key1000890: `库存`,
  key1000891: `商品货号/SPU不能为空!`,
  key1000892: `尺码`,
  key1000893: `法码`,
  key1000894: `德码`,
  key1000895: `西班牙码`,
  key1000896: `荷兰码`,
  key1000897: `波兰码`,
  key1000898: `葡萄牙码`,
  key1000899: `意大利码`,
  key1000900: `罗马尼亚码`,
  key1000901: `单个规格最多上传5张图片`,
  key1000902: `关闭提示`,
  key1000903: `确认退出`,
  key1000904: `标题不能为空`,
  key1000905: `选择主料确认`,
  key1000906: `该主料不可用`,
  key1000907: `切换主料SKU确认`,
  key1000908: `切换主料SKU后，部位&素材设置信息需要重新填写。请确认是否切换主料SKU?`,
  key1000909: `确认切换`,
  key1000910: `包装尺寸（长*宽*高 cm）`,
  key1000911: `包装长宽高各边最长不超过40cm，泳装除外，春夏款式高度最高不超过3cm，最低不低于1cm`,
  key1000912: `填充的数据不能为0`,
  key1000913: `填充`,
  key1000914: `重量填写最大码克重`,
  key1000915: `请输入价格`,
  key1000916: `零售`,
  key1000917: `销售`,
  key1000918: `加价配置：商品供货价的 `,
  key1000919: `%  +  固定金额的 `,
  key1000920: `服务费配置：商品加价后金额的 `,
  key1000921: `批发`,
  key1000922: `修改前内容：`,
  key1000923: `请先选择商品发货仓`,
  key1000924: `库存为整数`,
  key1000925: `请输入库存`,
  key1000926: `当前商品类目不允许其商品进行定制，请问是否清空商品类目，注意，此操作会导致下方已维护的商品信息清空，请谨慎操作。`,
  key1000927: `enter可以输入自定义属性`,
  key1000928: `请选择规格`,
  key1000929: `基本信息`,
  key1000930: `类型：`,
  key1000931: `商品是否支持定制：`,
  key1000932: `商品类目：`,
  key1000933: `商品货号/SPU：`,
  key1000934: `请输入商品货号/SPU`,
  key1000935: `商品原产地：`,
  key1000936: `选择主料：`,
  key1000937: `商品轮播图：`,
  key1000938: `图片类型：`,
  key1000939: `商品标题组成:商品特征+商品品类即可，不需要加年份、eBay、 亚马逊等字眼`,
  key1000940: `商品属性`,
  key1000941: `仅限输入数字及小数点`,
  key1000942: `价格库存`,
  key1000943: `服务与承诺`,
  key1000944: `商品服务：`,
  key1000945: `发货时效：`,
  key1000946: `商品销售建议`,
  key1000947: `查看示例`,
  key1000948: `、主属性图片不能为空`,
  key1000949: `供货价格`,
  key1000950: `设置此商品在`,
  key1000951: `累计销售达到一定数量后进行优惠的规则，此优惠将直接给到分销商，但分销商无法直接查看设置的优惠规则，仅在分销商达到某一分层的数量后才能查看下一分层优惠，请放心设置。`,
  key1000952: `提交审批`,
  key1000953: `普通商品`,
  key1000954: `选择商品类目`,
  key1000955: `修改类目`,
  key1000956: `准确选择类目有利于商品曝光，促进转化。`,
  key1000957: `为了方便管理，可以自定义商品编码，比如：货号，发布成功后生效。`,
  key1000958: `选择工厂主料`,
  key1000959: `重新选择`,
  key1000960: `首图`,
  key1000961: `上传网络图片`,
  key1000962: `首图优先带背景模特拼图，没有拼图时选择模特正面图，带背景模特图按一定顺序排列。`,
  key1000963: `查看规范`,
  key1000964: `图片要求`,
  key1000965: `建议上传800*800像素以上正方形实拍大图，比如：800*800px，1000*1000px，1500*1500px，最大不超过5MB，若不符合该尺寸则会导致上传失败。`,
  key1000966: `推荐JPG、JPEG格式图片，但平台支持PNG、WEBP、BMP格式图片上传（受限平台限制会将非JPG、JPEG格式都转化为JPEG格式，但会导致图片会有略微失真）`,
  key1000967: `自动生成`,
  key1000968: `Listing商品属性信息：`,
  key1000969: `展开填写更多属性`,
  key1000970: `以下属性需填写属性值比例：`,
  key1000971: `请先选择商品类目`,
  key1000972: `请准确填写属性，更多的商品属性将有利于提高下单转化率。`,
  key1000973: `仅支持第一组规格设置图片，套装首图要选择套装图，每个规格最多上传5张图片，建议尺寸：800*800px。`,
  key1000974: `已上架的定制商品，商品规格不支持调整，如需调整，去停售此商品，新建商品调整规格`,
  key1000975: `多规格排序`,
  key1000976: `规格明细`,
  key1000977: `自定义列`,
  key1000978: `尺码表`,
  key1000979: `请先添加商品规格`,
  key1000980: `固定金额`,
  key1000981: `折扣`,
  key1000982: `添加分层`,
  key1000983: `提交审核后暂不上架`,
  key1000984: `暂存`,
  key1000985: `编辑`,
  key1000986: `审核通过`,
  key1000987: `驳回`,
  key1000988: `发送验证码`,
  key1000989: `图形验证码不能为空`,
  key1000990: `验证码不能为空`,
  key1000991: `账户币种不能为空`,
  key1000992: `为保障账号安全与正常使用，请绑定手机号码。`,
  key1000993: `为保障账号安全与正常使用，请选择币种信息。`,
  key1000994: `为保障账号安全与正常使用，请绑定手机号码并选择币种信息。`,
  key1000995: `重新发送`,
  key1000996: `手机验证码已发送！`,
  key1000997: `确认新密码不能为空`,
  key1000998: `密码与确认密码不一致`,
  key1000999: `绑定成功`,
  key1001000: `请先勾选已阅读并接受`,
  key1001001: `请输入手机号码`,
  key1001002: `请输入图形验证码`,
  key1001003: `验证码图片`,
  key1001004: `请输入验证码`,
  key1001005: `请输入密码`,
  key1001006: `请再次确认密码`,
  key1001007: `邮箱（选填）`,
  key1001008: `点击选择账户币种`,
  key1001009: `完善账号信息`,
  key1001010: `不在重量区间之内`,
  key1001011: `起始重量`,
  key1001012: `截止重量`,
  key1001013: `原价格`,
  key1001014: `上浮后实收价格`,
  key1001015: `首重（`,
  key1001016: `原首重运费`,
  key1001017: `首重运费`,
  key1001018: `上浮后实收首重运费`,
  key1001019: `续重单位重量（`,
  key1001020: `原续重单价`,
  key1001021: `续重单价`,
  key1001022: `上浮后实收续重单价`,
  key1001023: `挂号费`,
  key1001024: `操作费`,
  key1001025: `原操作费`,
  key1001026: `上浮后实收操作费`,
  key1001027: `附加费（%）`,
  key1001028: `截止重量要大于起始重量`,
  key1001029: `上一区间截止重量必须等于下一区间起始重量`,
  key1001030: `请选择国家`,
  key1001031: `价格不能为空`,
  key1001032: `首重不能为空`,
  key1001033: `首重运费不能为空`,
  key1001034: `续重单位重量不能为空`,
  key1001035: `续重单价不能为空`,
  key1001036: `材积重不能为空`,
  key1001037: `计费模型编辑`,
  key1001038: `在当前计费模型的基础上进行加价；百分比上浮，将在“价格、首重运费、续重单价”的基础上上浮；固定加价，将在“操作费”的基础上增加`,
  key1001039: `在分销商计费模型的基础上，额外收取的金额，后续根据实际物流费进行多退少补`,
  key1001040: `支持中文、英文、二字码搜索`,
  key1001041: `材积(kg)：`,
  key1001042: `材积重：`,
  key1001043: `=长(cm) × 宽(cm) × 高(cm) / `,
  key1001044: `（材积(kg) = 长(cm) × 宽(cm) × 高(cm) ÷`,
  key1001045: `验证运费是否正确：重量(`,
  key1001046: `实收物流配置`,
  key1001047: `上浮`,
  key1001048: `加价`,
  key1001049: `预收物流费配置`,
  key1001050: `已选中国家：`,
  key1001051: `清空`,
  key1001052: `设置邮编`,
  key1001053: `查看邮编`,
  key1001054: `新增重量区间`,
  key1001055: `验证运费`,
  key1001056: `测试运费：`,
  key1001057: `实收运费：`,
  key1001058: `预收运费：`,
  key1001059: `预扣运费：`,
  key1001060: `定制商品已开始加工，取消订单，定制商品费用不退回；`,
  key1001061: `定制商品未开始加工，取消订单，订单费用全部退回；`,
  key1001062: `”已开始加工，取消订单，定制商品费用不退回；`,
  key1001063: `”未开始加工，取消订单，订单费用全部退回；`,
  key1001064: `允许取消`,
  key1001065: `订单取消`,
  key1001066: `取消原因不能为空！`,
  key1001067: `取消成功!`,
  key1001068: `请输入取消原因`,
  key1001069: `请输入手续费`,
  key1001070: `物流单作废费用：`,
  key1001071: `取消原因：`,
  key1001072: `订单中存在定制商品“`,
  key1001073: `”，需要向供应商确认此商品的加工状态后操作订单取消。`,
  key1001074: `商品加工状态：`,
  key1001075: `已经开始加工`,
  key1001076: `未开始加工`,
  key1001077: `订单已成功下发物流且获取到运单号，当前已超过获取运单号时间`,
  key1001078: `需要收取“`,
  key1001079: `”。（实际扣费以分销商操作取消时对应时间为准）`,
  key1001080: `取消手续费：`,
  key1001081: `订单中定制商品“`,
  key1001082: `定制商品费用：`,
  key1001083: `总计退费：`,
  key1001084: `创建后若后续平台订单中存在此商品都无需手动匹配`,
  key1001085: `商品，可直接通过此关联关系进行此`,
  key1001086: `商品匹配。`,
  key1001087: `提示：已创建的关联关系可通过路径“商品管理-收藏的商品-操作项[设置关联关系]”进行查看/编辑;`,
  key1001088: `（未收藏的商品也可创建关联关系，可在收藏后对其进行查看/编辑）`,
  key1001089: `SPU,支持多个按行分隔`,
  key1001090: `SKU,支持多个按行分隔`,
  key1001091: `中心仓库存`,
  key1001092: `添加商品`,
  key1001093: `供应商SPU`,
  key1001094: `请输入供应商SPU,支持多个按行分隔`,
  key1001095: `请输入SPU,支持多个逗号和按行分隔`,
  key1001096: `请输入SKU,支持多个逗号和按行分隔`,
  key1001097: `请输入商品名称,支持多个逗号和按行分隔`,
  key1001098: `供应商商户号`,
  key1001099: `商品标题`,
  key1001100: `请输入商品标题`,
  key1001101: `供应商名称`,
  key1001102: `供应商库存`,
  key1001103: `商品SKU：`,
  key1001104: `可用库存`,
  key1001105: `近30天销量`,
  key1001106: `选择`,
  key1001107: `我的库存`,
  key1001108: `在途库存：`,
  key1001109: `可用库存：`,
  key1001110: `单价`,
  key1001111: `长宽高(cm)`,
  key1001112: `在售`,
  key1001113: `试卖`,
  key1001114: `清仓`,
  key1001115: `商品数量不能为空!`,
  key1001116: `请先选择商品！`,
  key1001117: `该商品现已存在关联关系！`,
  key1001118: `订阅状态：`,
  key1001119: `选择确认`,
  key1001120: `条`,
  key1001121: `是否确认选择该`,
  key1001122: `商品进行订单商品匹配？`,
  key1001123: `已选择：`,
  key1001124: `设为主料`,
  key1001125: `创建关联关系`,
  key1001126: `系统公告`,
  key1001127: `不再提醒`,
  key1001128: `你没有访问该页面的权限`,
  key1001129: `返回上一页`,
  key1001130: `系统版本升级，旧版链接已失效。请点击侧边栏菜单或下方按钮，即可正常使用全部功能。`,
  key1001131: `返回系统首页`,
  key1001132: `返回有权限菜单`,
  key1001133: `未匹配到可访问的菜单！`,
  key1001134: `请先勾选需要展示的自定义列表字段！`,
  key1001135: `不打印`,
  key1001136: `条码`,
  key1001137: `自定义内容`,
  key1001138: `产品库位`,
  key1001139: `产品库位预览占位`,
  key1001140: `产品绑定库区`,
  key1001141: `产品绑定库区预览占位`,
  key1001142: `参考编号`,
  key1001143: `参考编号预览占位`,
  key1001144: `介质材料`,
  key1001145: `标签大小`,
  key1001146: `起止信息`,
  key1001147: `最大支持100mm`,
  key1001148: `字体`,
  key1001149: `每pt约占0.35mm宽`,
  key1001150: `*注:打印内容可拖动改变位置`,
  key1001151: `通过拖拽调整规格排序`,
  key1001152: `新增收货地址`,
  key1001153: `省/州不能为空`,
  key1001154: `城市不能为空`,
  key1001155: `区县不能为空`,
  key1001156: `详细地址不能为空`,
  key1001157: `收货人姓名不能为空`,
  key1001158: `手机号不能为空`,
  key1001159: `添加成功！`,
  key1001160: `更新成功！`,
  key1001161: `当前配送至：`,
  key1001162: `省/州：`,
  key1001163: `请输入省/州`,
  key1001164: `城市：`,
  key1001165: `请输入城市`,
  key1001166: `区县：`,
  key1001167: `请输入区县`,
  key1001168: `详细地址：`,
  key1001169: `请输入详细地址信息，如：道路、门牌号、小区、楼栋号、单元等信息`,
  key1001170: `邮政编码：`,
  key1001171: `请输入邮政编码`,
  key1001172: `收货人姓名：`,
  key1001173: `长度不超过25个字符`,
  key1001174: `手机号码：`,
  key1001175: `固定电话：`,
  key1001176: `请输入固定电话号码`,
  key1001177: `邮箱地址：`,
  key1001178: `请输入邮箱地址`,
  key1001179: `设置为默认收货地址`,
  key1001180: `创建时间：`,
  key1001181: `打印箱唛`,
  key1001182: `选择商品`,
  key1001183: `配置定制信息`,
  key1001184: `是否需要定制`,
  key1001185: `无需配置定制内容`,
  key1001186: `勾选的信息中存在不需要定制的商品，请重新选择`,
  key1001187: `保存中...`,
  key1001188: `定制商品专为您制作，制作启动后将无法退款/取消订单。请您确认需求无误后提交订单，感谢您的理解。`,
  key1001189: `商品是否需要定制：`,
  key1001190: `是，我需要配置定制内容`,
  key1001191: `否，直接购买基础商品即可`,
  key1001192: `平台定制数据选择`,
  key1001193: `供货价详情`,
  key1001194: `仓库直发价详情`,
  key1001195: `切换类目确认`,
  key1001196: `切换类目后，商品属性及规格等信息需要重新填写。请确认是否切换分类?`,
  key1001197: `请选择分类`,
  key1001198: `分类检索`,
  key1001199: `最近使用：`,
  key1001200: `已选类目：`,
  key1001201: `绑定手机成功`,
  key1001202: `暂不绑定`,
  key1001203: `备货商品异常`,
  key1001204: `以下商品为定制商品，暂不支持备货，请修改订单商品重新提交。`,
  key1001205: `编辑成功！`,
  key1001206: `编辑模板`,
  key1001207: `模板名称：`,
  key1001208: `发货仓不能为空`,
  key1001209: `单件处理费不能为空`,
  key1001210: `续件处理费不能为空`,
  key1001211: `费用币种不能为空`,
  key1001212: `重量单位不能为空`,
  key1001213: `订单处理费`,
  key1001214: `首重收费`,
  key1001215: `费用`,
  key1001216: `<span class="font-weight-bold">处理费 = 重量 * 单价</span>`,
  key1001217: `<span class="color-666">重量小于等于首重：</span>`,
  key1001218: `<span class="font-weight-bold">处理费 = 首重收费</span>`,
  key1001219: `<span class="color-666 mt3 ml24">重量大于首重：</span>`,
  key1001220: `<span class="font-weight-bold mt3">处理费 = 首重收费 + 向上取整(总重量-首重) / 续重单位重量 * 续重单价</span>`,
  key1001221: `<span class="font-weight-bold">处理费 = 费用</span>`,
  key1001222: `单价不能为空`,
  key1001223: `首重收费不能为空`,
  key1001224: `费用不能为空`,
  key1001225: `费用配置`,
  key1001226: `费用类型：`,
  key1001227: `发货仓：`,
  key1001228: `仅直发仓支持订单处理费配置`,
  key1001229: `收费模式：`,
  key1001230: `单件处理费：`,
  key1001231: `续件处理费：`,
  key1001232: `费用币种：`,
  key1001233: `重量单位：`,
  key1001234: `仓库处理费 = `,
  key1001235: `（件数-1）`,
  key1001236: `验证处理费是否正确：重量(`,
  key1001237: `按订单商品件数收费`,
  key1001238: `按订单商品重量收费`,
  key1001239: `验证处理费`,
  key1001240: `邮编前`,
  key1001241: `位：`,
  key1001242: `邮编：`,
  key1001243: `邮编不能为空`,
  key1001244: `邮编格式只能是数字或者字母`,
  key1001245: `支持批量输入，请换行分隔`,
  key1001246: `截取邮编前`,
  key1001247: `位`,
  key1001248: `出库单号`,
  key1001249: `订单取消提示`,
  key1001250: `本次作业中存在已取消的订单，订单所含出库单详情信息如下。`,
  key1001251: `继续分拣`,
  key1001252: `移除已取消的出库单`,
  key1001253: `若商品在已关联了“`,
  key1001254: `负责人”，本次操作将会把此前已关联的内容覆盖。`,
  key1001255: `若商品在“`,
  key1001256: `”已关联了制造商信息，本次操作将会把此前已关联的内容覆盖。`,
  key1001257: `欧盟`,
  key1001258: `土耳其`,
  key1001259: `欧盟/土耳其`,
  key1001260: `欧盟负责人：`,
  key1001261: `土耳其负责人：`,
  key1001262: `批量关联合规负责人`,
  key1001263: `批量关联制造商`,
  key1001264: `请选择关联的负责人！`,
  key1001265: `请选择关联的制造商！`,
  key1001266: `负责区域：`,
  key1001267: `请选择您需要关联的负责人信息；`,
  key1001268: `请选择您需要关联的制造商信息；`,
  key1001269: `制造商信息：`,
  key1001270: `点击“相同”，系统将针对列表所有SKU进行批量填充。`,
  key1001271: `点击“相同”，系统将根据您选择的商品规格，仅针对于规格相同的SKU进行批量填充。`,
  key1001272: `批量填充配置`,
  key1001273: `填充模式：`,
  key1001274: `SKU统一配置`,
  key1001275: `按SKU规格配置`,
  key1001276: `规格选择：`,
  key1001277: `常规订单面单长度和宽度不能为空！`,
  key1001278: `速卖通全托管货品标签长度和宽度不能为空！`,
  key1001279: `速卖通全托管物流面单长度和宽度不能为空！`,
  key1001280: `打印配置`,
  key1001281: `常规订单面单`,
  key1001282: `长：`,
  key1001283: `宽：`,
  key1001284: `速卖通全托管货品标签`,
  key1001285: `速卖通全托管物流面单`,
  key1001286: `已复制！`,
  key1001287: `商品驳回通知`,
  key1001288: `以下商品审核被驳回，请修改后重新提交审核:`,
  key1001289: `下次提醒`,
  key1001290: `此类目暂未维护平台映射，如有需要请咨询客服。`,
  key1001291: `暂无可支持刊登的平台！`,
  key1001292: `未绑定店铺`,
  key1001293: `你的账号暂时未绑定店铺，或绑定的店铺已过期。`,
  key1001294: `选择要刊登的平台`,
  key1001295: `请填写图片地址`,
  key1001296: `链接地址格式不正确`,
  key1001297: `获取上传图片失败！`,
  key1001298: `从地址添加图片`,
  key1001299: `图片地址：`,
  key1001300: `设置定制内容`,
  key1001301: `定制服务零附加费，仅按基础商品价格结算，有效降低消费门槛，提升转化。`,
  key1001302: `所有定制部位采用标准化计价（A元/部位），按所选部位数量叠加计费，实现高效透明管理。`,
  key1001303: `支持为各定制部位独立定价，费用按买家所选项目精准累加，满足差异化定价与价值分层需求。`,
  key1001304: `统一定制部位费用(`,
  key1001305: `定制费用(`,
  key1001306: `查看定制内容`,
  key1001307: `请完善所有必填字段`,
  key1001308: `费用金额必须要大于0`,
  key1001309: `请输入费用金额`,
  key1001310: `定制部位：`,
  key1001311: `定制说明：`,
  key1001312: `可输入定制说明，例如：此部位位于T恤的正前方靠左20cm左右处...`,
  key1001313: `部位示意图：`,
  key1001314: `可定制区域(长、宽cm)：`,
  key1001315: `定制工艺：`,
  key1001316: `定制收费`,
  key1001317: `统一定制部位费用不能为空且要大于0`,
  key1001318: `已上架的定制商品，不可修改其定制信息（收费模式除外），如需修改，请停售此商品，创建新定制商品重新编辑。`,
  key1001319: `添加定制部位`,
  key1001320: `请选择上传部位示意图`,
  key1001321: `可定制区域(长、宽cm)不能为空且要大于0`,
  key1001322: `请选择定制工艺`,
  key1001323: `定制费用不能为空`,
  key1001324: `代号`,
  key1001325: `账户名`,
  key1001326: `有效`,
  key1001327: `无效`,
  key1001328: `更新店铺`,
  key1001329: `添加店铺`,
  key1001330: `已授权列表`,
  key1001331: `可输入代号、账户名进行搜索`,
  key1001332: `请指定`,
  key1001333: `未选择规则`,
  key1001334: `规则名称不能为空`,
  key1001335: `申报规则`,
  key1001336: `物流规则`,
  key1001337: `仓库规则`,
  key1001338: `公共规则`,
  key1001339: `特殊规则`,
  key1001340: `新增`,
  key1001341: `关键字`,
  key1001342: `发货仓`,
  key1001343: `可输入多个，中间用逗号或换行隔开`,
  key1001344: `可输入多个，中间用英文逗号隔开`,
  key1001345: `请输入关键字...`,
  key1001346: `多邮编换行请求半角输入逗号隔开`,
  key1001347: `请选择平台`,
  key1001348: `请输入运输类型名称搜索`,
  key1001349: `新增运输类型`,
  key1001350: `您确定要删除吗？`,
  key1001351: `美元(USD)`,
  key1001352: `或欧元(EUR)`,
  key1001353: `或英镑(GBP)`,
  key1001354: `或澳元(AUD)`,
  key1001355: `或人民币(CNY)`,
  key1001356: `请输入SKU，多个SKU用逗号或换行隔开`,
  key1001357: `请选择或输入所在地`,
  key1001358: `请选择店铺，可输入搜索`,
  key1001359: `请选择物流`,
  key1001360: `请输入SPU，多个SPU用逗号或换行隔开`,
  key1001361: `请输入供应商商户号，多个商户号用逗号或换行隔开`,
  key1001362: `请输入分销商商户号，多个商户号用逗号或换行隔开`,
  key1001363: `十日达订单即X日达订单，如5日达、10日达`,
  key1001364: `指定范围`,
  key1001365: `指定类型`,
  key1001366: `开头`,
  key1001367: `结尾`,
  key1001368: `指定规律`,
  key1001369: `指定SKU`,
  key1001370: `指定仓库`,
  key1001371: `或`,
  key1001372: `指定平台`,
  key1001373: `指定发货地`,
  key1001374: `指定发货仓`,
  key1001375: `指定SPU`,
  key1001376: `指定供应商`,
  key1001377: `指定分销商`,
  key1001378: `指定分销商等级`,
  key1001379: `已选条件`,
  key1001380: `订单包含货品:`,
  key1001381: `体积重计重因子`,
  key1001382: `包裹货品总数量满足以下选中的条件：`,
  key1001383: `订单重量满足以下全部条件：`,
  key1001384: `订单货品长度满足以下全部条件：`,
  key1001385: `订单货品宽度满足以下全部条件：`,
  key1001386: `订单货品高度满足以下全部条件：`,
  key1001387: `订单货品体积满足以下全部条件`,
  key1001388: `订单货品总数量满足以下选中的条件：`,
  key1001389: `订单收货邮编字符长度满足以下选中的条件:`,
  key1001390: `订单包含货品：`,
  key1001391: `并且上述货品的数量总和满足以下选中的所有条件：`,
  key1001392: `与体积重取重对比取重的作为订单重量计算`,
  key1001393: `提示：订单中每件货品在商品管理中记录的最长边为a1、中间值为b1、最短边为c，所有`,
  key1001394: `a1中的最大值为a，所有b1中的最大值为b，订单中所有货品的短边c相加为d，则a、b、`,
  key1001395: `d中的最大值为订单货品长度，中间值为订单货品宽度，最小值为订单货品高度。体积`,
  key1001396: `重(g)=(a*b*d)/计重因子*1000。`,
  key1001397: `提示：订单中每件货品在商品管理中记录的最长边为a1、中间值为b1、最短边为c，`,
  key1001398: `所有a1中的最大值为a，所有b1中的最大值为b，订单中所有货品的短边c相加为d，`,
  key1001399: `则a、b、d中的最大值为订单货品长度，中间值为订单货品宽度，最小值为订单货品高度。`,
  key1001400: `则a、b、d中的最大值为订单货品长度，中间值为订单货品宽度，最小值为订单货品`,
  key1001401: `高度，a*b*d即订单货品体积。`,
  key1001402: `订单包含多个交易（且运输类型完全相同`,
  key1001403: `订单仅包含一个交易`,
  key1001404: `订单包含多个交易（且运输类型不完全相同`,
  key1001405: `指定条件`,
  key1001406: `订单收件人电话符合以下选中的条件：`,
  key1001407: `移动电话可读字符长度≤`,
  key1001408: `固定电话可读字符长度≤`,
  key1001409: `移动电话前缀`,
  key1001410: `指定字符串`,
  key1001411: `指定要在地址(仅街道1+街道2，不含国家/地区省市信息)中查找的字符：`,
  key1001412: `请输入订单在电商平台后台发货仓名称：`,
  key1001413: `指定长度`,
  key1001414: `订单地址信息字符长度小于：`,
  key1001415: `*此处地址信息由街道1与街道2合并组成，不包含国家/地区、省州、城市信息。`,
  key1001416: `,并且`,
  key1001417: `,或者`,
  key1001418: `包含`,
  key1001419: `指定格式`,
  key1001420: `订单邮编至少符合以下选中的条件中的任意一个条件(输入内容仅限数字、英文字母、中划线和空隔)：`,
  key1001421: `指定异常`,
  key1001422: `且邮编在`,
  key1001423: `邮编段`,
  key1001424: `邮编列表`,
  key1001425: `已选择`,
  key1001426: `注：其他币种转化成美元,所有选项都必须填写`,
  key1001427: `买家支付的运费转换为币种：`,
  key1001428: `之后满足以下全部条件：`,
  key1001429: `指定的商品状态`,
  key1001430: `并且为`,
  key1001431: `指定货品`,
  key1001432: `指定邮寄方式`,
  key1001433: `包裹总金额包含多订单合并到一包裹中的所有订单的金额，不同币种的订单的金额将被统一按汇率转换为如下设置中的币种。`,
  key1001434: `包裹总金额转换为币种：`,
  key1001435: `指定要在买家ID中查找的字符：`,
  key1001436: `注释：若添加多个条件，则按照添加顺序，依照“且”的关系设定规则执行条件。`,
  key1001437: `规则名称：`,
  key1001438: `可选条件`,
  key1001439: `更多平台`,
  key1001440: `请选择标签`,
  key1001441: `批量配置标签`,
  key1001442: `标签：`,
  key1001443: `添加标签`,
  key1001444: `删除标签`,
  key1001445: `导入中`,
  key1001446: `导入完成`,
  key1001447: `导入失败`,
  key1001448: `导入类型`,
  key1001449: `导入文件`,
  key1001450: `导入时间`,
  key1001451: `导入状态`,
  key1001452: `成功/失败`,
  key1001453: `导入类型：`,
  key1001454: `请输入任务编号`,
  key1001455: `导入时间：`,
  key1001456: `位置`,
  key1001457: `部位示意图`,
  key1001458: `可印区域（长、宽cm）`,
  key1001459: `印刷尺寸（长、宽cm）`,
  key1001460: `素材`,
  key1001461: `素材编码`,
  key1001462: `供应商用于标识素材的信息`,
  key1001463: `成品效果图`,
  key1001464: `切换部位确认`,
  key1001465: `切换部位后，印刷尺寸、素材等信息需要重新输入、请确认是否切换部位？`,
  key1001466: `文件大小超出限制，最大为20M！`,
  key1001467: `有必填项未填！`,
  key1001468: `位置&素材设置`,
  key1001469: `点击选择部位`,
  key1001470: `点击输入`,
  key1001471: `部位不能为空`,
  key1001472: `请先选择部位`,
  key1001473: `可印区域不能为空`,
  key1001474: `不能超过可印区域长度`,
  key1001475: `不能超过可印区域宽度`,
  key1001476: `请先输入印刷尺寸`,
  key1001477: `上传文件格式有误，限制上传图片格式为JPG、JPEG、PNG`,
  key1001478: `图片大小最大不超过5MB`,
  key1001479: `支付渠道不能为空`,
  key1001480: `运营收款账户不能为空`,
  key1001481: `在线支付`,
  key1001482: `线下支付，上传支付凭证`,
  key1001483: `创建待付款订单`,
  key1001484: `（稍后可于订单列表汇总支付）`,
  key1001485: `请上传支付流水图片`,
  key1001486: `请完善线下支付信息`,
  key1001487: `支付成功`,
  key1001488: `创建成功`,
  key1001489: `订单提交`,
  key1001490: `支付选择：`,
  key1001491: `支付渠道：`,
  key1001492: `运营收款账户：`,
  key1001493: `应付总额：`,
  key1001494: `支付流水图片：`,
  key1001495: `备注：`,
  key1001496: `运营收款账户币种对应金额：`,
  key1001497: `可用下单金额（`,
  key1001498: `可用余额（`,
  key1001499: `剩余授信额度（`,
  key1001500: `= 授信额度( `,
  key1001501: `已用授信额度( `,
  key1001502: `是否确定提交该订单？`,
  key1001503: `查看完整消息`,
  key1001504: `提交后需运营人员审核确认支付信息的有效性，确认后订单才会生效，请准确的输入支付信息。`,
  key1001505: `当前可用下单金额充足，点击“确定”可直接支付，完成下单。`,
  key1001506: `当前`,
  key1001507: `可用下单金额不足`,
  key1001508: `，请充值后再次打开窗口完成支付。`,
  key1001509: `点击充值`,
  key1001510: `（若已充值请重新打开此窗口，刷新数据）`,
  key1001511: `待查询`,
  key1001512: `查询中`,
  key1001513: `未查到`,
  key1001514: `运输中`,
  key1001515: `等待领取`,
  key1001516: `已签收`,
  key1001517: `投递失败`,
  key1001518: `运输过久`,
  key1001519: `可能异常`,
  key1001520: `跟踪信息`,
  key1001521: `运单号：`,
  key1001522: `状态：`,
  key1001523: `下载成功`,
  key1001524: `获取下载地址失败!`,
  key1001525: `查看定制信息`,
  key1001526: `若订单中定制商品在此处无定制信息，则直接使用基础商品发货即可`,
  key1001527: `一键下载全部图片`,
  key1001528: `素材图：`,
  key1001529: `成品预览图：`,
  key1001530: `申请成为分销商`,
  key1001531: `寻找商品`,
  key1001532: `收藏商品`,
  key1001533: `商品刊登&下载资料包`,
  key1001534: `下单发货`,
  key1001535: `订单管理`,
  key1001536: `财务管理`,
  key1001537: `去注册`,
  key1001538: `点击商城首页右上角“成为分销商”，使用手机号注册或使用通途账号授权登录。`,
  key1001539: `去浏览`,
  key1001540: `搜索关键字，找到想要分销的商品。`,
  key1001541: `在分类导航，找到想要分销的商品。`,
  key1001542: `在首页和核心页面，找到想要分销的商品。`,
  key1001543: `去收藏`,
  key1001544: `在商品列表页，找到商品后，点击“收藏”按钮收藏商品，以便刊登时使用。`,
  key1001545: `在商品详情页，点击“立即收藏”按钮收藏商品，以便刊登时使用。`,
  key1001546: `4.商品刊登&下载资料包`,
  key1001547: `商品刊登`,
  key1001548: `使用通途Listing，将商品一键刊登到ebay、Aliexpress、Wish、Amazon等海外电商平台。`,
  key1001549: `下载资料包`,
  key1001550: `您也可以在“商品列表”、“商品详情页”或“商品管理”页面，免费下载资料包，再到第三方销售平台商家后台上架商品。`,
  key1001551: `基础设置`,
  key1001552: `启用物流`,
  key1001553: `在通途ERP2.0，启用第三方物流，通途系统已内置了行业内用户使用数较多，口碑较好的一些物流商，您可以根据需要选择并启用。`,
  key1001554: `启用邮寄方式`,
  key1001555: `选择希望启用哪种邮寄方式，启用后会提示“邮寄方式启用成功”。`,
  key1001556: `仓库设置`,
  key1001557: `在第三方仓库中选择“云卖供应链“启用。`,
  key1001558: `绑定物流渠道`,
  key1001559: `选择“云卖供应链“仓库，在右侧点击”绑定物流渠道“，选择物流方式后，点“确认”按钮。`,
  key1001560: `生成通途SKU`,
  key1001561: `在通途ERP2.0的“商品管理-云卖分销商品”模块，点击已收藏的商品，在商品详情中，点击“生成商品资料”。`,
  key1001562: `在通途ERP2.0中，选择“发货管理-托管仓库-等待配货”模块，仓库选择“云卖供应链”，点击“云卖下单”，余额不足时，可联系客服充值。`,
  key1001563: `去查看`,
  key1001564: `在“订单管理-我的订单“模块，进行订单查询，进入“订单详情页”可以查看发货情况。`,
  key1001565: `在“财务管理”模块，可以查询充值记录和查看费用明细。`,
  key1001566: `标记发货成功，提单号：`,
  key1001567: `请选择物流方案`,
  key1001568: `请选择发货地址`,
  key1001569: `请选择物流商`,
  key1001570: `物流单号不能为空`,
  key1001571: `物流信息`,
  key1001572: `标记发货`,
  key1001573: `修改物流信息`,
  key1001574: `中国`,
  key1001575: `发货方式：`,
  key1001576: `运输方式：`,
  key1001577: `物流方案：`,
  key1001578: `发货地址：`,
  key1001579: `物流商：`,
  key1001580: `物流单号：`,
  key1001581: `物流`,
  key1001582: `上门揽收`,
  key1001583: `请务必提前与`,
  key1001584: `进行线下确认，是否可进行上门揽收！！`,
  key1001585: `发货时货品需贴`,
  key1001586: `商品条码，大包外需粘贴箱唛在显眼处！`,
  key1001587: `自有物流`,
  key1001588: `快递`,
  key1001589: `请在`,
  key1001590: `账户管理-基本信息`,
  key1001591: `中维护发货地址信息`,
  key1001592: `结束装箱`,
  key1001593: `初始化WebSocket出错:`,
  key1001594: `商品基础属性【`,
  key1001595: `商品规格属性【`,
  key1001596: `-包装尺寸（长*宽*高`,
  key1001597: `-重量`,
  key1001598: `-库存`,
  key1001599: `-尺码-`,
  key1001600: `阶梯价格类型`,
  key1001601: `分层价格`,
  key1001602: `字段`,
  key1001603: `商品是否支持定制`,
  key1001604: `商品类目`,
  key1001605: `商品货号/SPU`,
  key1001606: `商品发货仓`,
  key1001607: `商品原产地`,
  key1001608: `商品轮播图`,
  key1001609: `图片类型`,
  key1001610: `商品中文标题`,
  key1001611: `商品英文标题`,
  key1001612: `商品服务`,
  key1001613: `发货时效`,
  key1001614: `商品移除规格`,
  key1001615: `商品新增规格`,
  key1001616: `商品基础属性`,
  key1001617: `商品规格属性`,
  key1001618: `分钟前`,
  key1001619: `小时前`,
  key1001620: `天前`,
  key1001621: `周前`,
  key1001622: `个月前`,
  key1001623: `年前`,
  key1001624: `周日`,
  key1001625: `周一`,
  key1001626: `周二`,
  key1001627: `周三`,
  key1001628: `周四`,
  key1001629: `周五`,
  key1001630: `周六`,
  key1001631: `天`,
  key1001632: `小时`,
  key1001633: `分钟`,
  key1001634: `1分钟`,
  key1001635: `刚刚`,
  key1001636: `订单线下支付功能已停用，如需启用请联系通途商务。`,
  key1001637: `平台自营商品模式已关闭，如需启用请联系通途商务。`,
  key1001638: `供应商第三方平台授权功能已停用，如需使用请联系平台运营。`,
  key1001639: `线下支付功能已停用，如需使用请联系平台运营。`,
  key1001640: `订单合规标签校验功能已停用，如需启用请联系平台运营。`,
  key1001641: `当前功能已关闭`,
  key1001642: `供应商操作`,
  key1001643: `运营操作`,
  key1001644: `该功能需使用通途打印控件，请下载安装`,
  key1001645: `点击下载`,
  key1001646: `若已安装，请开启通途打印控件，若已开启，请关闭控件重启后再试。`,
  key1001647: `新品`,
  key1001648: `当前浏览器 Not support websocket`,
  key1001649: `连接菜鸟打印控件失败,请确认是否安装或启用菜鸟打印控件`,
  key1001650: `页面初始化失败，请刷新后重试`,
  key1001651: `刷新页面`,
  key1001652: `账户余额不足`,
  key1001653: `你的账户余额不足，请充值足够的金额后，再提交订单！`,
  key1001654: `去充值`,
  key1001655: `你的账户余额不足，请联系运营工作人员进行充值或选择其他支付方式，再进行订单支付!`,
  key1001656: `获取Saas系统配置数据失败===:`,
  key1001657: `大洋洲`,
  key1001658: `欧洲`,
  key1001659: `亚洲`,
  key1001660: `南极`,
  key1001661: `美洲`,
  key1001662: `非洲`,
  key1001663: `(供货仓及直发仓)`,
  key1001664: `(供货仓)`,
  key1001665: `(直发仓)`,
  key1001666: `供应商物流`,
  key1001667: `您选择的物流方式暂不支持派送至该收货地址/邮编，可能是由于：该物流服务暂未覆盖该地址/邮编；`,
  key1001668: `正在校验余额...`,
  key1001669: `获取云卖物流失败:`,
  key1001670: `获取所有规则项的枚举数据失败:`,
  key1001671: `获取导入模板失败:`,
  key1001672: `测试运费 =（重量 * 单价 + 挂号费 + 操作费） * （1 + 附加费）`,
  key1001673: `实收运费 =（重量 * 上浮后实收价格 + 挂号费 + 上浮后实收操作费）*（1 + 附加费）`,
  key1001674: `预收运费 =（重量 * 上浮后实收价格 *（1 + 预收上浮百分比）+ 挂号费 + 上浮后实收操作费 + 预收物流费加价金额）*（1 + 附加费）`,
  key1001675: `预扣运费 =（重量 * 价格 *（1 + 预扣上浮百分比）+ 挂号费 + 操作费 + 预扣物流费加价金额）*（1 + 附加费）`,
  key1001676: `重量小于等于首重：`,
  key1001677: `测试运费 = (首重运费 + 挂号费 + 操作费) *（1 + 附加费）`,
  key1001678: `重量大于首重：`,
  key1001679: `测试运费 = { 首重运费 + 向上取整(总重量 - 首重) / 续重单位重量 * 续重单价 + 挂号费 + 操作费 } *（1 + 附加费）`,
  key1001680: `实收运费 = (上浮后实收首重运费 + 挂号费 + 上浮后实收操作费) *（1 + 附加费）`,
  key1001681: `预收运费 = (上浮后实收首重运费 *（1 + 预收物流费上浮百分比）+ 挂号费 + 上浮后实收操作费 + 预付物流费加价金额) *（1 + 附加费）`,
  key1001682: `实收运费 = { 上浮后实收首重运费 + 向上取整(总重量 - 首重) / 续重单位重量 * 上浮后实收续重单价 + 挂号费 + 上浮后实收操作费 } *（1+附加费）`,
  key1001683: `预收运费 = { 上浮后实收首重运费 * (1 + 预收物流费上浮百分比) + 向上取整(总重量 - 首重) / 续重单位重量 * 上浮后实收续重单价 * (1 + 预收物流费上浮百分比) + 挂号费 + 上浮后实收操作费 + 预付物流费加价金额 } *（1 + 附加费）`,
  key1001684: `预扣运费 = (首重运费 *（1 + 预扣物流费上浮百分比）+ 挂号费 + 操作费 + 预扣物流费加价金额) *（1 + 附加费）`,
  key1001685: `预扣运费 = { 首重运费 *（1 + 预扣物流费上浮百分比）+ 向上取整(总重量 - 首重) / 续重单位重量 * 续重单价 *（1 + 预扣物流费上浮百分比）+ 挂号费 + 操作费 + 预扣物流费加价金额 } *（1 + 附加费）`,
  key1001686: `测试运费 = (单价 + 挂号费 + 操作费) * (1 + 附加费)`,
  key1001687: `实收运费 = (上浮后实收价格 + 挂号费 + 上浮后实收操作费) *（1 + 附加费）`,
  key1001688: `预收运费 = 上浮后实收价格 * (1 + 预收上浮百分比) + 挂号费 + 上浮后实收操作费 + 预收物流费加价金额 *（1 + 附加费）`,
  key1001689: `预扣运费 =（价格 *（1 + 预扣上浮百分比）+ 挂号费 + 操作费 + 预扣物流费加价金额）*（1 + 附加费）`,
  key1001690: `请求超时`,
  key1001691: `服务器错误`,
  key1001692: `账户已被停用，若需重新启用账户，请联系`,
  key1001693: `运营人员。`,
  key1001694: `商品“`,
  key1001695: `”库存不足，请修改数量后，重新提交。`,
  key1001696: `您已有`,
  key1001697: `账号，可直接使用此`,
  key1001698: `账号作为供应商进行入驻。`,
  key1001699: `账号开通分销商账户。`,
  key1001700: `没有权限访问该系统`,
  key1001701: `亲爱的通途用户，您没有权限访问该系统!`,
  key1001702: `请联系，系统管理员！`,
  key1001703: `账单待确认提示`,
  key1001704: `存在未确认账单，请及时确认，若账单生成后14天内未确认账单系统将默认账单无误，自动确认账单。`,
  key1001705: `查看账单`,
  key1001706: `稍后确认`,
  key1001707: `账户停用提示`,
  key1001708: `库存不足提示`,
  key1001709: `成为供应商确认`,
  key1001710: `前往入驻`,
  key1001711: `成为分销商确认`,
  key1001712: `确认开通`,
  key1001713: `您已有通途账号，可直接使用此账号开通分销商账户。`,
  key1001714: `提单，`,
  key1001715: `，存在货品多发，已转为备货库存存放于`,
  key1001716: `中心仓。`,
  key1001717: `订单自动取消通知`,
  key1001718: `您的订单`,
  key1001719: `，已超时自动取消，请及时关注。`,
  key1001720: `开启后，当平台订单中`,
  key1001721: `SKU仅唯一发货仓时，系统会默认自动匹配此发货仓；`,
  key1001722: `万邑通海外仓`,
  key1001723: `米雲仓`,
  key1001724: `单选可自定值`,
  key1001725: `多选可自定义值`,
  key1001726: `云卖供应链`,
  key1001727: `功能介绍`,
  key1001728: `云卖供应链功能介绍`,
  key1001729: `注册`,
  key1001730: `注册云卖供应链`,
  key1001731: `店铺授权`,
  key1001732: `一键刊登`,
  key1001733: `中文`,
  key1001734: `英文`,
  key1001735: `订单缺货提醒`,
  key1001736: `订单状态标记为缺货时`,
  key1001737: `订单编号`,
  key1001738: `你的订单：<span class="highlight_color">【A】</span>缺货，请及时关注！`,
  key1001739: `备货`,
  key1001740: `订单备货提醒`,
  key1001741: `订单数`,
  key1001742: `你有<span class="highlight_color">【A】</span>笔订单，备货已超时，请及时备货！`,
  key1001743: `拣货`,
  key1001744: `订单拣货提醒`,
  key1001745: `你有<span class="highlight_color">【A】</span>笔订单，拣货已超时，请及时拣货！`,
  key1001746: `换单`,
  key1001747: `订单换单提醒`,
  key1001748: `你有<span class="highlight_color">【A】</span>笔订单，换单已超时，请及时换单！`,
  key1001749: `装箱`,
  key1001750: `订单装箱提醒`,
  key1001751: `你有<span class="highlight_color">【A】</span>笔订单，装箱已超时，请及时装箱！`,
  key1001752: `发货`,
  key1001753: `订单发货提醒`,
  key1001754: `你有<span class="highlight_color">【A】</span>笔订单，发货已超时，请及时发货！`,
  key1001755: `订单取消提醒`,
  key1001756: `订单状态标记为取消时`,
  key1001757: `分销商已取消订单：<span class="highlight_color">【A】</span>，请及时关注发货情况`,
  key1001758: `商品停售通知`,
  key1001759: `供应商标记SPU或SKU停售时`,
  key1001760: `尊敬的分销商您好：您收藏的：<span class="highlight_color">【A】</span>，商品编码：<span class="highlight_color">【B】</span>已停售，如果您已上架该商品，请及时下架。`,
  key1001761: `商品描述或图片被修改时`,
  key1001762: `商品信息修改通知`,
  key1001763: `商品<span class="highlight_color">【A】</span>信息修改通知`,
  key1001764: `尊敬的分销商您好：您收藏的商品 <span class="highlight_color">【A】</span>，描述/图片已修改，如果您已上架该商品，请及时更新成最新的产品信息。`,
  key1001765: `商品价格被修改时`,
  key1001766: `商品调价通知`,
  key1001767: `商品<span class="highlight_color">【A】</span>调价通知`,
  key1001768: `尊敬的分销商您好：由于成本变动，您收藏的商品 <span class="highlight_color">【A】</span>，价格有调整，请及时关注。`,
  key1001769: `关注的供应商上新商品通过审核时`,
  key1001770: `商品上新通知`,
  key1001771: `您关注的供应商有商品上新`,
  key1001772: `您关注的供应商：<span class="highlight_color">【A】</span>有商品上新。`,
  key1001773: `入库分拣结束时，提单内存在多收货品时`,
  key1001774: `货品多发通知`,
  key1001775: `提单号`,
  key1001776: `通过分销商配置的自动规则调整库存或上架工具状态时`,
  key1001777: `商品状态自动同步通知`,
  key1001778: `您订阅的商品<span class="highlight_color">【A】</span>，已停售，已根据规则自动调整相关信息，请及时关注。`,
  key1001779: `通过分销商配置的自动规则调整在线刊登价格时`,
  key1001780: `在线刊登自动调价通知`,
  key1001781: `您订阅的商品<span class="highlight_color">【A】</span>，供货价格有调整，在线刊登价格根据规则自动调整，请及时关注。`,
  key1001782: `通过分销商配置的超时时间自动取消订单时`,
  key1001783: `通过平台订单自动下单由于余额不足导致下单失败时`,
  key1001784: `余额不足下单失败通知`,
  key1001785: `余额不足通知`,
  key1001786: `平台`,
  key1001787: `您的余额不足，<span class="highlight_color">【A】</span>订单<span class="highlight_color">【B】</span>自动下单失败，请及时充值。`,
  key1001788: `商品审核被驳回时`,
  key1001789: `商品审核驳回通知`,
  key1001790: `您的商品：<span class="highlight_color">【A】</span>，审核未通过，驳回原因：XXXXXXXXX。`,
  key1001791: `分销商店铺状态标记为“未授权”时；`,
  key1001792: `店铺授权过期通知`,
  key1001793: `平台名称`,
  key1001794: `店铺名称`,
  key1001795: `您在平台：<span class="highlight_color">【A】</span>中的店铺<span class="highlight_color">【B】</span>授权已过期，请及时更新授权信息；`,
  key1001796: `分销商自有物流商授权状态标记为“未授权”时；`,
  key1001797: `自有物流授权过期通知`,
  key1001798: `您的自有物流商：<span class="highlight_color">【A】</span>，授权已过期，请及时更新授权信息；`,
  key1001799: `已创建`,
  key1001800: `待付款`,
  key1001801: `等待在途库存`,
  key1001802: `待商家拣货`,
  key1001803: `待商家复核`,
  key1001804: `待商家打包`,
  key1001805: `快递运输中`,
  key1001806: `到达中心仓`,
  key1001807: `中心仓已到货`,
  key1001808: `待拣货`,
  key1001809: `待包装`,
  key1001810: `待装箱`,
  key1001811: `待物流商上门取件`,
  key1001812: `已交付物流商`,
  key1001813: `已取消`,
  key1001814: `英文-US名称`,
  key1001815: `英文-UK名称`,
  key1001816: `英文-AU名称`,
  key1001817: `英文-EU名称`,
  key1001818: `立即购买`,
  key1001819: `加入购物车`,
  key1001820: `妙手采集`,
  key1001821: `生成售卖资料`,
  key1001822: `下载资料`,
  key1001823: `商品可售卖国`,
  key1001824: `启用后商品可进行可售卖国配置，在商城可通过此项进行商品筛选；`,
  key1001825: `商品标签展示`,
  key1001826: `启用后商品标签将会呈现在商城，停用则仅在运营端商品列表进行标记展示；`,
  key1001827: `LOGO配置`,
  key1001828: `配置后运营系统涉及LOGO展示处均展示您配置的LOGO；`,
  key1001829: `默认语种`,
  key1001830: `配置后运营系统用户首次登录展示此语种；`,
  key1001831: `平台账单周期配置`,
  key1001832: `配置后平台账单按此周期进行汇总生成；`,
  key1001833: `线下支付`,
  key1001834: `开启线下支付后，分销商可通过线下支付，上传支付凭证的方式完成订单付款；`,
  key1001835: `订单自动取消`,
  key1001836: `开启并设置自动取消倒计时后，分销商创建待付款订单后，订单会立刻进入倒计时，倒计时结束，订单自动取消；`,
  key1001837: `跨境电商平台配置`,
  key1001838: `分销商仅可绑定已配置的电商平台店铺，进行一件刊登、订单拉取等；`,
  key1001839: `在线支付渠道`,
  key1001840: `配置后分销商可启用对应的支付渠道（根据渠道要求上传对应资质）；`,
  key1001841: `配置后分销商城、分销后台涉及LOGO展示处均展示您配置的LOGO；`,
  key1001842: `语种配置`,
  key1001843: `分销商可根据已配置的语种在对应系统进行切换显示；`,
  key1001844: `商品详情页按钮布局配置`,
  key1001845: `可根据当前业务侧重，调整商城商品详情页中各个功能性按钮的布局优先级；`,
  key1001846: `商城游客价格展示配置`,
  key1001847: `可根据实际业务情况，配置商城面向未登录的游客分销商商品价格是否展示/展示内容。`,
  key1001848: `商城注册分销商默认业务类型配置`,
  key1001849: `可根据实际业务情况，配置由商城注册入口注册成为分销商的默认业务类型(零售/批发)。`,
  key1001850: `平台订单发货仓匹配配置`,
  key1001851: `商城右侧悬浮信息展示配置`,
  key1001852: `点击可配置分销商城及分销后台页面右侧悬停展示的“微信咨询”、“电话咨询”信息内容；`,
  key1001853: `第三方平台配置`,
  key1001854: `配置后，供应商可授权已配置的平台进行库存同步、订单拉取等；`,
  key1001855: `配置后供应商系统涉及LOGO展示处均展示您配置的LOGO；`,
  key1001856: `供应商可根据已配置的语种在对应系统进行切换显示；`,
  key1001857: `常规`,
  key1001858: `paramValue 解析失败：`,
  key1001859: `原收件名称`,
  key1001860: `原收件邮箱`,
  key1001861: `原收件电话`,
  key1001862: `原收件用户`,
  key1001863: `原收国家编码`,
  key1001864: `原收件人手机`,
  key1001865: `原收件收货地址1`,
  key1001866: `原收件收货地址2`,
  key1001867: `原收件城市`,
  key1001868: `原收件人州/省`,
  key1001869: `原收件人邮编`,
  key1001870: `原收件人护照编码`,
  key1001871: `订单[`,
  key1001872: `]，修改地址成功:`,
  key1001873: `付款，实付金额：`,
  key1001874: `分销商已付款，实付金额：`,
  key1001875: `调价;货品原价总金额：`,
  key1001876: `;分销商应付金额：`,
  key1001877: `;供应商应收金额：`,
  key1001878: `已到仓`,
  key1001879: `标记为非`,
  key1001880: `订单,清空商品&物流信息`,
  key1001881: `自动匹配订单商品或物流失败`,
  key1001882: `原始单订单取消`,
  key1001883: `未匹配到任何物流`,
  key1001884: `匹配基础物流失败`,
  key1001885: `取消订单成功`,
  key1001886: `自动匹配物流成功：`,
  key1001887: `订单`,
  key1001888: `自动匹配物流成功:`,
  key1001889: `]，匹配物流特殊规则：[`,
  key1001890: `]，匹配适用范围:`,
  key1001891: `匹配方案规则:`,
  key1001892: `手工匹配商品成功：平台SKU：`,
  key1001893: `，匹配`,
  key1001894: `手工匹配商品失败：平台SKU：`,
  key1001895: `，未匹配`,
  key1001896: `自动匹配商品成功：平台SKU：`,
  key1001897: `自动匹配商品失败：平台SKU：`,
  key1001898: `SKU失败，SKU已停售`,
  key1001899: `手动匹配物流成功:`,
  key1001900: `下单失败，分销商余额不足`,
  key1001901: `变更物流信息，原物流方式：`,
  key1001902: `原运单号：`,
  key1001903: `原物流商单号：`,
  key1001904: `标发货失败，原因：`,
  key1001905: `标发货成功，运单号：`,
  key1001906: `取消订单失败，原因：`,
  key1001907: `下单失败`,
  key1001908: `下单成功`,
  key1001909: `自动匹配物流失败，未找到符合条件的物流方式`,
  key1001910: `(未找到符合基本条件的物流`,
  key1001911: `修改地址信息失败`,
  key1001912: `]，修改物流成功:`,
  key1001913: `原物流`,
  key1001914: `改成`,
  key1001915: `]，修改物流信息失败`,
  key1001916: `添加授权`,
  key1001917: `更新授权`,
  key1001918: `授权失效`,
  key1001919: `手动标记平台订单标发货成功`,
  key1001920: `编辑IOSS;IOSS名称：`,
  key1001921: `;IOSS编号：`,
  key1001922: `添加IOSS;IOSS名称：`,
  key1001923: `添加规则;规则名称：`,
  key1001924: `;使用的IOSS：`,
  key1001925: `;适用平台：`,
  key1001926: `;适用店铺：`,
  key1001927: `编辑规则;规则名称：`,
  key1001928: `取消交易，取消金额：`,
  key1001929: `部分取消，取消金额：`,
  key1001930: `创建备货单`,
  key1001931: `确认接单，接受调价`,
  key1001932: `拒绝调价`,
  key1001933: `未到货部分已退款，退款金额`,
  key1001934: `，币种：`,
  key1001935: `子单全部到仓，已完结`,
  key1001936: `下单`,
  key1001937: `货品缺货,补货中：;预计到货时间：`,
  key1001938: `;缺货内容如下;`,
  key1001939: `货品缺货,已停售：;缺货内容如下;`,
  key1001940: `请补充邮编信息后重试`,
  key1001941: `添加属性`,
  key1001942: `启用属性`,
  key1001943: `停用属性`,
  key1001944: `出库成功`,
  key1001945: `下发物流成功`,
  key1001946: `变更物流信息;原物流方式：`,
  key1001947: `;原运单号：`,
  key1001948: `;原物流商单号：`,
  key1001949: `作废订单成功`,
  key1001950: `生成账单`,
  key1001951: `更新仓储账单`,
  key1001952: `生成客户账单`,
  key1001953: `物流分拣完成`,
  key1001954: `新增费率：`,
  key1001955: `编辑费率：`,
  key1001956: `生成一条供应商账单`,
  key1001957: `生成一条分销商账单`,
  key1001958: `换单失败退回到生成拣货单列表`,
  key1001959: `从拣货单【`,
  key1001960: `】移除`,
  key1001961: `已换单`,
  key1001962: `重置分拣`,
  key1001963: `标记已拣货`,
  key1001964: `已生成拣货单，拣货单编号:【`,
  key1001965: `换单失败退回到拣货单列表`,
  key1001966: `提单已揽收`,
  key1001967: `提单已创建`,
  key1001968: `提单已入库`,
  key1001969: `提单已上架`,
  key1001970: `提单已分拣`,
  key1001971: `有多余包裹，请联系供应商`,
  key1001972: `审核不通过的原因：`,
  key1001973: `由审核通过`,
  key1001974: `更改为`,
  key1001975: `审核不通过：`,
  key1001976: `由审核不通过`,
  key1001977: `审核不通过`,
  key1001978: `调整补贴`,
  key1001979: `由`,
  key1001980: `调整为`,
  key1001981: `;调整说明：`,
  key1001982: `运营人工添加供应商`,
  key1001983: `停用供应商`,
  key1001984: `启用供应商`,
  key1001985: `编辑供应商`,
  key1001986: `商城入驻注册供应商`,
  key1001987: `商城入驻完善供应商企业信息`,
  key1001988: `审核驳回，驳回原因：`,
  key1001989: `新增配置`,
  key1001990: `编辑配置`,
  key1001991: `已分配库存`,
  key1001992: `匹配智能物流规则：`,
  key1001993: `创建订单`,
  key1001994: `备货中`,
  key1001995: `出库单号：`,
  key1001996: `自动匹配仓库成功;发货仓库：`,
  key1001997: `已取消订单`,
  key1001998: `取消订单，取消原因：`,
  key1001999: `物流[`,
  key1002000: `]修改为[`,
  key1002001: `;特殊规则：`,
  key1002002: `,适用范围`,
  key1002003: `,运费/时效优先级`,
  key1002004: `上传包裹前获取包裹状态异常`,
  key1002005: `申请运单号失败`,
  key1002006: `获取运单号失败`,
  key1002007: `获取速卖通货品标签异常`,
  key1002008: `申请运单号成功`,
  key1002009: `(运单号：`,
  key1002010: `(失败原因:：`,
  key1002011: `edis重新上传包裹异常异常`,
  key1002012: `手动修改：更新仓储账单【单据费用】`,
  key1002013: `手动修改：更新仓储账单【其他费用】`,
  key1002014: `手动修改：新增其他费用【`,
  key1002015: `添加备注`,
  key1002016: `手动修改`,
  key1002017: `币种修改`,
  key1002018: `导入账单更新`,
  key1002019: `确认结算`,
  key1002020: `人工标记标记允许取消订单`,
  key1002021: `由于地址修改，当前物流无法送达，原订单已取消，请重新匹配物流后进行下单。`,
  key1002022: `收货中`,
  key1002023: `由于地址修改，原订单已取消。`,
  key1002024: `作废提单，原因：`,
  key1002025: `手动标记付款成功`,
  key1002026: `买家修改收货地址，更新订单收货地址`,
  key1002027: `缴费金额：`,
  key1002028: `，时长：`,
  key1002029: `个月`,
  key1002030: `备货单首次分配`,
  key1002031: `商户工商信息变更，驳回原因：`,
  key1002032: `供应商修改了:`,
  key1002033: `商户工商信息变更，审核通过`,
  key1002034: `订单新增标签：`,
  key1002035: `订单删除标签：`,
  key1002036: `存在备货单尚未到货，等待在途库存。`,
  key1002037: `订单新增备注：`,
  key1002038: `美西仓库存不足，等待下次分配`,
  key1002039: `审核账单`,
  key1002040: `确认账单`,
  key1002041: `确认打款`,
  key1002042: `停售商品：`,
  key1002043: `停售货品：`,
  key1002044: `，生成货品标签异常;`,
  key1002045: `上传支付凭证信息`,
  key1002046: `编辑支付凭证信息`,
  key1002047: `运营对账-通过`,
  key1002048: `运营对账-退回`,
  key1002049: `订单付款信息取消`,
  key1002050: `线下付款成功`,
  key1002051: `订单付款信息提交`,
  key1002052: `修改支付凭证信息`,
  key1002053: `手动匹配仓库成功:`,
  key1002054: `分销商付款`,
  key1002055: `信用额度由`,
  key1002056: `修改为`,
  key1002057: `自动匹配商品发货仓失败`,
  key1002058: `自动匹配商品发货仓成功`,
  key1002059: `手动匹配商品发货仓成功`,
  key1002060: `将仓库`,
  key1002061: `类型修改为`,
  key1002062: `,商品发货仓由`,
  key1002063: `修改为匹配`,
  key1002064: `手动添加订单-`,
  key1002065: `拆分订单-`,
  key1002066: `，拆分成订单`,
  key1002067: `手动调整订单成功，订单号：`,
  key1002068: `对应发货仓库存不足，请操作调整此商品的订单数量或商品发货仓`,
  key1002069: `商品定制内容配置完成`,
  key1002070: `自动商品定制内容配置失败`,
  key1002071: `更新客户账单`,
  key1002072: `供应商子单“`,
  key1002073: `”，已在`,
  key1002074: `平台订单线上发货成功`,
  key1002075: `平台订单地址解密成功`,
  key1002076: `平台订单地址解密失败，失败原因:`,
  key1002077: `添加商品SPU[`,
  key1002078: `添加商品[`,
  key1002079: `删除SKU[`,
  key1002080: `新增商品图片`,
  key1002081: `新增SPU颜色图片`,
  key1002082: `修改商品规格：[`,
  key1002083: `]改为[`,
  key1002084: `修改商品由：[`,
  key1002085: `];组装信息sku：[`,
  key1002086: `新增图片：`,
  key1002087: `删除图片:`,
  key1002088: `修改商品Height:[`,
  key1002089: `修改商品LENGTH:[`,
  key1002090: `修改商品WEIGHT:[`,
  key1002091: `修改商品WIDTH:[`,
  key1002092: `修改商品SKU:[`,
  key1002093: `删除SKU货品属性,标签,图片:[`,
  key1002094: `发货仓[`,
  key1002095: `]供货价变更：[`,
  key1002096: `]变更为[`,
  key1002097: `更新商品SPU:[`,
  key1002098: `物品属性`,
  key1002099: `值:[`,
  key1002100: `修改商品描述`,
  key1002101: `修改SPU/商品编码:[`,
  key1002102: `修改商品中文名称:[`,
  key1002103: `上架商品：`,
  key1002104: `上架货品：`,
  key1002105: `分销商余额充值信息提交`,
  key1002106: `分销商线下充值成功`,
  key1002107: `商户店铺信息变更，驳回原因：`,
  key1002108: `商户店铺信息变更，审核通过`,
  key1002109: `商户收款账户变更，驳回原因：`,
  key1002110: `商户收款账户变更，审核通过`,
  key1002111: `未关联对应区域/国家合规责任人、制造商信息`,
  key1002112: `[ 运费最低 ]`,
  key1002113: `[ 时效最快 ]`,
  key1002114: `供货仓`,
  key1002115: `直发仓`,
  key1002116: `[imInit] window.tmsIm SDK 未加载，请检查 HTML 中是否引入了 im.min.js`,
  key1002117: `[imInit] 初始化失败，请检查 systemEnvironment 是否正确`,
  key1002118: `当前可使用语种已变更，如有疑问请联系平台运营！`,
  key1002119: `点击刷新`,
  key1002120: `无法备货至`,
  key1002121: `仓`,
  key1002122: `当前最多可下单`,
  key1002123: `个`,
  key1002124: `存在重复，请修改`,
  key1002125: `尺码值语种：`,
  key1002126: `不可为空`,
  key1002127: `出库单:`,
  key1002128: `不是等待拣货状态，请移除有再完成追加`,
  key1002129: `速卖通预约交货失败`,
  key1002130: `数量超出限制，请核对数量`,
  key1002131: `当前容器`,
  key1002132: `正在被占用`,
  key1002133: `已存在`,
  key1002134: `运营下发物流异常：不同仓库`,
  key1002135: `订单不可同时发货`,
  key1002136: `运营下发物流异常：店铺地址不匹配`,
  key1002137: `已预约，揽收单号：`,
  key1002138: `供应商系统出库异常，提单单号：`,
  key1002139: `交接单号：`,
  key1002140: `预约交货异常`,
  key1002141: `非此订单所需货品，请确认货品所属订单`,
  key1002142: `提单：`,
  key1002143: `不存在，请输入正确提单号`,
  key1002144: `存在已下发的云卖订单`,
  key1002145: `库位所属库区不匹配：`,
  key1002146: `[bindAppScrollClosePoppers] 未找到滚动容器：`,
  key1002147: `，优惠金额：`,
  key1002148: `，折扣系数：`,
  key1002149: `待付款订单取消倒计时不能为空！`,
  key1002150: `是否启用此功能：`,
  key1002151: `待付款订单取消倒计时：`,
  key1002152: `优先级`,
  key1002153: `置底`,
  key1002154: `置顶`,
  key1002155: `移动`,
  key1002156: `规则名称`,
  key1002157: `启用状态`,
  key1002158: `创建人`,
  key1002159: `创建时间`,
  key1002160: `最后更新时间`,
  key1002161: `修改成功`,
  key1002162: `删除提示`,
  key1002163: `规则删除后，将不可恢复，是否删除？`,
  key1002164: `启用状态：`,
  key1002165: `请输入规则名称`,
  key1002166: `新增规则`,
  key1002167: `阿里国际`,
  key1002168: `查看规则`,
  key1002169: `编辑规则`,
  key1002170: `复制规则`,
  key1002171: `请先选择规则项！`,
  key1002172: `复制成功`,
  key1002173: `仓库不能为空`,
  key1002174: `动作类型：`,
  key1002175: `指定帐号`,
  key1002176: `指定履约方`,
  key1002177: `设定动作`,
  key1002178: `分配发货仓库`,
  key1002179: `所分配仓库缺货时支持继续匹配其他分配仓库规则`,
  key1002180: `禁用`,
  key1002181: `发货地名称`,
  key1002182: `发货国家/地区`,
  key1002183: `是否允许集货`,
  key1002184: `查看&编辑`,
  key1002185: `新建发货地`,
  key1002186: `跨境电商平台至少要选择一个！`,
  key1002187: `平台选择：`,
  key1002188: `容器类型`,
  key1002189: `重量(kg)`,
  key1002190: `体积(cm³)`,
  key1002191: `长(cm)`,
  key1002192: `宽(cm)`,
  key1002193: `高(cm)`,
  key1002194: `容器类型不能为空`,
  key1002195: `容器重量不能为空`,
  key1002196: `容器体积不能为空`,
  key1002197: `容器长度不能为空`,
  key1002198: `容器宽度不能为空`,
  key1002199: `容器高度不能为空`,
  key1002200: `新增容器类型`,
  key1002201: `容器类型：`,
  key1002202: `请输入容器类型，比如：周转箱`,
  key1002203: `重量(kg)：`,
  key1002204: `体积(cm³)：`,
  key1002205: `长(cm)：`,
  key1002206: `宽(cm)：`,
  key1002207: `高(cm)：`,
  key1002208: `平台币种`,
  key1002209: `交易币种`,
  key1002210: `汇率配置`,
  key1002211: `固定汇率`,
  key1002212: `实时汇率浮动`,
  key1002213: `浮动比例`,
  key1002214: `下浮`,
  key1002215: `请输入固定汇率`,
  key1002216: `请输入浮动比例`,
  key1002217: `汇率展示`,
  key1002218: `实时汇率：`,
  key1002219: `系统汇率：`,
  key1002220: `固定汇率不能为空！`,
  key1002221: `固定汇率必须是大于等于0且最多允许4位小数`,
  key1002222: `实时汇率浮动不能为空！`,
  key1002223: `实时汇率浮动必须是大于等于0且最多允许4位小数`,
  key1002224: `平台币种：`,
  key1002225: `供应商币种：`,
  key1002226: `添加支持币种`,
  key1002227: `分销商币种：`,
  key1002228: `月结`,
  key1002229: `半月结`,
  key1002230: `周结`,
  key1002231: `每月`,
  key1002232: `每半月`,
  key1002233: `每周`,
  key1002234: `请填写账单生成周期`,
  key1002235: `生成，`,
  key1002236: `的第`,
  key1002237: `账单生成周期：`,
  key1002238: `按`,
  key1002239: `日，生成账单`,
  key1002240: `打印容器条码`,
  key1002241: `请输入自定义内容`,
  key1002242: `介质材料：`,
  key1002243: `标签大小：`,
  key1002244: `自定义内容：`,
  key1002245: `自定义内容字体`,
  key1002246: `条码字体`,
  key1002247: `每pt约占0.35mm宽，请确保最长的SKU字符数*左侧pt值*0.35小于介质尺寸`,
  key1002248: `不打印自定义内容`,
  key1002249: `打印自定义内容`,
  key1002250: `增加`,
  key1002251: `统一设置打印数量`,
  key1002252: `注:打印内容可拖动改变位置`,
  key1002253: `服务商在此发货地无仓库，请选择其他发货地进行配置`,
  key1002254: `请先选择仓库发货地！`,
  key1002255: `线上物流`,
  key1002256: `线下物流`,
  key1002257: `平台物流`,
  key1002258: `请选择第三方服务商`,
  key1002259: `请完善服务商信息`,
  key1002260: `开启仓库`,
  key1002261: `仓库可用物流配置`,
  key1002262: `消息名称`,
  key1002263: `消息类型`,
  key1002264: `通知渠道`,
  key1002265: `通知方式`,
  key1002266: `站内信`,
  key1002267: `邮箱->短信`,
  key1002268: `短信->邮箱`,
  key1002269: `删除消息模板后，将不再发送提醒消息，你确定要删除？`,
  key1002270: `新增消息模板`,
  key1002271: `标题不能为空！`,
  key1002272: `内容不能为空！`,
  key1002273: `消息类型不能为空`,
  key1002274: `内容：`,
  key1002275: `编辑消息模板`,
  key1002276: `提醒时间类型为固定时间且单位为天时，具体的提醒时间段不能为空！`,
  key1002277: `触发条件的频率次数不能为空！`,
  key1002278: `提醒类型为固定时间的频率次数不能为空！`,
  key1002279: `编辑成功`,
  key1002280: `消息名称：`,
  key1002281: `请输入消息名称，最多输入20个汉字`,
  key1002282: `消息类型：`,
  key1002283: `触发条件：`,
  key1002284: `通知渠道：`,
  key1002285: `通知方式：`,
  key1002286: `是否弹窗：`,
  key1002287: `提醒时间：`,
  key1002288: `提醒时间段为：6:00-23:00，其他时间段不提醒`,
  key1002289: `请选择时间`,
  key1002290: `占位符：`,
  key1002291: `含义：`,
  key1002292: `状态停留时间超过`,
  key1002293: `及时提醒`,
  key1002294: `固定时间`,
  key1002295: `每`,
  key1002296: `提醒一次`,
  key1002297: `1)可从右侧拖拽添加动态字段。`,
  key1002298: `2)蓝色字体文字为动态参数，请勿修改。`,
  key1002299: `3)自定义内容仅支持站内信与邮件，短信按默认内容发送。`,
  key1002300: `动态参数`,
  key1002301: `发货地名称不能为空`,
  key1002302: `发货国家/地区不能为空`,
  key1002303: `发货地名称：`,
  key1002304: `发货国家/地区：`,
  key1002305: `是否允许集货：`,
  key1002306: `按钮名称`,
  key1002307: `（更多）`,
  key1002308: `是否设置为主按钮`,
  key1002309: `是否可见`,
  key1002310: `按钮布局配置`,
  key1002311: `此按钮仅在可定制商品详情页中展示！`,
  key1002312: `按钮配置`,
  key1002313: `布局预览`,
  key1002314: `库区代码`,
  key1002315: `库区名称`,
  key1002316: `仓库名称不能为空`,
  key1002317: `库区名称不能为空`,
  key1002318: `库区代码不能为空`,
  key1002319: `状态不能为空`,
  key1002320: `新建库区`,
  key1002321: `查看库区`,
  key1002322: `编辑库区`,
  key1002323: `请先勾选需要打印的数据！`,
  key1002324: `库区名称：`,
  key1002325: `库区代码：`,
  key1002326: `库区状态：`,
  key1002327: `仓库名称：`,
  key1002328: `打印库区条码`,
  key1002329: `库区`,
  key1002330: `批量打印条码`,
  key1002331: `姓名`,
  key1002332: `国家/地区`,
  key1002333: `省/州`,
  key1002334: `城市`,
  key1002335: `区县`,
  key1002336: `街道地址1`,
  key1002337: `街道地址2`,
  key1002338: `街道地址3`,
  key1002339: `手机号`,
  key1002340: `邮政编码`,
  key1002341: `公司名称`,
  key1002342: `邮箱`,
  key1002343: `请输入对外展示-仓库名称`,
  key1002344: `请输入对外展示-仓库编码`,
  key1002345: `查看&编辑仓库`,
  key1002346: `请联系平台运营确定集货仓信息后选择`,
  key1002347: `供应商直发仓将直接在商城对分销商展示，可自主配置分销商可见的直发仓名称及编码。`,
  key1002348: `请选择此直发仓已对接可发出的物流渠道`,
  key1002349: `第三方物流`,
  key1002350: `基础信息`,
  key1002351: `仓库发货地：`,
  key1002352: `仓库编码：`,
  key1002353: `仓库配置`,
  key1002354: `仓库类型：`,
  key1002355: `供货仓配置`,
  key1002356: `供货目标集货仓：`,
  key1002357: `是否可打印物流面单：`,
  key1002358: `直发仓配置`,
  key1002359: `对外展示-仓库名称：`,
  key1002360: `对外展示-仓库名称不能为空`,
  key1002361: `对外展示-仓库编码：`,
  key1002362: `对外展示-仓库编码不能为空`,
  key1002363: `直发可用物流`,
  key1002364: `仓库地址`,
  key1002365: `发货地址`,
  key1002366: `退货地址`,
  key1002367: `二维码图片尺寸不能小于`,
  key1002368: `170px，当前为`,
  key1002369: `上传文件格式有误，文件`,
  key1002370: `格式错误，请选择jpg、jpeg、png格式的图片`,
  key1002371: `文件大小受限，文件`,
  key1002372: `太大，不能超过20M`,
  key1002373: `请上传展示图片（二维码）`,
  key1002374: `请输入电话`,
  key1002375: `仅支持 PNG / JPG / JPEG 格式的图片`,
  key1002376: `图片读取失败`,
  key1002377: `图片上传成功`,
  key1002378: `是否展示此信息：`,
  key1002379: `咨询时段：`,
  key1002380: `例如：周一至周五 9:00–18:00`,
  key1002381: `展示图片(二维码)：`,
  key1002382: `请输入内容`,
  key1002383: `展示`,
  key1002384: `隐藏`,
  key1002385: `重新上传`,
  key1002386: `点击上传图片`,
  key1002387: `容器编号`,
  key1002388: `容器颜色`,
  key1002389: `作业状态`,
  key1002390: `所属仓库`,
  key1002391: `最后一次占用时间`,
  key1002392: `编辑容器颜色`,
  key1002393: `所属仓库不能为空`,
  key1002394: `新增容器`,
  key1002395: `请选择数据`,
  key1002396: `容器数量不能为空`,
  key1002397: `容器数量必须是大于0的正整数`,
  key1002398: `上传音频失败，请重新尝试`,
  key1002399: `所属仓库：`,
  key1002400: `容器编号：`,
  key1002401: `请入输入容器编号`,
  key1002402: `容器颜色：`,
  key1002403: `作业状态：`,
  key1002404: `容器数量：`,
  key1002405: `请输入颜色名称`,
  key1002406: `批量删除`,
  key1002407: `上传音频`,
  key1002408: `游客价格展示：`,
  key1002409: `是否校验发货地一致性`,
  key1002410: `用于标识该平台是否要求订单实际发货地与平台后台标记发货地保持一致，便于系统判断订单是否可更换发货仓发货。`,
  key1002411: `平台设置`,
  key1002412: `平台列表`,
  key1002413: `平台是否校验发货地一致性：`,
  key1002414: `新增仓库`,
  key1002415: `仓库编码不能为空`,
  key1002416: `仓库类型不能为空`,
  key1002417: `发货地不能为空`,
  key1002418: `常规订单处理费不能为空`,
  key1002419: `常规多品订单续件不能为空`,
  key1002420: `备货类订单处理费不能为空`,
  key1002421: `仓库发货地址`,
  key1002422: `仓库收货地址`,
  key1002423: `仓库退货地址`,
  key1002424: `名称：`,
  key1002425: `编辑仓库`,
  key1002426: `查看仓库`,
  key1002427: `名称不能为空`,
  key1002428: `左区间不能为空！`,
  key1002429: `右区间不能为空！`,
  key1002430: `分层价不能为空！`,
  key1002431: `左区间不能大于等于右区间`,
  key1002432: `模板选择不能为空`,
  key1002433: `发货地：`,
  key1002434: `是否能备货：`,
  key1002435: `是否设置为集货仓：`,
  key1002436: `模板选择：`,
  key1002437: `常规订单处理费：`,
  key1002438: `常规多品订单续件：`,
  key1002439: `常规订单耗材费：`,
  key1002440: `备货类订单处理费：`,
  key1002441: `仓库租金：`,
  key1002442: ` / 件`,
  key1002443: ` / 单`,
  key1002444: ` / 月`,
  key1002445: `仓库处理费`,
  key1002446: `+添加分层价`,
  key1002447: `每日`,
  key1002448: `时`,
  key1002449: `点击查看`,
  key1002450: `消息标题`,
  key1002451: `时间`,
  key1002452: `请先勾选要标记已读的数据！`,
  key1002453: `标记为已读`,
  key1002454: `共`,
  key1002455: `条消息，其中未读消息`,
  key1002456: `-默认语种`,
  key1002457: `（当前配置为`,
  key1002458: `（倒计时`,
  key1002459: `功能名称`,
  key1002460: `功能描述`,
  key1002461: `功能状态`,
  key1002462: `配置`,
  key1002463: `不展示价格`,
  key1002464: `展示商品销售价`,
  key1002465: `展示商品批发价`,
  key1002466: `展示商品零售价`,
  key1002467: `运营端`,
  key1002468: `分销商端`,
  key1002469: `供应商端`,
  key1002470: `停用提示`,
  key1002471: `是否确认停用此配置项？`,
  key1002472: `停用成功！`,
  key1002473: `启用成功！`,
  key1002474: `目的国`,
  key1002475: `清关费率`,
  key1002476: `更新人`,
  key1002477: `更新时间`,
  key1002478: `日志`,
  key1002479: `启用确认`,
  key1002480: `停用确认`,
  key1002481: `启用后，此目的国将校验IOSS编号，请确认是否启用？`,
  key1002482: `停用后，此目的国将不再校验IOSS编号，请确认是否停用？`,
  key1002483: `确认启用`,
  key1002484: `确认停用`,
  key1002485: `启用成功`,
  key1002486: `停用成功`,
  key1002487: `目的国不能为空`,
  key1002488: `清关费率不能为空`,
  key1002489: `最多支持两位小数，需大于等于0`,
  key1002490: `添加税率设置`,
  key1002491: `编辑税率设置`,
  key1002492: `清关费率不能为空！`,
  key1002493: `目的国：`,
  key1002494: `清关费率：`,
  key1002495: `渠道选择：`,
  key1002496: `按照货品成本单价由高到低顺序选择`,
  key1002497: `按照货品成本单价X数量由高到低顺序选择`,
  key1002498: `按照货品单品体积由大到小顺序选择`,
  key1002499: `按照货品单品体积X数量由大到小顺序选择`,
  key1002500: `按照货品单品重量由大到小顺序选择`,
  key1002501: `按照货品单品重量X数量由大到小顺序选择`,
  key1002502: `封顶价格要大于最低价格`,
  key1002503: `请输入设置最低价格`,
  key1002504: `请输入设置封顶价格`,
  key1002505: `请输入设置包裹封顶重量`,
  key1002506: `申报的SKU品种数`,
  key1002507: `每个申报的SKU品种申报的数量`,
  key1002508: `包裹包含多SKU时选择申报的货品信息`,
  key1002509: `申报重量的计算方法`,
  key1002510: `申报价格的计算方法`,
  key1002511: `默认申报设置`,
  key1002512: `全部申报`,
  key1002513: `限制最多申报品种数`,
  key1002514: `实际数量`,
  key1002515: `限制最多申报数量`,
  key1002516: `本项设置仅为确定申报所使用的品名及数量，对报关重量和价格无影响`,
  key1002517: `使用固定的总重量申报`,
  key1002518: `固定包裹总重量为`,
  key1002519: `如果申报时各品种需要详细的申报重量，系统将自动按照申报的品种的真实货品重量加权平均计算`,
  key1002520: `使用货品真实重量申报`,
  key1002521: `设置包裹封顶重量为`,
  key1002522: `申报币种`,
  key1002523: `使用固定价格申报`,
  key1002524: `固定申报价格`,
  key1002525: `本项设置仅录入金额，币种取本申报币种`,
  key1002526: `使用价格比例申报`,
  key1002527: `使用包裹`,
  key1002528: `的`,
  key1002529: `设置最低价格`,
  key1002530: `设置封顶价格`,
  key1002531: `设置为本选项后，系统将根据申报币种自动做汇率转换`,
  key1002532: `上传文件格式有误,文件`,
  key1002533: `格式错误,`,
  key1002534: `请上传`,
  key1002535: `尺寸必须为`,
  key1002536: `运营端Logo`,
  key1002537: `分销商端Logo`,
  key1002538: `供应商端Logo`,
  key1002539: `运营端浏览器icon`,
  key1002540: `分销商端浏览器icon`,
  key1002541: `供应商端浏览器icon`,
  key1002542: `请选择语种`,
  key1002543: `请选择平台币种`,
  key1002544: `请选择跨境电商平台`,
  key1002545: `jpg、jpeg、png格式的图片`,
  key1002546: `ico格式的图片`,
  key1002547: `分销商端必须设置一个默认语种`,
  key1002548: `供应商端必须设置一个默认语种`,
  key1002549: `浏览器 icon 仅支持 ico 格式`,
  key1002550: `LOGO 仅支持 PNG / JPG / JPEG 格式`,
  key1002551: `运营端配置`,
  key1002552: `分销商端配置`,
  key1002553: `供应商端配置`,
  key1002554: `完成`,
  key1002555: `默认语种选择：`,
  key1002556: `平台币种选择：`,
  key1002557: `浏览器icon：`,
  key1002558: `语种选择：`,
  key1002559: `可用跨境电商平台配置：`,
  key1002560: `下一步`,
  key1002561: `欢迎`,
  key1002562: `欢迎你使用通途分销商系统`,
  key1002563: `系统提示：`,
  key1002564: `1、首次进入通途分销系统，为了系统顺利运行，需要您根据实际业务情况进行一些核心内容的配置；`,
  key1002565: `2、本次配置的内容，后续可在“`,
  key1002566: `基础设置-系统配置`,
  key1002567: `”模块中进行调整；`,
  key1002568: `展示于系统左上角，logo固定显示大小为210*22px；限制格式为PNG、JPG、JPEG;`,
  key1002569: `顶部浏览器图标，浏览器顶部图标展示，固定显示大小为16*16px；限制格式为ico；`,
  key1002570: `(默认语种)`,
  key1002571: `设为默认`,
  key1002572: `新配置“`,
  key1002573: `”的物流渠道，`,
  key1002574: `需要绑定`,
  key1002575: `物流才能正常使用，请问是否绑定？（`,
  key1002576: `也可到“`,
  key1002577: `基础物流-线上物流-查看物流渠道-设置`,
  key1002578: `”页面中进行绑定）`,
  key1002579: `对外展示-仓库名称`,
  key1002580: `仓库代码`,
  key1002581: `仓库类型`,
  key1002582: `供货仓及直发仓`,
  key1002583: `是否为集货仓`,
  key1002584: `是否能备货`,
  key1002585: `发货地`,
  key1002586: `国家`,
  key1002587: `所属供应商`,
  key1002588: `仓库权限已经停用，如需启用请联系通途运营！`,
  key1002589: `平台仓`,
  key1002590: `供应商仓`,
  key1002591: `是否确认停用该仓库？`,
  key1002592: `是否确认停用该仓库，停用后系统将会自动删除该仓库与所有供应商仓的集货/备货关系，请谨慎操作！`,
  key1002593: `万邑通3PL`,
  key1002594: `米雲仓平台`,
  key1002595: `物流绑定提示`,
  key1002596: `点击绑定`,
  key1002597: `请输入仓库名称`,
  key1002598: `国家：`,
  key1002599: `是否为集货仓：`,
  key1002600: `所属供应商：`,
  key1002601: `请输入供应商名称/商户号`,
  key1002602: `图片尺寸必须为`,
  key1002603: `请先上传LOGO和浏览器icon图片！`,
  key1002604: `LOGO仅支持 PNG / JPG / JPEG`,
  key1002605: `浏览器图标仅支持 ICO`,
  key1002606: `LOGO 上传成功`,
  key1002607: `浏览器 icon 上传成功`,
  key1002608: `所属库区名称`,
  key1002609: `所属库区代码`,
  key1002610: `库位代码`,
  key1002611: `库位代码不能为空`,
  key1002612: `新建库位`,
  key1002613: `查看库位`,
  key1002614: `编辑库位`,
  key1002615: `请先选择所属仓库`,
  key1002616: `所属库区名称：`,
  key1002617: `库位代码：`,
  key1002618: `库位状态：`,
  key1002619: `打印库位条码`,
  key1002620: `库位`,
  key1002621: `导入库位`,
  key1002622: `提示：`,
  key1002623: `1.支持扩展名:`,
  key1002624: `2.当导入数据存在异常时，数据导入失败;`,
  key1002625: `3.导入操作后，请稍后在“导入/导出任务-导入查看”中查看导入结果。`,
  key1002626: `默认业务类型：`,
  key1002627: `返回列表`,
  key1002628: `模板名称`,
  key1002629: `手机号码`,
  key1002630: `已启用`,
  key1002631: `已停用`,
  key1002632: `停用提示？`,
  key1002633: `启用提示？`,
  key1002634: `是否确认停用此模板？`,
  key1002635: `是否确认启用此模板？`,
  key1002636: `请入输入模板名称`,
  key1002637: `新增地址`,
  key1002638: `请至少选择一个语种`,
  key1002639: `请设置默认语种`,
  key1002640: `存在进行中的入库分拣任务，请完成后再进行修改。`,
  key1002641: `入库分拣设置`,
  key1002642: `拣货容器：`,
  key1002643: `包装容器：`,
  key1002644: `切换仓库`,
  key1002645: `提单揽收`,
  key1002646: `流程状态：启用`,
  key1002647: `提单入库`,
  key1002648: `入库分拣`,
  key1002649: `极速出库模式`,
  key1002650: `分拣时进行贴单`,
  key1002651: `商品上架`,
  key1002652: `多品分拣`,
  key1002653: `单品任务跳过此流程`,
  key1002654: `包装作业`,
  key1002655: `物流分拣`,
  key1002656: `上架容器`,
  key1002657: `贴单+上架容器`,
  key1002658: `出库容器`,
  key1002659: `包装容器`,
  key1002660: `贴单+包装容器`,
  key1002661: `拣货容器`,
  key1002662: `贴单+拣货容器`,
  key1002663: `分拣容器出库单数量限制`,
  key1002664: `暂无仓库数据权限，请配置仓库权限后重试。`,
  key1002665: `设置成功！`,
  key1002666: `商城默认语言配置`,
  key1002667: `语言选择：`,
  key1002668: `模板名称不能为空`,
  key1002669: `姓名不能为空`,
  key1002670: `国家/地区不能为空`,
  key1002671: `省州不能为空`,
  key1002672: `街道地址不能为空`,
  key1002673: `邮政编码不能为空`,
  key1002674: `编辑地址`,
  key1002675: `查看地址`,
  key1002676: `姓名：`,
  key1002677: `国家/地区：`,
  key1002678: `街道地址1：`,
  key1002679: `eDIS街道地址限制输入50字符以内；`,
  key1002680: `街道地址2：`,
  key1002681: `街道地址3：`,
  key1002682: `公司名称：`,
  key1002683: `添加时间`,
  key1002684: `订单自动规则--编辑`,
  key1002685: `特殊申报规则`,
  key1002686: `收款账户详情`,
  key1002687: `请输入开户行`,
  key1002688: `收款账户审核`,
  key1002689: `编辑收款账户`,
  key1002690: `银行卡`,
  key1002691: `银行卡号`,
  key1002692: `支付宝`,
  key1002693: `支付宝账户`,
  key1002694: `审核成功！`,
  key1002695: `请输入银行卡号`,
  key1002696: `请输入支付宝登录号`,
  key1002697: `手机号/邮箱格式不正确`,
  key1002698: `请输入开户人姓名`,
  key1002699: `请输入该支付宝账户的开户人姓名`,
  key1002700: `请输入身份证号`,
  key1002701: `请输入该支付宝账户的开户人证件号`,
  key1002702: `收款方式：`,
  key1002703: `开户人姓名：`,
  key1002704: `开户行：`,
  key1002705: `银行卡号：`,
  key1002706: `身份证号：`,
  key1002707: `支付宝账户：`,
  key1002708: `请输入支付宝登录号，支持邮箱和手机号格式`,
  key1002709: `开户人证件号：`,
  key1002710: `原记录：`,
  key1002711: `收款方式：-`,
  key1002712: `变更后记录：`,
  key1002713: `审核驳回`,
  key1002714: `新增供应商等级`,
  key1002715: `等级名称不能为空`,
  key1002716: `等级名称`,
  key1002717: `被展示分销商`,
  key1002718: `所有（包含未登录）`,
  key1002719: `查看供应商等级`,
  key1002720: `编辑供应商等级`,
  key1002721: `是否要删除当前供应商等级？`,
  key1002722: `请选择分销等级！`,
  key1002723: `等级名称：`,
  key1002724: `被展示分销商：`,
  key1002725: `部分`,
  key1002726: `请选择[jpg,jpeg,png]`,
  key1002727: `添加供应商`,
  key1002728: `请选择经营规模`,
  key1002729: `联系人不能为空`,
  key1002730: `店铺名称不能为空`,
  key1002731: `请选择经营模式`,
  key1002732: `请选择计划经营类目`,
  key1002733: `请选择预计上架商品数`,
  key1002734: `供应商等级不能为空`,
  key1002735: `10人以下`,
  key1002736: `10~30人`,
  key1002737: `30~50人`,
  key1002738: `50~100人`,
  key1002739: `100人以上`,
  key1002740: `10以下`,
  key1002741: `100以上`,
  key1002742: `公司`,
  key1002743: `入驻审核状态：`,
  key1002744: `工商信息变更审核状态：`,
  key1002745: `供应商详情`,
  key1002746: `编辑供应商信息`,
  key1002747: `审核供应商`,
  key1002748: `供应商工商信息变更审核`,
  key1002749: `款`,
  key1002750: `待定`,
  key1002751: `营业执照`,
  key1002752: `法定代表人身份证国徽面`,
  key1002753: `法定代表人身份证人像面`,
  key1002754: `店铺logo`,
  key1002755: `请先上传营业执照`,
  key1002756: `请先上传法定代表人身份证国徽面`,
  key1002757: `请先上传法定代表人身份证人像面`,
  key1002758: `请先上传店铺logo`,
  key1002759: `请先选择商品发布频率类型！`,
  key1002760: `账期结算不能为空！`,
  key1002761: `商品发布数不能为空`,
  key1002762: `商品发布数必须是大于0的正整数`,
  key1002763: `营业地址不能为空`,
  key1002764: `请选择完整的省市区营业地址`,
  key1002765: `请填写邮箱`,
  key1002766: `营业执照：`,
  key1002767: `法定代表人身份证照：`,
  key1002768: `经营规模：`,
  key1002769: `联系人姓名：`,
  key1002770: `请填写联系人姓名`,
  key1002771: `联系人手机号码：`,
  key1002772: `请填联系人手机号码`,
  key1002773: `请填写固定电话号码`,
  key1002774: `店铺名称：`,
  key1002775: `请填写店铺名称`,
  key1002776: `店铺Logo：`,
  key1002777: `经营模式：`,
  key1002778: `计划经营类目：`,
  key1002779: `预计上架商品数：`,
  key1002780: `商品发布频率：`,
  key1002781: `请填写具体数量`,
  key1002782: `营业地址：`,
  key1002783: `请填写详细地址`,
  key1002784: `每月的X日生成上月账单，不含当月账单`,
  key1002785: `供应商等级：`,
  key1002786: `申请时间：`,
  key1002787: `驳回原因：`,
  key1002788: `仓库发货地址：`,
  key1002789: `仓库退货地址：`,
  key1002790: `账号信息`,
  key1002791: `密码：`,
  key1002792: `重新生成`,
  key1002793: `企业信息`,
  key1002794: `仅支持JPG、JPEG、PNG格式。`,
  key1002795: `人面像`,
  key1002796: `国徽面`,
  key1002797: `店铺信息`,
  key1002798: `尺寸：300*300px，仅支持JPG、JPEG、PNG格式。`,
  key1002799: `账期结算：`,
  key1002800: `日出账单`,
  key1002801: `收款信息`,
  key1002802: `审核结果`,
  key1002803: `仓库信息`,
  key1002804: `供货目标集货/备货仓选择：`,
  key1002805: `供应商编号`,
  key1002806: `请输入供应商编号，支持多个逗号或换行分隔`,
  key1002807: `请输入手机号，支持多个逗号或换行分隔`,
  key1002808: `请输入邮箱，支持多个逗号或换行分隔`,
  key1002809: `已认证供应商`,
  key1002810: `黑名单供应商`,
  key1002811: `联系人`,
  key1002812: `手机`,
  key1002813: `电话`,
  key1002814: `SKU总数量`,
  key1002815: `注册时间`,
  key1002816: `停用时间`,
  key1002817: `是否启用该供应商？启用后该供应商的账号可正常登录平台进行操作。`,
  key1002818: `名称`,
  key1002819: `提交时间：`,
  key1002820: `搜索字符：`,
  key1002821: `供应商名称/供应商商户号/联系人/手机/邮箱`,
  key1002822: `新增供应商`,
  key1002823: `请输入停用原因`,
  key1002824: `停用原因：`,
  key1002825: `停用后供应商将无法登录系统，无法进行发货等任何操作，请谨慎操作！`,
  key1002826: `店铺信息详情`,
  key1002827: `请先上传店铺Logo`,
  key1002828: `店铺信息审核`,
  key1002829: `编辑店铺信息`,
  key1002830: `上传店铺Logo成功`,
  key1002831: `上传店铺Logo失败`,
  key1002832: `供应商信息是否允许通过审核？`,
  key1002833: `入驻审核`,
  key1002834: `工商信息变更审核`,
  key1002835: `工商信息变更审核驳回`,
  key1002836: `店铺信息变更审核`,
  key1002837: `店铺信息变更审核驳回`,
  key1002838: `收款账户变更审核`,
  key1002839: `收款账户变更审核驳回`,
  key1002840: `驳回时间：`,
  key1002841: `店铺名称/供应商商户号`,
  key1002842: `供应商名称/供应商商户号`,
  key1002843: `通过审核`,
  key1002844: `确认通过`,
  key1002845: `供应商状态`,
  key1002846: `初审`,
  key1002847: `信息变更`,
  key1002848: `法人代表身份证`,
  key1002849: `经营规模`,
  key1002850: `联系人姓名`,
  key1002851: `联系人手机号码`,
  key1002852: `固定电话`,
  key1002853: `店铺Logo`,
  key1002854: `经营模式`,
  key1002855: `计划经营类目`,
  key1002856: `预计上架商品数`,
  key1002857: `商品发布频率`,
  key1002858: `营业地址`,
  key1002859: `详细地址`,
  key1002860: `收款方式`,
  key1002861: `收款账号`,
  key1002862: `开户人姓名`,
  key1002863: `原记录`,
  key1002864: `变更后记录`,
  key1002865: `提交审核时间`,
  key1002866: `驳回时间`,
  key1002867: `审核`,
  key1002868: `请输入驳回原因`,
  key1002869: `驳回成功！`,
  key1002870: `驳回申请`,
  key1002871: `销售额`,
  key1002872: `订单量`,
  key1002873: `时间不能跨度超过一年`,
  key1002874: `排名`,
  key1002875: `较上月`,
  key1002876: `较上周`,
  key1002877: `分销商商户号`,
  key1002878: `分销商名称`,
  key1002879: `统计`,
  key1002880: `订单状态为已出库的累计订单总金额。`,
  key1002881: `订单状态为已出库的累计订单总数量。`,
  key1002882: `商城SKU状态为在售的总数量。`,
  key1002883: `统计所有分销商订阅商品总量，同一个商品多个分销商订阅只计算1次。`,
  key1002884: `统计所有分销商已上架到平台的商品总数量，同一个商品不同的Item只计算一次。`,
  key1002885: `统计所有分销商发布刊登的总数量，按Item数量统计。`,
  key1002886: `供应商订单排名`,
  key1002887: `分销商订单排名`,
  key1002888: `总销售额(`,
  key1002889: `本月销售额`,
  key1002890: `昨日销售额`,
  key1002891: `今日销售额`,
  key1002892: `订单总数（单）`,
  key1002893: `本月订单数`,
  key1002894: `昨日订单数`,
  key1002895: `今日订单数`,
  key1002896: `在售商品数（SKU）`,
  key1002897: `本月上新`,
  key1002898: `昨日上新`,
  key1002899: `今日上新`,
  key1002900: `商品订阅数（SPU）`,
  key1002901: `本月订阅`,
  key1002902: `昨日订阅`,
  key1002903: `今日订阅`,
  key1002904: `上架商品数（SPU）`,
  key1002905: `本月上架数`,
  key1002906: `昨日上架数`,
  key1002907: `今日上架数`,
  key1002908: `发布刊登数（Item）`,
  key1002909: `本月刊登数`,
  key1002910: `昨日刊登数`,
  key1002911: `今日刊登数`,
  key1002912: `供应商总数`,
  key1002913: `本月新增`,
  key1002914: `昨日新增`,
  key1002915: `今日新增`,
  key1002916: `分销商总数`,
  key1002917: `订单状态`,
  key1002918: `待下单`,
  key1002919: `待换单`,
  key1002920: `待发货`,
  key1002921: `本周`,
  key1002922: `本月`,
  key1002923: `本年`,
  key1002924: `商品列表`,
  key1002925: `商品贴单`,
  key1002926: `库存余量`,
  key1002927: `提单列表`,
  key1002928: `出库明细`,
  key1002929: `问卷统计`,
  key1002930: `补贴审核`,
  key1002931: `充值记录`,
  key1002932: `供应商总账单`,
  key1002933: `供应商明细账单`,
  key1002934: `供应商订单`,
  key1002935: `物品属性池`,
  key1002936: `物流账单`,
  key1002937: `仓储账单`,
  key1002938: `库存明细`,
  key1002939: `类目映射`,
  key1002940: `导入实重`,
  key1002941: `自营商品`,
  key1002942: `草稿`,
  key1002943: `待修改`,
  key1002944: `待审核`,
  key1002945: `待发送`,
  key1002946: `已发送`,
  key1002947: `公告名称`,
  key1002948: `发送状态`,
  key1002949: `通知对象`,
  key1002950: `发送时间`,
  key1002951: `（预定）`,
  key1002952: `审核人`,
  key1002953: `审核通过提示`,
  key1002954: `审核通过后系统将按指定时间发送公告，请确认是否审核通过？`,
  key1002955: `删除公告提示`,
  key1002956: `公告删除后不可恢复，请确认是否删除？`,
  key1002957: `删除成功！`,
  key1002958: `取消发送`,
  key1002959: `取消发送提示`,
  key1002960: `取消后此公告将流转为草稿状态，请确认是否取消发送？`,
  key1002961: `通知对象：`,
  key1002962: `创建人：`,
  key1002963: `发送时间：`,
  key1002964: `创建公告`,
  key1002965: `问卷名称`,
  key1002966: `问卷状态`,
  key1002967: `已暂停`,
  key1002968: `答题中`,
  key1002969: `浏览量`,
  key1002970: `回收率`,
  key1002971: `最后修改时间`,
  key1002972: `停用后不可答题`,
  key1002973: `停用后，问卷答题将暂停，你确定停用？`,
  key1002974: `新建问卷`,
  key1002975: `文本`,
  key1002976: `弹窗`,
  key1002977: `不显示【跳过】按钮`,
  key1002978: `显示【跳过】按钮`,
  key1002979: `首次登录`,
  key1002980: `选项`,
  key1002981: `其他____`,
  key1002982: `是否保存问卷内容`,
  key1002983: `你有未保存的问卷，是否需要保存？`,
  key1002984: `不保存`,
  key1002985: `新建成功！`,
  key1002986: `题目标题不能为空！`,
  key1002987: `题目标题不能重复！`,
  key1002988: `问卷标题`,
  key1002989: `问卷说明`,
  key1002990: `请输入题目标题`,
  key1002991: `请输入选项`,
  key1002992: `投放渠道`,
  key1002993: `显示方式`,
  key1002994: `触发事件`,
  key1002995: `选择题型`,
  key1002996: `选填`,
  key1002997: `添加选项`,
  key1002998: `添加其他`,
  key1002999: `问卷设置`,
  key1003000: `PDF文件`,
  key1003001: `在线内容`,
  key1003002: `指引标题`,
  key1003003: `所属模块`,
  key1003004: `指引类型`,
  key1003005: `排序`,
  key1003006: `停用提醒`,
  key1003007: `停用后，用户将无法查看使用教程，`,
  key1003008: `你确定要停用吗？`,
  key1003009: `删除提醒`,
  key1003010: `你即将永久删除，删除后将无法恢复，`,
  key1003011: `你确定要删除吗？`,
  key1003012: `新增指引`,
  key1003013: `是否确认删除【`,
  key1003014: `】分类？`,
  key1003015: `标题`,
  key1003016: `发布日期`,
  key1003017: `最后更新日期`,
  key1003018: `展示状态`,
  key1003019: `开`,
  key1003020: `关`,
  key1003021: `首页推荐`,
  key1003022: `新增目录`,
  key1003023: `文章标题不能为空`,
  key1003024: `目录`,
  key1003025: `首页最多推荐5条帮助文档，请先关闭其他推荐，再开启！`,
  key1003026: `是否确认删除当前文章？`,
  key1003027: `编辑目录`,
  key1003028: `目录分类最多只能有三个层级关系，且只允许同级拖动排序！`,
  key1003029: `内容`,
  key1003030: `目录名称`,
  key1003031: `内容标题：`,
  key1003032: `请输入内容标题`,
  key1003033: `正文内容：`,
  key1003034: `排序：`,
  key1003035: `展示状态：`,
  key1003036: `复制文章标题`,
  key1003037: `最多可输入28个中文字符`,
  key1003038: `数字越大，越靠后`,
  key1003039: `添加内容`,
  key1003040: `请配置所属模块后再选择开启展示`,
  key1003041: `文档类型`,
  key1003042: `内容类型`,
  key1003043: `帮助中心处展示`,
  key1003044: `对应目录已隐藏，请取消隐藏后操作`,
  key1003045: `所属模块处展示`,
  key1003046: `是否确认复制当前文章？`,
  key1003047: `已隐藏`,
  key1003048: `(已隐藏)`,
  key1003049: `文档类型：`,
  key1003050: `在新的标签页打开图片`,
  key1003051: `1:1显示图片`,
  key1003052: `鼠标滚轮缩放图片`,
  key1003053: `指引标题不能为空`,
  key1003054: `所属模块不能为空`,
  key1003055: `显示位置不能为空`,
  key1003056: `编辑指引`,
  key1003057: `上传文件成功`,
  key1003058: `请先上传PDF文件！`,
  key1003059: `正文内容不能为空！`,
  key1003060: `指引标题：`,
  key1003061: `请输入指引标题`,
  key1003062: `所属模块：`,
  key1003063: `显示位置：`,
  key1003064: `指引类型：`,
  key1003065: `1.仅支持扩展名为PDF的文件。`,
  key1003066: `2.文件大小不超过10Mb。`,
  key1003067: `请输入公告名称`,
  key1003068: `请选择通知对象`,
  key1003069: `编辑公告`,
  key1003070: `提交审核成功`,
  key1003071: `请输入正文内容`,
  key1003072: `请选择发送时间`,
  key1003073: `公告名称：`,
  key1003074: `若审核通过时已超出发送时间，公告将在审核通过后立即发送。`,
  key1003075: `存为草稿`,
  key1003076: `提交审核`,
  key1003077: `请先勾选需要导出的数据！`,
  key1003078: `当前筛选结果暂无数据，无法导出！`,
  key1003079: `商户号`,
  key1003080: `开始答题时间`,
  key1003081: `结束答题时间`,
  key1003082: `导出数据`,
  key1003083: `按选中导出`,
  key1003084: `按查询结果导出`,
  key1003085: `编辑内容`,
  key1003086: `内容中文标题：`,
  key1003087: `内容英文标题：`,
  key1003088: `点击输入内容中文标题`,
  key1003089: `点击输入内容英文标题`,
  key1003090: `中文标题不能为空`,
  key1003091: `请上传中文 PDF`,
  key1003092: `中文内容不能为空`,
  key1003093: `可选择是否配置此项，若未配置，文档可选择仅展示在平台对应帮助中心中`,
  key1003094: `所属模块处显示：`,
  key1003095: `内容类型：`,
  key1003096: `帮助中心处显示：`,
  key1003097: `客户等级不能为空`,
  key1003098: `客户名称：`,
  key1003099: `联系人：`,
  key1003100: `手机：`,
  key1003101: `请输入手机号`,
  key1003102: `客户币种：`,
  key1003103: `业务类型：`,
  key1003104: `客户等级：`,
  key1003105: `仓库权限：`,
  key1003106: `客户类型：`,
  key1003107: `分销客户`,
  key1003108: `阿里国际分销`,
  key1003109: `点击总人数`,
  key1003110: `注册总人数`,
  key1003111: `注册转换率`,
  key1003112: `请填写链接名称`,
  key1003113: `分时数据`,
  key1003114: `点击人数`,
  key1003115: `注册人数`,
  key1003116: `链接详情`,
  key1003117: `链接名称：`,
  key1003118: `来源渠道：`,
  key1003119: `推广人：`,
  key1003120: `推广方式：`,
  key1003121: `推广内容：`,
  key1003122: `推广组：`,
  key1003123: `备注信息`,
  key1003124: `链接基本信息`,
  key1003125: `链接数据`,
  key1003126: `请填写链接地址`,
  key1003127: `创建成功！`,
  key1003128: `创建链接`,
  key1003129: `联系记录`,
  key1003130: `开通产品记录`,
  key1003131: `日志信息`,
  key1003132: `请先联系客户完善客户币种！`,
  key1003133: `主联系人`,
  key1003134: `不是有效的邮箱或者邮箱格式不正确！`,
  key1003135: `信息至少要填写其中一个！`,
  key1003136: `客户详情`,
  key1003137: `客户信息`,
  key1003138: `编号：`,
  key1003139: `客户来源：`,
  key1003140: `关联商户：`,
  key1003141: `客户负责人：`,
  key1003142: `请填写备注`,
  key1003143: `余额：`,
  key1003144: `预扣金额：`,
  key1003145: `信用额度：`,
  key1003146: `已使用额度：`,
  key1003147: `请输入姓名`,
  key1003148: `职务：`,
  key1003149: `请输入职务`,
  key1003150: `请输入邮箱`,
  key1003151: `请输入固定电话`,
  key1003152: `微信号：`,
  key1003153: `请输入微信号`,
  key1003154: `QQ号：`,
  key1003155: `请输入微QQ号`,
  key1003156: `客户旅程`,
  key1003157: `下次联系时间：`,
  key1003158: `操作人：`,
  key1003159: `客户基本信息`,
  key1003160: `客户财务信息`,
  key1003161: `客户仓库权限`,
  key1003162: `客户API权限`,
  key1003163: `添加联系人`,
  key1003164: `设为主要联系人`,
  key1003165: `暂无旅程数据`,
  key1003166: `分组名称`,
  key1003167: ` 分组客户数量`,
  key1003168: `分组备注`,
  key1003169: `删除分组提示`,
  key1003170: `正在操作删除分组，请确认是否删除？`,
  key1003171: `删除分组`,
  key1003172: `创建分组`,
  key1003173: `客户编号`,
  key1003174: `请输入客户编号，支持多个逗号或换行分隔`,
  key1003175: `是否确认启用？`,
  key1003176: `是否确认停用？`,
  key1003177: `仅待审核客户可进行审核，请重新选择!`,
  key1003178: `请先勾选要审核的数据`,
  key1003179: `未分组`,
  key1003180: `客户名称`,
  key1003181: `客户分组`,
  key1003182: `客户标签`,
  key1003183: `客户等级`,
  key1003184: `业务类型`,
  key1003185: `客户币种`,
  key1003186: `余额`,
  key1003187: `预扣金额`,
  key1003188: `信用额度`,
  key1003189: `已使用额度`,
  key1003190: `注册来源`,
  key1003191: `客户备注`,
  key1003192: `请先选择客户`,
  key1003193: `注册时间：`,
  key1003194: `注册来源：`,
  key1003195: `请选择注册来源`,
  key1003196: `客户标签：`,
  key1003197: `请选择客户标签`,
  key1003198: `请选择客户等级`,
  key1003199: `客户名称/客户编号/联系人/手机/邮箱/备注`,
  key1003200: `客户编号：`,
  key1003201: ` 日志信息`,
  key1003202: `新增客户`,
  key1003203: `移动分组`,
  key1003204: `批量审核`,
  key1003205: `请填写标签名称`,
  key1003206: `创建标签`,
  key1003207: `编辑标签`,
  key1003208: `标签名称：`,
  key1003209: `请输入标签名称`,
  key1003210: `标签备注：`,
  key1003211: `请选择分组`,
  key1003212: `指定分组：`,
  key1003213: `本次操作中存在删除分组行为，请为分组下的客户重新进行分组`,
  key1003214: `通途商户号不能为空`,
  key1003215: `查看客户`,
  key1003216: `非通途客户`,
  key1003217: `通途客户`,
  key1003218: `标签名称`,
  key1003219: `标签客户数量`,
  key1003220: `标签备注`,
  key1003221: `删除标签提示`,
  key1003222: `删除标签后，此标签将同步从客户上去除，请确认是否删除？`,
  key1003223: `标签详情`,
  key1003224: `标签基本信息`,
  key1003225: `标签类型：`,
  key1003226: `标签数据`,
  key1003227: `链接名称`,
  key1003228: `链接类型`,
  key1003229: `查看二维码`,
  key1003230: `复制链接`,
  key1003231: `统计时间：`,
  key1003232: `搜索链接名称`,
  key1003233: `请选择标签类型`,
  key1003234: `搜索标签名称`,
  key1003235: `请填写分组名称`,
  key1003236: `最多输入20个字符`,
  key1003237: `编辑分组`,
  key1003238: `分组名称：`,
  key1003239: `请输入分组名称`,
  key1003240: `分组备注：`,
  key1003241: `新增客户等级`,
  key1003242: `等级`,
  key1003243: `查看客户等级`,
  key1003244: `编辑客户等级`,
  key1003245: `是否要删除当前客户等级？`,
  key1003246: `等级折扣系数`,
  key1003247: `注册时默认等级`,
  key1003248: `默认`,
  key1003249: `更换注册默认等级`,
  key1003250: `当前操作将会影响商城客户注册时的默认等级，是否确认更换默认等级？`,
  key1003251: `等级折扣系数不能为空`,
  key1003252: `等级折扣系数必须大于 0 且小于等于 1`,
  key1003253: `等级折扣系数：`,
  key1003254: `设置成功`,
  key1003255: `单位换算`,
  key1003256: `平台属性单位`,
  key1003257: `编号`,
  key1003258: `规格/普通属性`,
  key1003259: `是否尺码属性`,
  key1003260: `规格/普通属性(规格、普通)`,
  key1003261: `是否自定义(是、否)`,
  key1003262: `属性值单选/多选(多选、单选)`,
  key1003263: `是否尺码属性(是、否)`,
  key1003264: `填写要求(必填、非必填、推荐填写)`,
  key1003265: `属性信息`,
  key1003266: `中文-简体`,
  key1003267: `法语`,
  key1003268: `德语`,
  key1003269: `西班牙语`,
  key1003270: `荷兰语`,
  key1003271: `波兰语`,
  key1003272: `葡萄牙语`,
  key1003273: `意大利语`,
  key1003274: `属性状态`,
  key1003275: `属性值/单位信息`,
  key1003276: `属性删除提示`,
  key1003277: `本次修改中存在删除属性行为，删除后现有商品信息中该属性字段将一并删除，请确认是否保存此次修改？`,
  key1003278: `停用属性后，供应商发布新商品和修改已发布的商品时，此属性将不可使用，你确定要停用?`,
  key1003279: `立即停用`,
  key1003280: `属性名称：`,
  key1003281: `请输入属性名称，支持多语种搜索`,
  key1003282: `是否自定义：`,
  key1003283: `单选/多选：`,
  key1003284: `物品属性导入`,
  key1003285: `导出属性`,
  key1003286: `2.当导入数据存在异常时，数据导入失败。`,
  key1003287: `暂无日志内容`,
  key1003288: `新值：`,
  key1003289: `暂无操作日志`,
  key1003290: `部位`,
  key1003291: `单位`,
  key1003292: `是否要删除当前尺码模板？`,
  key1003293: `新增模板`,
  key1003294: `标签商品数量`,
  key1003295: `标签名称不能为空`,
  key1003296: `标签`,
  key1003297: `删除标签后，此标签将同步从商品上去除，请确认是否删除？`,
  key1003298: `中心仓批发价（`,
  key1003299: `供应商仓直发价（`,
  key1003300: `供应商仓直发`,
  key1003301: `供应商仓直发批发价（`,
  key1003302: `供应商信息`,
  key1003303: `商品分类`,
  key1003304: `商品标签`,
  key1003305: `请输入供应商SKU,支持多个按行分隔`,
  key1003306: `以SPU维度导出`,
  key1003307: `(报表中每个SPU一行)`,
  key1003308: `以SKU维度导出`,
  key1003309: `(报表中每个SKU一行)`,
  key1003310: `最小值`,
  key1003311: `最大值`,
  key1003312: `供货仓库存`,
  key1003313: `直发仓库存`,
  key1003314: `未删除`,
  key1003315: `商品上架时间`,
  key1003316: `删除时间`,
  key1003317: `销售状态`,
  key1003318: `最后上架时间`,
  key1003319: `最近停售时间`,
  key1003320: `首次提交审核时间`,
  key1003321: `首次上架时间`,
  key1003322: `供货价（包含多个国家）`,
  key1003323: `中心仓销售价（包含多个国家）`,
  key1003324: `中心仓批发价（包含多个国家）`,
  key1003325: `供应商仓直发价`,
  key1003326: `供应商直发销售价`,
  key1003327: `供应商仓批发价`,
  key1003328: `商品类型`,
  key1003329: `供货仓库存库存`,
  key1003330: `中心仓零售价（包含多个国家）`,
  key1003331: `供应商直发零售价（包含多个国家）`,
  key1003332: `查询中...`,
  key1003333: `请先勾选需要停售的数据！`,
  key1003334: `当前筛选结果暂无数据，无法操作停售！`,
  key1003335: `库存最小值不可大于最大值，请修改条件后再查询。`,
  key1003336: `请先选择商品`,
  key1003337: `查看SKU`,
  key1003338: `查看中心仓库存`,
  key1003339: `查看供应商库存`,
  key1003340: `1688找同款`,
  key1003341: `商品售卖国/地区修改`,
  key1003342: `请输入中文标题,支持多个按行分隔`,
  key1003343: `供应商：`,
  key1003344: `商品类型：`,
  key1003345: `商品标签：`,
  key1003346: `请选择商品标签`,
  key1003347: `供应商是否已删除：`,
  key1003348: `发货仓国家：`,
  key1003349: `发货仓类型：`,
  key1003350: `导出商品列表`,
  key1003351: `SKU数量（`,
  key1003352: `供应商名称：`,
  key1003353: `供应商商户号：`,
  key1003354: ` (供应商直发仓)`,
  key1003355: ` (中心仓)`,
  key1003356: `直发仓库存：`,
  key1003357: `中心仓库存：`,
  key1003358: `供货仓库存：`,
  key1003359: `查看全部（`,
  key1003360: `批量停售`,
  key1003361: `按选中停售`,
  key1003362: `按查询结果停售`,
  key1003363: `仓储与价格`,
  key1003364: `取消选择`,
  key1003365: `销售价`,
  key1003366: `导出平台自营商品`,
  key1003367: `库存：`,
  key1003368: `添加平台`,
  key1003369: `平台不能为空`,
  key1003370: `站点不能为空`,
  key1003371: `平台属性`,
  key1003372: `平台属性值类型`,
  key1003373: `编辑平台`,
  key1003374: `查看平台`,
  key1003375: `（已映射）`,
  key1003376: `Product Type不能为空`,
  key1003377: `FamiltType不能为空`,
  key1003378: `自定义值`,
  key1003379: `开始匹配`,
  key1003380: `正在匹配中...`,
  key1003381: `匹配数据获取完成`,
  key1003382: `数据匹配中`,
  key1003383: `接口请求错误，可能导致数据匹配不全`,
  key1003384: `名称数据匹配`,
  key1003385: `类目不能为空`,
  key1003386: `1. 选择平台`,
  key1003387: `2. 选择站点`,
  key1003388: `4. 选择Product Type`,
  key1003389: `4. 选择Family Type`,
  key1003390: `5. 商品规格映射`,
  key1003391: `6. 商品属性映射`,
  key1003392: `平台属性变更，原值：`,
  key1003393: `选择站点`,
  key1003394: `商品规格映射`,
  key1003395: `属性:`,
  key1003396: `已映射:`,
  key1003397: `待映射:`,
  key1003398: `属性值:`,
  key1003399: `属性值已映射:`,
  key1003400: `属性值待映射:`,
  key1003401: `自动匹配`,
  key1003402: `正在匹配中，请稍后...`,
  key1003403: `自动匹配完成，已匹配属性：`,
  key1003404: `已匹配属性值：`,
  key1003405: `查看更多可选值`,
  key1003406: `无数据`,
  key1003407: `商品属性映射`,
  key1003408: `关联属性：`,
  key1003409: `阶梯销售价分层数值不能为空！`,
  key1003410: `商品价格配置`,
  key1003411: `供货价不能为空`,
  key1003412: `商品批发价格`,
  key1003413: `匹配平台销售价规则`,
  key1003414: `匹配平台销售价规则会覆盖商品当前的销售价，请确认是否匹配？`,
  key1003415: `匹配成功`,
  key1003416: `阶梯销售价`,
  key1003417: `自定义属性值`,
  key1003418: `正在搜索`,
  key1003419: `输入文字进行搜索`,
  key1003420: `平台标签属性`,
  key1003421: `映射属性`,
  key1003422: `listing关键词的生成规则`,
  key1003423: `随机`,
  key1003424: `不选`,
  key1003425: `切换Product Type会清空列表数据`,
  key1003426: `请先选择Product Type`,
  key1003427: `平台属性不能重复`,
  key1003428: `未查询到平台类目`,
  key1003429: `平台映射表`,
  key1003430: `电商平台：`,
  key1003431: `站点名称：`,
  key1003432: `分类名称：`,
  key1003433: `加价收取：`,
  key1003434: `服务费收取：`,
  key1003435: `批发加价收取：`,
  key1003436: `批发服务费收取：`,
  key1003437: `商品供货价的：`,
  key1003438: `商品加价后金额的：`,
  key1003439: `产品、操作对象(至少选一个)`,
  key1003440: `固定金额：`,
  key1003441: `供应商货号/SPU`,
  key1003442: `分类`,
  key1003443: `中文品名`,
  key1003444: `供应商商户号 / 名称`,
  key1003445: `审核状态`,
  key1003446: `请勾选需要批量审核的数据!`,
  key1003447: `审核中...`,
  key1003448: `审核成功!`,
  key1003449: `请先勾选需要批量驳回的数据！`,
  key1003450: `批量驳回`,
  key1003451: `不限`,
  key1003452: `5星`,
  key1003453: `4.5星-5.0星`,
  key1003454: `4星-4.5星`,
  key1003455: `4星以下`,
  key1003456: `认证工厂`,
  key1003457: `当日发货`,
  key1003458: `24小时发货`,
  key1003459: `48小时发货`,
  key1003460: `7天无理由`,
  key1003461: `一件代发`,
  key1003462: `支持包邮`,
  key1003463: `按价格`,
  key1003464: `按月销量`,
  key1003465: `价格开始区间不能大于价格结束区间`,
  key1003466: `价格区间(CNY)：`,
  key1003467: `综合评分：`,
  key1003468: `24小时揽收率：`,
  key1003469: `48小时揽收率：`,
  key1003470: `搜索关键词：`,
  key1003471: ` 起`,
  key1003472: `起批`,
  key1003473: `分`,
  key1003474: `近30天成交：`,
  key1003475: `同一列部位的中文名称不能重复！`,
  key1003476: `部位1`,
  key1003477: `英文名称`,
  key1003478: ` 荷兰语名称`,
  key1003479: `同一列的部位多语种名称必须填写完整或全为空！`,
  key1003480: `单位名称不能为空！`,
  key1003481: `新增模板成功！`,
  key1003482: `更新模板成功！`,
  key1003483: `上移`,
  key1003484: `下移`,
  key1003485: `不能选择重复的单位值！`,
  key1003486: `中文名称不能为空！`,
  key1003487: `尺码表模板名称`,
  key1003488: `新增部位`,
  key1003489: `新增单位`,
  key1003490: `商品规格中只能有一个是尺码属性！`,
  key1003491: `请先选择属性池数据！`,
  key1003492: `属性池管理`,
  key1003493: `请输入属性中文名称`,
  key1003494: `您确认`,
  key1003495: `这个平台吗？`,
  key1003496: `商品总数：`,
  key1003497: `您确认删除这条内容吗？`,
  key1003498: `报关编码不能为空`,
  key1003499: `中文报关名称不能为空`,
  key1003500: `英文报关名称不能为空`,
  key1003501: `尺码表模板不能为空`,
  key1003502: `站点`,
  key1003503: `修改`,
  key1003504: `是否将其他物品属性listing关键词的生成规则更新为当前生成规则`,
  key1003505: `同步`,
  key1003506: `定制部位中文名称`,
  key1003507: `主属性设置`,
  key1003508: `主属性`,
  key1003509: `设为主属性`,
  key1003510: `只能同级拖动`,
  key1003511: `请先设置商品规格的主属性！`,
  key1003512: `是否要删除当前分类？`,
  key1003513: `不能包含->特殊字符`,
  key1003514: `文件格式有误, 仅支持上传xls、xlsx格式文件`,
  key1003515: `分类下已存在支持定制的商品，不可将分类设置为不允许商品定制。`,
  key1003516: `输入关键词搜索`,
  key1003517: `分类ID：`,
  key1003518: `父级类目已配置不展示，此类目不展示于商城。`,
  key1003519: `报关编码：`,
  key1003520: `中文报关名称：`,
  key1003521: `英文报关名称：`,
  key1003522: `尺码表模板：`,
  key1003523: `编辑失败提示`,
  key1003524: `新增子分类`,
  key1003525: `导入映射`,
  key1003526: `分类信息`,
  key1003527: `商城展示配置：`,
  key1003528: `不展示`,
  key1003529: `平台信息`,
  key1003530: `报关信息`,
  key1003531: `商品定制部位`,
  key1003532: `此类目商品是否能定制：`,
  key1003533: `新增定制部位`,
  key1003534: `您编辑的原定制部位名称为`,
  key1003535: `的部位，因已有商品设置使用，停用/编辑名称失败。`,
  key1003536: `请问是否忽略上述定制部位修改内容，保存其他已编辑内容？`,
  key1003537: `打印面单`,
  key1003538: `编辑定制部位`,
  key1003539: `查看定制部位`,
  key1003540: `位置状态：`,
  key1003541: `运行中，规则不可调整（`,
  key1003542: `商品的SPU为：`,
  key1003543: `商品的SKU为：`,
  key1003544: `商品的分类为：`,
  key1003545: `商品的发货地为：`,
  key1003546: `，并且发货仓为：`,
  key1003547: `发货仓为：`,
  key1003548: `商品的供应商为：`,
  key1003549: `购买商品的分销商等级为：`,
  key1003550: `购买商品的分销商为：`,
  key1003551: `点击确定执行后，系统会使用当前规则计算商品销售价，`,
  key1003552: `并替换商品此前销售价`,
  key1003553: `（包括手动修改内容），请问是否确认执行？`,
  key1003554: `商品加价配置`,
  key1003555: `商品平台服务费配置`,
  key1003556: `公共配置`,
  key1003557: `特殊配置`,
  key1003558: `商品加价配置规则`,
  key1003559: `商品服务费配置规则`,
  key1003560: `最后修改人`,
  key1003561: `新建公共规则`,
  key1003562: `新建特殊规则`,
  key1003563: `已完成`,
  key1003564: `已停止`,
  key1003565: `商品加价金额计算优先匹配“特殊规则”，若未匹配到，再进行公共规则匹配；若二者均未匹配到，则商品加价金额 = 0;`,
  key1003566: `商品平台服务费计算优先匹配“特殊规则”，若未匹配到，再进行公共规则匹配：若二者均未匹配到，则商品平台服务费 = 0;`,
  key1003567: `启用提示`,
  key1003568: `是否确认启用此规则？`,
  key1003569: `是否确认停用此规则？`,
  key1003570: `是否确认删除此规则？删除后数据无法恢复，请谨慎操作！`,
  key1003571: `<span class="themeColor">平台所有商品</span>`,
  key1003572: `商品零售加价金额`,
  key1003573: `商品零售服务费`,
  key1003574: `商品批发加价金额`,
  key1003575: `商品批发服务费`,
  key1003576: `商品供货价的`,
  key1003577: `商品加价后金额的`,
  key1003578: `商品加价金额`,
  key1003579: `商品服务费`,
  key1003580: `规则执行确认`,
  key1003581: `操作“规则执行”后系统会自动运行任务，根据最新的“加价规则”、“服务费规则”计算商品销售价，任务运行过程中规则不可调整，仅可查看`,
  key1003582: `规则内容：`,
  key1003583: `例如：规则中分销商商户号、供应商商户号、分类名称、商品发货地名称等`,
  key1003584: `最近更新商品销售价时间：`,
  key1003585: `商品销售价=商品供货价+商品加价金额+商品服务费；`,
  key1003586: `商品销售价规则计算任务：`,
  key1003587: `停止`,
  key1003588: `规则执行`,
  key1003589: `请输入打款密码`,
  key1003590: `账单打款确认`,
  key1003591: `打款密码：`,
  key1003592: `是否已核对账单无误，确认打款后款项将直接通过支付宝转账至供应商账户中，请谨慎操作。`,
  key1003593: `账单周期：`,
  key1003594: `账单生成时间：`,
  key1003595: `总利润：`,
  key1003596: `总收入：`,
  key1003597: `总支出：`,
  key1003598: `业务单据号`,
  key1003599: `订单金额`,
  key1003600: `商品成本/供应商结算金额`,
  key1003601: `订单利润`,
  key1003602: `请输入分销商商户号`,
  key1003603: `请输入供应商商户号`,
  key1003604: `业务单据号：`,
  key1003605: `请输入业务单据号`,
  key1003606: `共 `,
  key1003607: ` 项数据`,
  key1003608: `总计利润金额：`,
  key1003609: `总计订单金额：`,
  key1003610: `账单明细`,
  key1003611: `订单币种`,
  key1003612: `账单号`,
  key1003613: `账单周期`,
  key1003614: `客户商户号`,
  key1003615: `月累计充值金额`,
  key1003616: `支付宝充值金额`,
  key1003617: `手工充值金额`,
  key1003618: `累计消费金额`,
  key1003619: `账单生成时间`,
  key1003620: `账单信息`,
  key1003621: `所属商户`,
  key1003622: `所属账单`,
  key1003623: `充值流水号`,
  key1003624: `第三方交易号`,
  key1003625: `充值金额`,
  key1003626: `付款方式`,
  key1003627: `充值成功时间`,
  key1003628: `消费记录`,
  key1003629: `第三方单号`,
  key1003630: `货品总数`,
  key1003631: `物流重量(g)`,
  key1003632: `商品金额`,
  key1003633: `预付物流费`,
  key1003634: `实付物流费`,
  key1003635: `预付包裹处理费`,
  key1003636: `实付包裹处理费`,
  key1003637: `退件物流费(CNY)`,
  key1003638: `偏远地区派送费(CNY)`,
  key1003639: `二次派送(CNY)`,
  key1003640: `物流作废费(CNY)`,
  key1003641: `订单完成时间`,
  key1003642: `国内快递费`,
  key1003643: `清关费`,
  key1003644: `账单维度`,
  key1003645: `明细维度`,
  key1003646: `客户账单更新提示`,
  key1003647: `账单数据正在更新中，请等待，更新完毕后提示您进行查看。`,
  key1003648: `账单时间：`,
  key1003649: `客户商户号：`,
  key1003650: `请输入客户商户号`,
  key1003651: `导出客户账单`,
  key1003652: `自有物流费用`,
  key1003653: `货品结算金额`,
  key1003654: `货品金额小计`,
  key1003655: `费用类型`,
  key1003656: `货品数量`,
  key1003657: `SPU近30天累计销量`,
  key1003658: `提单编号`,
  key1003659: `结束装箱时间`,
  key1003660: `揽收时间`,
  key1003661: `订单发货时间`,
  key1003662: `云卖网发货时间`,
  key1003663: `订单创建时间`,
  key1003664: `供应商账单号：`,
  key1003665: `账单结算状态：`,
  key1003666: `账单状态更新时间：`,
  key1003667: `账单金额：`,
  key1003668: `货品金额（应付）：`,
  key1003669: `国内物流费用（应收）：`,
  key1003670: `补贴金额（应付）：`,
  key1003671: `自有物流费用（应付）：`,
  key1003672: `订单处理费（应付）：`,
  key1003673: `货品金额`,
  key1003674: `国内物流费用`,
  key1003675: `补贴金额`,
  key1003676: `账单审核确认`,
  key1003677: `是否已审核账单无误，审核确认后将变为可打款状态。`,
  key1003678: `审核确认`,
  key1003679: `账单线下已打款确认`,
  key1003680: `请确认是否已进行线下打款。`,
  key1003681: `确认线下已打款`,
  key1003682: `国内物流费用为供应商应付项，货品金额、补贴金额、自有物流费用及订单处理费为供应商应收项，计算时请注意`,
  key1003683: `费用明细`,
  key1003684: `线下已打款`,
  key1003685: `账单编号：`,
  key1003686: `账单更新时间：`,
  key1003687: `客户实付物流费：`,
  key1003688: `应付物流费：`,
  key1003689: `其他应付费用：`,
  key1003690: `总费用：`,
  key1003691: `单据号`,
  key1003692: `单据状态`,
  key1003693: `已出库`,
  key1003694: `已揽收`,
  key1003695: `已分拣`,
  key1003696: `已作废`,
  key1003697: `系统计算物流重量(g)`,
  key1003698: `运单号`,
  key1003699: `物流实重(g)`,
  key1003700: `客户实付物流费`,
  key1003701: `应付物流费`,
  key1003702: `未对账`,
  key1003703: `应付其他费用`,
  key1003704: `总费用`,
  key1003705: `盈亏`,
  key1003706: `包裹出库时间`,
  key1003707: `对账数据来源`,
  key1003708: `导入账单`,
  key1003709: `应付物流费不能为空`,
  key1003710: `备注不能为空`,
  key1003711: `账单确认结算`,
  key1003712: `正在操作账单结算，结算后将无法再对账单进行修改。请确认是否结算？`,
  key1003713: `结算成功!`,
  key1003714: `修改币种成功！`,
  key1003715: `应付其他费用：`,
  key1003716: `物流实重(g)：`,
  key1003717: `未对账订单数量：`,
  key1003718: `物流商币种：`,
  key1003719: `仅看亏损订单`,
  key1003720: `仅看未对账订单`,
  key1003721: `盈亏(当前筛选条件)：`,
  key1003722: `操作中`,
  key1003723: `操作失败`,
  key1003724: `流水号`,
  key1003725: `第三方凭证号`,
  key1003726: `第三方凭证`,
  key1003727: `操作金额`,
  key1003728: `操作前余额`,
  key1003729: `操作后余额`,
  key1003730: `操作前可用信用额度`,
  key1003731: `操作后可用信用额度`,
  key1003732: `操作状态`,
  key1003733: `充值状态`,
  key1003734: `操作前信用额度`,
  key1003735: `操作后信用额度`,
  key1003736: `分销商商户号：`,
  key1003737: `充值时间：`,
  key1003738: `操作状态：`,
  key1003739: `流水号：`,
  key1003740: `请输入流水号,支持多个按行分隔`,
  key1003741: `导出充值记录`,
  key1003742: `充值`,
  key1003743: `扣费`,
  key1003744: `月处理订单数：`,
  key1003745: `订单处理费：`,
  key1003746: `订单耗材费：`,
  key1003747: `附加服务费：`,
  key1003748: `退货处理费：`,
  key1003749: `总金额：`,
  key1003750: `客户实付金额：`,
  key1003751: `其他费用：`,
  key1003752: `费用名称`,
  key1003753: `金额`,
  key1003754: `关联单据号`,
  key1003755: `订单内货品数量`,
  key1003756: `订单耗材费`,
  key1003757: `附加服务费`,
  key1003758: `退货处理费`,
  key1003759: `合计`,
  key1003760: `客户实付金额`,
  key1003761: `费用产生时间`,
  key1003762: `修改费用`,
  key1003763: `单据费用`,
  key1003764: `其他费用`,
  key1003765: `订单处理费不能为空`,
  key1003766: `费用金额不能为空`,
  key1003767: `费用名称不能为空`,
  key1003768: `添加费用`,
  key1003769: `添加费用成功`,
  key1003770: `修改费用成功`,
  key1003771: `添加备注成功`,
  key1003772: `费用名称：`,
  key1003773: `费用金额：`,
  key1003774: `+添加费用`,
  key1003775: `分销商货币为`,
  key1003776: `，实际到账`,
  key1003777: `系统汇率：1`,
  key1003778: `现金`,
  key1003779: `分销商商户号不能为空`,
  key1003780: `付款方式不能为空`,
  key1003781: `支付流水号不能为空`,
  key1003782: `充值币种不能为空`,
  key1003783: `充值币种：`,
  key1003784: `操作币种：`,
  key1003785: `充值金额：`,
  key1003786: `操作金额：`,
  key1003787: `自定义的充值面额不能为空！`,
  key1003788: `请上传支付流水图片！`,
  key1003789: `扣费成功！`,
  key1003790: `充值成功！`,
  key1003791: `最多支持上传五个附件！`,
  key1003792: `（分销商币种）`,
  key1003793: `请输入分销商商户号搜索`,
  key1003794: `若充值币种与分销商币种不一致时，系统将按汇率转为分销商币种进行充值。`,
  key1003795: `付款方式：`,
  key1003796: `支付流水号：`,
  key1003797: `自定义`,
  key1003798: `上传附件`,
  key1003799: `供应商账单号`,
  key1003800: `请输入供应商账单号，支持多个逗号或换行分隔`,
  key1003801: `账单金额`,
  key1003802: `账单币种`,
  key1003803: `订单数量`,
  key1003804: `账单结算状态`,
  key1003805: `供应商确认时间`,
  key1003806: `审核时间`,
  key1003807: `打款时间`,
  key1003808: `打款人`,
  key1003809: `打款方式`,
  key1003810: `收款账户信息`,
  key1003811: `开户行`,
  key1003812: `账户`,
  key1003813: `身份证号`,
  key1003814: `账单明细信息`,
  key1003815: `供货价(CNY)`,
  key1003816: `货品金额小计(CNY)`,
  key1003817: `产生费用时间`,
  key1003818: `面单类型`,
  key1003819: `中心仓发货时间`,
  key1003820: `是否中心仓备货`,
  key1003821: `供应商直发自有物流费(CNY)`,
  key1003822: `国内物流费(CNY)`,
  key1003823: `合计金额(CNY)`,
  key1003824: `总账单`,
  key1003825: `仅收款账户为支付宝的才能批量打款！`,
  key1003826: `请先选择账单！`,
  key1003827: `支付宝订单号`,
  key1003828: `账单状态：`,
  key1003829: `可搜索账单号/供应商名称`,
  key1003830: `导出供应商账单`,
  key1003831: `批量打款`,
  key1003832: `批量确认线下打款`,
  key1003833: `总利润`,
  key1003834: `总收入`,
  key1003835: `总支出`,
  key1003836: `平台账单更新提示`,
  key1003837: `开始日期时间 ~ 结束日期时间`,
  key1003838: `导出平台账单`,
  key1003839: `导出账单`,
  key1003840: `物流方式`,
  key1003841: `物流费用`,
  key1003842: `补贴规则`,
  key1003843: `提单重量`,
  key1003844: `提货单内货品数量`,
  key1003845: `准时发货率`,
  key1003846: `入库时间`,
  key1003847: `分拣时间`,
  key1003848: `最后更新人`,
  key1003849: `请输入提单号,支持多个逗号或换行分隔`,
  key1003850: `请输入运单号,支持多个逗号或换行分隔`,
  key1003851: `请输入供应商商户号,支持多个逗号或换行分隔`,
  key1003852: `仅待审核的订单可批量审核！`,
  key1003853: `请先勾选需要审核的数据！`,
  key1003854: `说明`,
  key1003855: `提单内货品数量`,
  key1003856: `重新审核`,
  key1003857: `补贴规则：`,
  key1003858: `请选择补贴规则`,
  key1003859: `物流-快递`,
  key1003860: `物流-上门揽收`,
  key1003861: `.截止`,
  key1003862: `前的`,
  key1003863: `单`,
  key1003864: `按提单个数补贴`,
  key1003865: `按提单重量补贴`,
  key1003866: `无补贴`,
  key1003867: `发货方式`,
  key1003868: `订单发货率`,
  key1003869: `补贴对象`,
  key1003870: `补贴类型`,
  key1003871: `补贴说明`,
  key1003872: `补贴条件`,
  key1003873: `使用`,
  key1003874: `实际数据`,
  key1003875: `补贴计算`,
  key1003876: `1.单个提单补贴：`,
  key1003877: `1.0-1公斤补贴：`,
  key1003878: `2.续重每公斤补贴：`,
  key1003879: `3.单个提单补贴上限：`,
  key1003880: `符合子规则：`,
  key1003881: `符合规则：`,
  key1003882: `补贴手动调整为：`,
  key1003883: `总计：`,
  key1003884: `结算状态`,
  key1003885: `总金额(CNY)`,
  key1003886: `订单处理量`,
  key1003887: `仓库租金`,
  key1003888: `账单更新时间`,
  key1003889: `月订单处理量(CNY)`,
  key1003890: `订单耗材费用(CNY)`,
  key1003891: `附加费用(CNY)`,
  key1003892: `退货处理费用(CNY)`,
  key1003893: `仓库租金(CNY)`,
  key1003894: `订单耗材费用`,
  key1003895: `附加服务费用`,
  key1003896: `退货处理费用`,
  key1003897: `合计总金额`,
  key1003898: `仓储费用重新计算中，请稍候刷新列表查看！`,
  key1003899: `请选勾选需要更新的数据！`,
  key1003900: `导出仓储账单`,
  key1003901: `更新账单`,
  key1003902: `调整后补贴金额不能为空`,
  key1003903: `调整说明不能为空`,
  key1003904: `规则计算补贴：`,
  key1003905: `调整后补贴：`,
  key1003906: `请输入调整后补贴金额`,
  key1003907: `调整说明：`,
  key1003908: `请输入调整说明`,
  key1003909: `分销商`,
  key1003910: `单据编号`,
  key1003911: `账单所属月份`,
  key1003912: `费用流水状态`,
  key1003913: `费用流水状态：`,
  key1003914: `费用产生时间：`,
  key1003915: `账号`,
  key1003916: `月包裹数`,
  key1003917: `账单匹配数量`,
  key1003918: `导出物流账单`,
  key1003919: `导入物流商账单`,
  key1003920: `导入物流账单`,
  key1003921: `1.已结算的账单数据导入后不再进行更新，将显示为失败;`,
  key1003922: `2.支持扩展名:`,
  key1003923: `3.当导入数据存在异常时，数据导入失败;`,
  key1003924: `审核原因不能为空`,
  key1003925: `请选择补贴审核结果：`,
  key1003926: `审核不通过原因：`,
  key1003927: `未设置`,
  key1003928: `设置打款密码`,
  key1003929: `打款密码不能为空`,
  key1003930: `更换成功!`,
  key1003931: `保存成功!`,
  key1003932: `两次输入的密码不一致`,
  key1003933: `已设置`,
  key1003934: `修改打款密码`,
  key1003935: `删除打款密码`,
  key1003936: `请输入打款密码：`,
  key1003937: `新打款密码：`,
  key1003938: `请再次输入新密码：`,
  key1003939: `请再次输入打款密码`,
  key1003940: `请再次输入密码：`,
  key1003941: `账单打款密码`,
  key1003942: `删除密码`,
  key1003943: `删除打款密码后,账单线上打款确认时将不再需要输入密码,请谨慎操作。`,
  key1003944: `月累计充值：`,
  key1003945: `月支付宝累计充值：`,
  key1003946: `月手工累计充值：`,
  key1003947: `月累计消费：`,
  key1003948: `第三方交易凭证`,
  key1003949: `预扣物流费`,
  key1003950: `实扣物流费`,
  key1003951: `偏远地区派送费`,
  key1003952: `物流退件费`,
  key1003953: `二次派送费`,
  key1003954: `物流单作废费`,
  key1003955: `消费记录（订单仅计算已取消及已出库部分）`,
  key1003956: `多个`,
  key1003957: `SKU请换行分隔`,
  key1003958: `提单SKU详情`,
  key1003959: `当前提单内SKU如下图所示，共`,
  key1003960: `种，合计`,
  key1003961: `件。`,
  key1003962: `待上架数量`,
  key1003963: `上架数量`,
  key1003964: `仓库名称不能为空!`,
  key1003965: `库区名称不能为空!`,
  key1003966: `库位名称不能为空!`,
  key1003967: `上架数量不能为空!`,
  key1003968: `上架数量必须是大于0的整数`,
  key1003969: `上架数量不能大于待上架数量!`,
  key1003970: `上架数量必须大于0`,
  key1003971: `货品上架`,
  key1003972: `请输入YMSSKU,支持多个逗号或换行分隔`,
  key1003973: `请输入YMSSPU,支持多个逗号或换行分隔`,
  key1003974: `请输入供应商SKU,支持多个逗号或换行分隔`,
  key1003975: `请输入供应商SPU,支持多个逗号或换行分隔`,
  key1003976: `供应商SKU：`,
  key1003977: `应贴数量`,
  key1003978: `扫描成功！`,
  key1003979: `请输入正确的供应商SKU！`,
  key1003980: `供应商SKU不能为空!`,
  key1003981: `请先勾选要打印的数据！`,
  key1003982: `打印数量不能为空!`,
  key1003983: `扫描或输入供应商SKU`,
  key1003984: `批量打印`,
  key1003985: `正在贴单作业...`,
  key1003986: `结束贴单作业`,
  key1003987: `常规分拣`,
  key1003988: `备货分拣`,
  key1003989: `移除包裹提示`,
  key1003990: `正在操作移除包裹，移除后可重新扫描装箱`,
  key1003991: `还需`,
  key1003992: `移除成功`,
  key1003993: `克`,
  key1003994: `千克`,
  key1003995: `称重单位为：`,
  key1003996: `请输入出库单号或运单号！`,
  key1003997: `称重必须是大于0的整数！`,
  key1003998: `称重不能为空！`,
  key1003999: `此物流渠道需发快递至揽收点，国内快递或物流商、物流单号不能为空！`,
  key1004000: `你还有包裹未完成分拣，你是否结束分拣？`,
  key1004001: `物流分拣异常提示`,
  key1004002: `强制结束`,
  key1004003: `扫描：`,
  key1004004: `可扫描出库单号、运单号、物流商单号、容器编号`,
  key1004005: `称重：`,
  key1004006: `请保持系统重量单位和电子秤重量单位一致`,
  key1004007: `实际称重(`,
  key1004008: `地址`,
  key1004009: `称重`,
  key1004010: `物流渠道：`,
  key1004011: `结束容器分拣`,
  key1004012: `结袋`,
  key1004013: `打印预约交货面单提示`,
  key1004014: `速卖通线上发货需打印预交面单，请结袋后在物流交接单中打印预交面单。`,
  key1004015: `暂不结袋`,
  key1004016: `直接结袋`,
  key1004017: `预约并结袋`,
  key1004018: `打印揽收面单提示`,
  key1004019: `速卖通全托管JIT订单需打印揽收面单，若未打印将无法交付速卖通揽收。`,
  key1004020: `打印并结袋`,
  key1004021: `交接单号`,
  key1004022: `包裹数量`,
  key1004023: `交货方式`,
  key1004024: `物流下发方式`,
  key1004025: `系统下发`,
  key1004026: `手动下发`,
  key1004027: `国内物流单号`,
  key1004028: `交接时间`,
  key1004029: `交接人`,
  key1004030: `标记出库`,
  key1004031: `继续装箱`,
  key1004032: `打印预交面单`,
  key1004033: `打印快递面单`,
  key1004034: `获取快递面单地址失败`,
  key1004035: `预约揽收`,
  key1004036: `打印揽收面单`,
  key1004037: `按创建时间`,
  key1004038: `请输入交接单号,支持多个逗号或换行分隔`,
  key1004039: `请输入出库单号,支持多个逗号或换行分隔`,
  key1004040: `请先勾选要标记出库的数据！`,
  key1004041: `获取预交面单地址失败`,
  key1004042: `预约成功！`,
  key1004043: `获取揽收面单地址失败`,
  key1004044: `交接人：`,
  key1004045: `请输入交接人`,
  key1004046: `排序方式：`,
  key1004047: `三方提单编号`,
  key1004048: `箱/袋内出库单数量`,
  key1004049: `入库成功！`,
  key1004050: `请输入提单号！`,
  key1004051: `请扫描或录入提单号/快递单号/三方提单编号`,
  key1004052: `容器状态`,
  key1004053: `商品数量`,
  key1004054: `作业开始时间`,
  key1004055: `继续上架`,
  key1004056: `实际上架数量`,
  key1004057: `作业结束时间`,
  key1004058: `作业时长`,
  key1004059: `按容器维度导出`,
  key1004060: `按SKU维度导出`,
  key1004061: `容器内SKU数量`,
  key1004062: `货品数`,
  key1004063: `上架库位`,
  key1004064: `待上架`,
  key1004065: `上架中`,
  key1004066: `已上架`,
  key1004067: `提货单号不能为空！`,
  key1004068: `商品上架作业提醒`,
  key1004069: `你有商品上架作业未完成，是否继续作业？`,
  key1004070: `上架作业：`,
  key1004071: `扫描或输入容器编号`,
  key1004072: `支持多个容器编号，用逗号或换行分隔`,
  key1004073: `导出上架数据`,
  key1004074: `容器状态：`,
  key1004075: `贴单作业`,
  key1004076: `继续贴单`,
  key1004077: `待贴单`,
  key1004078: `贴单中`,
  key1004079: `已贴单`,
  key1004080: `容器编号不能为空！`,
  key1004081: `商品贴单作业提醒`,
  key1004082: `你有商品贴单作业未完成，是否继续作业？`,
  key1004083: `贴单作业：`,
  key1004084: `导出贴单数据`,
  key1004085: `请选择仓库`,
  key1004086: `请选择货主`,
  key1004087: `操作数量`,
  key1004088: `收货仓库`,
  key1004089: `盘点仓库`,
  key1004090: `请选择收货仓库`,
  key1004091: `请选择盘点仓库`,
  key1004092: `操作数量必须大于等于1`,
  key1004093: `新建提单`,
  key1004094: `入库类型：`,
  key1004095: `货主：`,
  key1004096: `请输入商户号搜索`,
  key1004097: `第三方提单号：`,
  key1004098: `请输入第三方提单号`,
  key1004099: `请先添加商品数据`,
  key1004100: `明细信息`,
  key1004101: `添加货品`,
  key1004102: `等待揽收`,
  key1004103: `已入库`,
  key1004104: `缺失包裹`,
  key1004105: `入库类型`,
  key1004106: `物流轨迹`,
  key1004107: `应收货品数量`,
  key1004108: `应收部分实收数量`,
  key1004109: `供应商多发数量`,
  key1004110: `异常状态`,
  key1004111: `数量异常，请点击查看`,
  key1004112: `标记已揽收`,
  key1004113: `作废`,
  key1004114: `请输入SKU,支持多个逗号或换行分隔`,
  key1004115: `请输入三方提单编号,支持多个逗号或换行分隔`,
  key1004116: `提货单号`,
  key1004117: `供应商商户名`,
  key1004118: `快递单号`,
  key1004119: `运输方式`,
  key1004120: `按提货单维度导出`,
  key1004121: `请先勾选要标记已揽收的数据！`,
  key1004122: `分拣异常：`,
  key1004123: `揽收时间：`,
  key1004124: `导出提单列表`,
  key1004125: `批量标记已揽收`,
  key1004126: `(已取消)`,
  key1004127: `包裹实重（g）`,
  key1004128: `数据来源`,
  key1004129: `称重员`,
  key1004130: `已装箱`,
  key1004131: `移除成功！`,
  key1004132: `出库时间：`,
  key1004133: `发货设置`,
  key1004134: `单位：`,
  key1004135: `截去：`,
  key1004136: `部分物流商面单扫描的运单号会带前缀或后缀，这样系统就无法识别运单号，勾选可截去相对应的前缀或后缀。`,
  key1004137: `开启(必填)`,
  key1004138: `开启(非必填)`,
  key1004139: `不开启`,
  key1004140: `前`,
  key1004141: `后`,
  key1004142: `TEMU标签号`,
  key1004143: `是否已扫描`,
  key1004144: `重量（g）`,
  key1004145: `打印打包标签`,
  key1004146: `请扫描TEMU标签号！`,
  key1004147: `扫描成功`,
  key1004148: `请扫描所有TEMU小包后再进行结袋操作。`,
  key1004149: `未获取到面单地址！`,
  key1004150: `请扫描TEMU标签号`,
  key1004151: `请输入作废原因`,
  key1004152: `作废成功！`,
  key1004153: `作废提单确认`,
  key1004154: `作废原因：`,
  key1004155: `作废提单后，未发货订单将重新流转至供应商待发货列表中。`,
  key1004156: `确认作废`,
  key1004157: `分拣容器：`,
  key1004158: `提单编号：`,
  key1004159: `分拣时间：`,
  key1004160: `请先扫描提单号！`,
  key1004161: `撤销操作提示`,
  key1004162: `撤销后，对应容器中的SKU将移除，请谨慎操作。`,
  key1004163: `撤销`,
  key1004164: `扫描记录`,
  key1004165: `撤销操作`,
  key1004166: `容器已结束不可撤销`,
  key1004167: `实收数量`,
  key1004168: `目的仓库`,
  key1004169: `操作内容/留言`,
  key1004170: `请输入备注内容！`,
  key1004171: `提单中存在多发货品，`,
  key1004172: `将作为备货进行处理，并已自动创建相应备货单号，类型为多发补单`,
  key1004173: `提单号：`,
  key1004174: `提单类型：`,
  key1004175: `三方提单编号：`,
  key1004176: `提单申明数量及实际到仓数量`,
  key1004177: `销售订单：`,
  key1004178: `备货单：`,
  key1004179: `多发货品数量`,
  key1004180: `提货单状态`,
  key1004181: `提货单类型`,
  key1004182: `出库单数量`,
  key1004183: `分拣作业`,
  key1004184: `提货单货品数`,
  key1004185: `实际分拣数量`,
  key1004186: `分拣容器`,
  key1004187: `sku数量`,
  key1004188: `入库操作时间`,
  key1004189: `分拣开始时间`,
  key1004190: `分拣结束时间`,
  key1004191: `分拣结束操作人`,
  key1004192: `待分拣`,
  key1004193: `分拣中`,
  key1004194: `入库分拣作业提醒`,
  key1004195: `你有入库分拣作业未完成，是否继续作业？`,
  key1004196: `分拣作业：`,
  key1004197: `扫描或输入提单号/快递单号/三方提单编号`,
  key1004198: `导出分拣数据`,
  key1004199: `进入作业界面`,
  key1004200: `提货单状态：`,
  key1004201: `应上架数量`,
  key1004202: `存在异常SKU，请检查后重试`,
  key1004203: `上架数据未填写完整`,
  key1004204: `上架异常提示`,
  key1004205: `上架数量不能超出待上架数量`,
  key1004206: `库区库位未填写`,
  key1004207: `部分上架`,
  key1004208: `结束上架`,
  key1004209: `SKU上架数量与待上架数量不一致，详情如下，请确认是否结束上架？`,
  key1004210: `继续作业`,
  key1004211: `已在`,
  key1004212: `容器中存在相同SKU，请结束`,
  key1004213: `容器后重新扫描提单`,
  key1004214: `SKU/供应商SKU/物流面单不能不为空！`,
  key1004215: `应收数量`,
  key1004216: `分拣数量`,
  key1004217: `还需分拣`,
  key1004218: `已扫数量`,
  key1004219: `请扫描商品`,
  key1004220: `已分拣数量`,
  key1004221: `未分拣`,
  key1004222: `提货单号不能为空!`,
  key1004223: `当前容器已经完拣，需要重新绑定`,
  key1004224: `提货单中没有此商品，请仔细确认！`,
  key1004225: `此包裹已被分拣，请勿重复扫描`,
  key1004226: `容器完拣提示`,
  key1004227: `此容器拣货数量已达上限，系统将自动将容器完拣，请绑定新容器继续作业。`,
  key1004228: `此容器包装数量已达上限，系统将自动将容器完拣，请绑定新容器继续作业。`,
  key1004229: `结束分拣作业`,
  key1004230: `将同时结束提货单与容器分拣，你确定要结束？`,
  key1004231: `结束分拣`,
  key1004232: `容器颜色重复提示`,
  key1004233: `此颜色容器已存在，请选择不同颜色的容器。`,
  key1004234: `设置容器颜色提示`,
  key1004235: `此容器无颜色，请选择具有颜色属性的容器。`,
  key1004236: `请先扫描提单号!`,
  key1004237: `容器编号不能为空!`,
  key1004238: `请选择面单类型！`,
  key1004239: `SKU超出应收提示`,
  key1004240: `正在进行作业的SKU已超出应收数量，分拣完成后若存在超出应收数量的SKU，系统将自动进行补单并向供应商发送提示，无需人工操作。`,
  key1004241: `此SKU需进行上架，暂未绑定贴单+上架容器，请绑定贴单+上架容器：`,
  key1004242: `此SKU需进行上架，暂未绑定上架容器，请绑定上架容器：`,
  key1004243: `SKU数量异常提示`,
  key1004244: `以下SKU数量与应发数量有差异，结束分拣后实际多收的SKU系统将自动进行补单并向供应商发送提示。`,
  key1004245: `扫描或输入`,
  key1004246: `SKU/供应商SKU/物流面单`,
  key1004247: `扫描或输入提货单号`,
  key1004248: `请扫描或输入容器编号`,
  key1004249: `订单号：`,
  key1004250: `正在分拣作业...`,
  key1004251: `结束本单分拣`,
  key1004252: `逐件扫描`,
  key1004253: `超出应发数量是否提示`,
  key1004254: `启用语音播报`,
  key1004255: `需贴单`,
  key1004256: `请添加容器`,
  key1004257: `容器完拣`,
  key1004258: `找到多种类型面单，请正确选择！`,
  key1004259: `暂不处理`,
  key1004260: `绑定容器`,
  key1004261: `请选择国内快递`,
  key1004262: `国内快递选择`,
  key1004263: `下单方式：`,
  key1004264: `国内快递：`,
  key1004265: `此物流渠道需发快递至揽收点，结袋后请将此渠道下的所有包裹再次打包，最外层贴国内快递面单！`,
  key1004266: `系统下单`,
  key1004267: `线下下单`,
  key1004268: `补收费用不能为空`,
  key1004269: `补收费用必须大于 0`,
  key1004270: `物流费补收`,
  key1004271: `补收类型：`,
  key1004272: `补收费用：`,
  key1004273: `请输入补收费用`,
  key1004274: `原物流商`,
  key1004275: `原物流方式`,
  key1004276: `目的地`,
  key1004277: `原因`,
  key1004278: `未选择数据`,
  key1004279: `请选择物流渠道`,
  key1004280: `账号不能为空`,
  key1004281: `修改物流方式`,
  key1004282: `选择修改后物流方式：`,
  key1004283: `账号：`,
  key1004284: `修改失败数据`,
  key1004285: `物流动态参数`,
  key1004286: `确认修改`,
  key1004287: `请输入取消`,
  key1004288: `订单原因`,
  key1004289: `订单原因，此原因分销商可见。`,
  key1004290: `取消订单`,
  key1004291: `订单取消原因：`,
  key1004292: `确认取消`,
  key1004293: `收款渠道`,
  key1004294: `收款账户`,
  key1004295: `补充收款信息`,
  key1004296: `创建日期`,
  key1004297: `启用中`,
  key1004298: `编辑&查看`,
  key1004299: `删除确认`,
  key1004300: `是否确认删除该信息？`,
  key1004301: `确认删除`,
  key1004302: `删除成功!`,
  key1004303: `收款渠道：`,
  key1004304: `收款账户：`,
  key1004305: `新增收款账户`,
  key1004306: `商品为定制商品，原SKU表示原基础定制商品模板的SKU`,
  key1004307: `原SKU：`,
  key1004308: `平台自营`,
  key1004309: `的供应商订单总金额和分销商订单总金额不能为空`,
  key1004310: `保存并下单成功`,
  key1004311: `供应商订单总金额：`,
  key1004312: `分销商订单总金额：`,
  key1004313: `分销商应付金额：`,
  key1004314: `供应商应收金额：`,
  key1004315: `保存并下单`,
  key1004316: `收货数量`,
  key1004317: `取消数量`,
  key1004318: `退款数量`,
  key1004319: `待调价`,
  key1004320: `待供应商接单`,
  key1004321: `待分销商付款`,
  key1004322: `待入库`,
  key1004323: `请输入SPU，支持多个逗号或换行分隔`,
  key1004324: `请输入SKU，支持多个逗号或换行分隔`,
  key1004325: `请输入分销商商户号，支持多个逗号或换行分隔`,
  key1004326: `请输入供应商商户号，支持多个逗号或换行分隔`,
  key1004327: `已发货`,
  key1004328: `待重发`,
  key1004329: `下单确认`,
  key1004330: `正在操作下单。请确认是否下单？`,
  key1004331: `确认下单`,
  key1004332: `下单成功！`,
  key1004333: `取消成功！`,
  key1004334: `备货单状态：`,
  key1004335: `备货单号：`,
  key1004336: `请输入备货单号,支持多个按行分隔`,
  key1004337: `下单时间：`,
  key1004338: `付款时间：`,
  key1004339: `完结时间：`,
  key1004340: `订单金额：`,
  key1004341: `订单原金额：`,
  key1004342: `调价后金额：`,
  key1004343: `已取消金额：`,
  key1004344: `已退款金额：`,
  key1004345: `分销商：`,
  key1004346: `供应商子单单号：`,
  key1004347: `发货时间：`,
  key1004348: `入库时间：`,
  key1004349: `金额：`,
  key1004350: `调价：`,
  key1004351: `结算：`,
  key1004352: `原单价：`,
  key1004353: `调价后：`,
  key1004354: `单价：`,
  key1004355: `订单数量：`,
  key1004356: `收货数量：`,
  key1004357: `上架数量：`,
  key1004358: `取消数量：`,
  key1004359: `退款数量：`,
  key1004360: `缺货数量：`,
  key1004361: `预计到货时间：`,
  key1004362: `单号：`,
  key1004363: `异常状态：`,
  key1004364: `补货中`,
  key1004365: `已发货（`,
  key1004366: `包装尺寸（长、宽、高 cm）`,
  key1004367: `已分配数量`,
  key1004368: `行号`,
  key1004369: `供应商订单号`,
  key1004370: `物品数量`,
  key1004371: `出库单状态`,
  key1004372: `缺货状态`,
  key1004373: `缺货中，请查看详情`,
  key1004374: `订单状态更新时间`,
  key1004375: `是否作废`,
  key1004376: `未作废`,
  key1004377: `详情`,
  key1004378: `中文申报名`,
  key1004379: `英文申报名`,
  key1004380: `申报价值`,
  key1004381: `申报重量`,
  key1004382: `申报数量`,
  key1004383: `海关编码`,
  key1004384: `销售链接`,
  key1004385: `申报信息`,
  key1004386: `日志内容描述`,
  key1004387: `面单类型：`,
  key1004388: `分销商订单号：`,
  key1004389: `发货仓库：`,
  key1004390: `收货人名称：`,
  key1004391: `买家识别号：`,
  key1004392: `详细地址1：`,
  key1004393: `详细地址2：`,
  key1004394: `物流商单号：`,
  key1004395: `邮寄方式：`,
  key1004396: `运单号1：`,
  key1004397: `运单号2：`,
  key1004398: `物流商称重（g）：`,
  key1004399: `物流商运费：`,
  key1004400: `订单预估称重（g）：`,
  key1004401: `订单实际称重（g）：`,
  key1004402: `物流商预估运费：`,
  key1004403: `物流商实际运费：`,
  key1004404: `物流三方单号：`,
  key1004405: `Temu标签号`,
  key1004406: `SKU*数量`,
  key1004407: `包裹重量(g)`,
  key1004408: `暂无打包标签`,
  key1004409: `Temu 样`,
  key1004410: `Temu 货`,
  key1004411: `已配货`,
  key1004412: `已拣货`,
  key1004413: `已备货`,
  key1004414: `新增行请填写完整`,
  key1004415: `请先添加申报信息！`,
  key1004416: `当前小包未进行物流分拣，无法打印箱唛`,
  key1004417: `主信息`,
  key1004418: `收货人信息`,
  key1004419: `物流商信息`,
  key1004420: `订单详情：`,
  key1004421: `订单商品`,
  key1004422: `供应商子单`,
  key1004423: `打包信息`,
  key1004424: `出库单类型：`,
  key1004425: `到仓时间：`,
  key1004426: `所有SKU`,
  key1004427: `到仓异常数量SKU`,
  key1004428: `发起备货数量`,
  key1004429: `实际到仓数量`,
  key1004430: `sku信息`,
  key1004431: `订单号，支持多个逗号或换行分隔`,
  key1004432: `订单信息`,
  key1004433: `订单SKU信息`,
  key1004434: `运营`,
  key1004435: `分销商订单号`,
  key1004436: `请输入分销商订单号，支持多个逗号或换行分隔`,
  key1004437: `请输入供应商订单号，支持多个逗号或换行分隔`,
  key1004438: `请输入运单号，支持多个逗号或换行分隔`,
  key1004439: `请输入Temu标签号，支持多个逗号或换行分隔`,
  key1004440: `物流商单号`,
  key1004441: `请输入物流商单号，支持多个逗号或换行分隔`,
  key1004442: `物流三方单号`,
  key1004443: `请输入物流三方单号，支持多个逗号或换行分隔`,
  key1004444: `发货信息`,
  key1004445: `供应商子单信息`,
  key1004446: `待下发`,
  key1004447: `下发中`,
  key1004448: `下发成功`,
  key1004449: `下发失败`,
  key1004450: `自有渠道`,
  key1004451: `三方渠道`,
  key1004452: `商品费用(CNY)`,
  key1004453: `总费用(CNY)`,
  key1004454: `实收处理费(CNY)`,
  key1004455: `预收处理费(CNY)`,
  key1004456: `预付物流费(CNY)`,
  key1004457: `实付物流费(CNY)`,
  key1004458: `运单号1`,
  key1004459: `运单号2`,
  key1004460: `供应商出库时间`,
  key1004461: `提单揽收时间`,
  key1004462: `订单取消时间`,
  key1004463: `订单取消原因`,
  key1004464: `订单类型`,
  key1004465: `订单标签`,
  key1004466: `SKU单价`,
  key1004467: `平台订单信息`,
  key1004468: `平台站点`,
  key1004469: `店铺名`,
  key1004470: `平台订单号`,
  key1004471: `平台订单金额`,
  key1004472: `平台订单状态`,
  key1004473: `平台订单SKU信息`,
  key1004474: `下单时间`,
  key1004475: `付款时间`,
  key1004476: `订单维度`,
  key1004477: `SKU维度`,
  key1004478: `(列)`,
  key1004479: `(行)`,
  key1004480: `按行展示时，通用信息将进行合并，统计时请注意。`,
  key1004481: `状态更新时间`,
  key1004482: `按更新时间`,
  key1004483: `待交付物流商`,
  key1004484: `供应商自有物流`,
  key1004485: `单次最多查询1000条，请调整后重试。`,
  key1004486: `（待执行发货）`,
  key1004487: `(原：`,
  key1004488: `分销商自有物流`,
  key1004489: `请选择已付款且下发状态为待下发或下发失败的订单进行下发物流！`,
  key1004490: `请先勾选要下发物流的数据！`,
  key1004491: `请先勾选要修改的数据！`,
  key1004492: `请选择发货仓一致的订单进行批量修改物流方式！`,
  key1004493: `请先勾选要添加标签的数据！`,
  key1004494: `删除标签确认`,
  key1004495: `正在操作删除订单标签。请确认是否删除?`,
  key1004496: `更新承运商`,
  key1004497: `添加承运商`,
  key1004498: `获取中...`,
  key1004499: `SKU，支持多个逗号或换行分隔`,
  key1004500: `SPU，支持多个逗号或换行分隔`,
  key1004501: `订单标签：`,
  key1004502: `下发状态：`,
  key1004503: `订单类型：`,
  key1004504: `来源：`,
  key1004505: `履约方：`,
  key1004506: `是否存在平台自营商品：`,
  key1004507: `是云卖物流或来源为自有渠道的数据，才能修改物流方式！`,
  key1004508: `需通过快递发至揽收点的包裹将加收国内快递费。`,
  key1004509: `重新获取`,
  key1004510: `实重导入`,
  key1004511: `物品数量：`,
  key1004512: `状态更新时间：`,
  key1004513: `订单创建时间：`,
  key1004514: `订单发货时间：`,
  key1004515: `订单取消时间：`,
  key1004516: `查看更多（`,
  key1004517: `剩余`,
  key1004518: `个）`,
  key1004519: `国内快递费：`,
  key1004520: `货品金额：`,
  key1004521: `预收处理费：`,
  key1004522: `实收处理费：`,
  key1004523: `实付物流费：`,
  key1004524: `预付物流费：`,
  key1004525: `清关费：`,
  key1004526: `偏远地区派送费：`,
  key1004527: `物流退件费：`,
  key1004528: `二次派送费：`,
  key1004529: `物流单作废费：`,
  key1004530: `国内快递单号：`,
  key1004531: `客选物流：`,
  key1004532: `个供应商子单`,
  key1004533: `下发物流`,
  key1004534: `订单编号：`,
  key1004535: `(待手动下发)`,
  key1004536: `(未匹配到基础物流，请手动修改物流渠道)`,
  key1004537: `正在获取运单号中，请稍后`,
  key1004538: `获取运单号失败，请手动尝试获取`,
  key1004539: `下载面单`,
  key1004540: `查看子单`,
  key1004541: `打印物流面单`,
  key1004542: `通知分销商`,
  key1004543: `1、若文件中运单号与列表中订单运单号匹配，则视为无效内容；`,
  key1004544: `2、若文件中运单号与列表中已上传物流费的条目向匹配，同样视为无效内容；`,
  key1004545: `3、仅支持xls、xlsx格式文件`,
  key1004546: `取消处理费不能为空`,
  key1004547: `已装箱状态允许取消订单确认`,
  key1004548: `取消处理费：`,
  key1004549: `此订单已装箱，请务必确认现场是否未发出，取消后需及时联系相关人员将包裹进行取出。`,
  key1004550: `允许取消订单`,
  key1004551: `产品图片`,
  key1004552: `(原SKU：`,
  key1004553: `缺货信息`,
  key1004554: `供应商订单号：`,
  key1004555: `出库单状态：`,
  key1004556: `货品数量：`,
  key1004557: `已收货`,
  key1004558: `Sku,支持多个逗号或换行分隔`,
  key1004559: `备货单号`,
  key1004560: `出库单类型`,
  key1004561: `请输入备货单号,支持多个逗号或换行分隔`,
  key1004562: `备货单状态`,
  key1004563: `供应商出库单状态`,
  key1004564: `供应商出库单类型`,
  key1004565: `发货时间`,
  key1004566: `取消时间`,
  key1004567: `请选择备货单状态`,
  key1004568: `供应商出库单状态：`,
  key1004569: `请选择出库单状态`,
  key1004570: `供应商出库单类型：`,
  key1004571: `请选择供应商出库单类型`,
  key1004572: `导出订单`,
  key1004573: `订单/分销商备货单号：`,
  key1004574: `，仓库实收数量不足，请至发货记录中查看详情`,
  key1004575: `已作废，需重新发货。`,
  key1004576: `订单/分销商备货单号`,
  key1004577: `订单/分销商备货单号，支持多个逗号或换行分隔`,
  key1004578: `秒`,
  key1004579: `供应商子单号：`,
  key1004580: `剩余发货时间`,
  key1004581: `已超时时间`,
  key1004582: `条码：`,
  key1004583: `到仓数量：`,
  key1004584: `超时时间`,
  key1004585: `完结时间`,
  key1004586: `完结时间指此订单流程已全部结束时间节点，订单将已此节点时间计入对应账期。`,
  key1004587: `标记到货`,
  key1004588: `更新标记`,
  key1004589: `供应商子单号`,
  key1004590: `请输入供应商子单号，支持多个逗号或换行分隔`,
  key1004591: `请输入供应商SKU，支持多个逗号或换行分隔`,
  key1004592: `请输入供应商名称，支持多个逗号或换行分隔`,
  key1004593: `供应商商户编号`,
  key1004594: `订单总金额`,
  key1004595: `子单类型`,
  key1004596: `未入账`,
  key1004597: `结算中`,
  key1004598: `已结算`,
  key1004599: `超时时间开始时长不能大于结束时长`,
  key1004600: `获取标记缺货详情数据失败！`,
  key1004601: `已超时`,
  key1004602: `订单状态：`,
  key1004603: `请选择订单状态`,
  key1004604: `结算状态：`,
  key1004605: `请选择结算状态`,
  key1004606: `超时时间：`,
  key1004607: `收款渠道不能为空`,
  key1004608: `收款账户不能为空`,
  key1004609: `收款币种不能为空`,
  key1004610: `编辑&查看收款账户`,
  key1004611: `请输入收款渠道`,
  key1004612: `请输入收款账户`,
  key1004613: `收款币种：`,
  key1004614: `补充收款信息：`,
  key1004615: `可根据收款渠道，在“补充收款信息”处，补充输入使用该渠道进行支付时所需的必要信息;`,
  key1004616: `支付批次号`,
  key1004617: `订单应付总额`,
  key1004618: `支付渠道`,
  key1004619: `运营收款账户`,
  key1004620: `分销商户号`,
  key1004621: `业务单号`,
  key1004622: `业务金额`,
  key1004623: `支付流水图片`,
  key1004624: `对账状态`,
  key1004625: `对账`,
  key1004626: `待对账`,
  key1004627: `对账通过`,
  key1004628: `对账退回`,
  key1004629: `请先勾选需要操作的数据！`,
  key1004630: `请选择待对账的支付数据进行对账`,
  key1004631: `请输入业务单号,支持多个按行分隔`,
  key1004632: `支付批次号：`,
  key1004633: `请输入支付批次号,支持多个按行分隔`,
  key1004634: `业务单号：`,
  key1004635: `对账状态：`,
  key1004636: `批量对账`,
  key1004637: `添加备注：`,
  key1004638: `订单金额修改`,
  key1004639: `货品金额修改`,
  key1004640: `请选择物流方式`,
  key1004641: `运单号不能为空`,
  key1004642: `修改运单号`,
  key1004643: `物流方式：`,
  key1004644: `请输入运单号`,
  key1004645: `请输入物流商单号`,
  key1004646: `对账退回表示运营方未收到此订单款项或实收与应收金额不符，需分销商重新进行支付，审核通过后，运营方才会对此订单进行履约。`,
  key1004647: `对账通过表示运营方已收到此订单款项，该订单会由运营方进行后续履约。`,
  key1004648: `订单支付对账`,
  key1004649: `请输入退回原因`,
  key1004650: `条信息`,
  key1004651: `对账结果：`,
  key1004652: `退回原因：`,
  key1004653: `开始区间不能大于`,
  key1004654: `结束区间`,
  key1004655: `商品导入`,
  key1004656: `按SKU`,
  key1004657: `规格属性值`,
  key1004658: `货主角色`,
  key1004659: `货主商户号`,
  key1004660: `按产品查询`,
  key1004661: `按产品/库位查询`,
  key1004662: `总库存`,
  key1004663: `作废数量`,
  key1004664: `必须是大于等于0的正整数`,
  key1004665: `明细`,
  key1004666: `SKU，用逗号或换行分隔`,
  key1004667: `SPU，用逗号或换行分隔`,
  key1004668: `多个供应商商户号，用逗号或换行分隔`,
  key1004669: `库位：`,
  key1004670: `请输入库位代码`,
  key1004671: `请输入商户号`,
  key1004672: `分配库存和可用库存的总数量`,
  key1004673: `作废数量：`,
  key1004674: `导出库存余量`,
  key1004675: `导出库存明细`,
  key1004676: `导出库存余量数据`,
  key1004677: `导出库存明细数据`,
  key1004678: `1.导入库存后将覆盖原来库存，请谨慎导入;`,
  key1004679: `库存详情`,
  key1004680: `显示库存为0的数据`,
  key1004681: `你有包装中作业未完成，拣货单号：`,
  key1004682: `，是否继续作业?`,
  key1004683: `包装中`,
  key1004684: `已包装`,
  key1004685: `拣货单号`,
  key1004686: `拣货单状态`,
  key1004687: `出库单数`,
  key1004688: `拣货单类型`,
  key1004689: `拣货/分拣完成时间`,
  key1004690: `拣货/分拣人`,
  key1004691: `包装人`,
  key1004692: `拣货单来源`,
  key1004693: `开始作业`,
  key1004694: `拣货单编号`,
  key1004695: `作业操作人`,
  key1004696: `开始作业时间`,
  key1004697: `结束作业时间`,
  key1004698: `常规包装作业提醒`,
  key1004699: `备货包装作业提醒`,
  key1004700: `处理中....`,
  key1004701: `请输入拣货单号！`,
  key1004702: `常规包装`,
  key1004703: `备货包装`,
  key1004704: `拣货单状态：`,
  key1004705: `包装人：`,
  key1004706: `拣货单号：`,
  key1004707: `请输入拣货单号，支持多个按行分隔`,
  key1004708: `导出多品分拣`,
  key1004709: `扫描拣货单单号/容器编号：`,
  key1004710: `仅按货品库位字符升序`,
  key1004711: `仅按货品库位降序`,
  key1004712: `请至少选择一个常规拣货架！`,
  key1004713: `请至少选择一个备货拣货架！`,
  key1004714: `单品拣货单打印时货品列表输入顺序：`,
  key1004715: `多品拣货单打印时货品列表输入顺序：`,
  key1004716: `集货超时：`,
  key1004717: `分拣时打印地址面单：`,
  key1004718: `分拣时打印商品合规标签：`,
  key1004719: `包装时打印商品合规标签：`,
  key1004720: `拣货单设置`,
  key1004721: `集货超时设置`,
  key1004722: `包装作业设置`,
  key1004723: `常规分拣架设置(仅在多品多件包裹自动分拣功能开启时可用)`,
  key1004724: `启用左侧分拣货架`,
  key1004725: `货架矩阵`,
  key1004726: `行`,
  key1004727: `列`,
  key1004728: `启用中间分拣货架`,
  key1004729: `启用右侧分拣货架`,
  key1004730: `备货分拣架设置(仅在多品多件包裹自动分拣功能开启时可用)`,
  key1004731: `保存见货出单设置`,
  key1004732: `你有分拣中作业未完成，拣货单号:`,
  key1004733: `拣货完成时间`,
  key1004734: `拣货人`,
  key1004735: `分拣人`,
  key1004736: `扫描/录入拣货单单号开始多品分拣：`,
  key1004737: `常规分拣作业提醒`,
  key1004738: `备货分拣作业提醒`,
  key1004739: `分拣人：`,
  key1004740: `未打印`,
  key1004741: `已打印`,
  key1004742: `按添加时间`,
  key1004743: `按拣货单状态`,
  key1004744: `查询已包装的拣货单，创建时间不能为空！`,
  key1004745: `标记成功`,
  key1004746: `请选择操作数据`,
  key1004747: `拣货状态`,
  key1004748: `打印状态`,
  key1004749: `SKU数`,
  key1004750: `未指定物流商`,
  key1004751: `未指定邮寄方式`,
  key1004752: `拣货单编号：`,
  key1004753: `打印状态：`,
  key1004754: `批量操作`,
  key1004755: `打印拣货单`,
  key1004756: `标记为已拣货`,
  key1004757: `包裹重量不能为空`,
  key1004758: `小包结袋`,
  key1004759: `包裹重量(g)：`,
  key1004760: `当前小包内SKU如下图所示，共`,
  key1004761: `件，确认数量后请先进行称重，再进行结袋操作。`,
  key1004762: `打印标签并结袋`,
  key1004763: `库存数`,
  key1004764: `盘点数`,
  key1004765: `差异数`,
  key1004766: `待盘点`,
  key1004767: `盘点中`,
  key1004768: `盘点单:`,
  key1004769: `盘点仓库：`,
  key1004770: `拣货提醒：`,
  key1004771: `盘点单状态：`,
  key1004772: `动态盘点：`,
  key1004773: `盲盘：`,
  key1004774: `盘点人员：`,
  key1004775: `制单人`,
  key1004776: `（签字/日期）`,
  key1004777: `（签字日期）`,
  key1004778: `取消打印`,
  key1004779: `拣货单单号`,
  key1004780: `所在仓库`,
  key1004781: `成功生成`,
  key1004782: `张拣货单`,
  key1004783: `每张备货拣货单最大包裹数不能为空！`,
  key1004784: `每张常规拣货单最大包裹数不能为空！`,
  key1004785: `生成拣货单`,
  key1004786: `拣货单生成规则：`,
  key1004787: `去拣货单列表`,
  key1004788: `仓储管理`,
  key1004789: `见货货单`,
  key1004790: `分拣单`,
  key1004791: `Temu样品订单`,
  key1004792: `Temu发货订单`,
  key1004793: `sku/名称/规格`,
  key1004794: `总货品数量`,
  key1004795: `已分拣货品数量`,
  key1004796: `拣货单`,
  key1004797: `出库单`,
  key1004798: `包裹`,
  key1004799: `拣货单下出库单均已换单`,
  key1004800: `请扫描正确的SKU/货品身份码`,
  key1004801: `没有可用拣货篮`,
  key1004802: `当前货品无标签地址`,
  key1004803: `多品备货分拣—结束分拣`,
  key1004804: `拣货单取消提示`,
  key1004805: `拣货单内已无出库单，拣货单已取消，点击按钮后将自动结束本次作业。`,
  key1004806: `打印失败`,
  key1004807: `打印标签成功！`,
  key1004808: `分拣打印完成`,
  key1004809: `应发数量`,
  key1004810: `容器货品数量`,
  key1004811: `待分拣数量`,
  key1004812: `打印标签`,
  key1004813: `打印Temu中间标签成功！`,
  key1004814: `获取Temu中间标签地址失败！`,
  key1004815: `未获取到Temu中间标签面单地址`,
  key1004816: `商品标签选择`,
  key1004817: `拣货单号：{pickingGoodsNo} 已经分拣完成，点击【结束本次分拣】结束本次作业`,
  key1004818: `您扫描的货品{sku}，当前拣货单中的包裹均不需要或需求数量已经满足。`,
  key1004819: `当前分拣作业拣货单：`,
  key1004820: `结束本次分拣`,
  key1004821: `SKU/货品身份码`,
  key1004822: `全部分拣完成`,
  key1004823: `货品异常警告`,
  key1004824: `可能的原因：`,
  key1004825: `1.您拣货的时候错误拣出该货品或该货品拣货过多。`,
  key1004826: `2.该货品条码粘贴错误。`,
  key1004827: `请将该货品交由异常处理部门处理。`,
  key1004828: `继续扫描其他货品（回车）`,
  key1004829: `拣货单信息：`,
  key1004830: `出库单信息：`,
  key1004831: `将该包裹重置为未开始分拣`,
  key1004832: `将该包裹从当前拣货单中移除等待生成新拣货单`,
  key1004833: `打印Temu中间标签`,
  key1004834: `请选择商品标签：`,
  key1004835: `已扫描数量`,
  key1004836: `未拣数量`,
  key1004837: `已完成包装包裹总数`,
  key1004838: `已完成包装货品总数`,
  key1004839: `统计项目`,
  key1004840: `拣货单数量`,
  key1004841: `实际完成数量`,
  key1004842: `作业人`,
  key1004843: `包裹总数`,
  key1004844: `作业时长(分钟)`,
  key1004845: `包裹速度(每分钟)`,
  key1004846: `货品速度(每分钟)`,
  key1004847: `收件人`,
  key1004848: `扫描时间`,
  key1004849: `已打`,
  key1004850: `未打`,
  key1004851: `货品小计`,
  key1004852: `货品信息`,
  key1004853: `拣货复核-结束作业`,
  key1004854: `您即将结束拣货单 {pickingGoodsNo} 的拣货复核`,
  key1004855: `共 {scannedCount} 人参与本次拣货复核`,
  key1004856: `包装总时间 {scannedTime} 分钟`,
  key1004857: `总计(人.时) {userScannedTime} 分钟`,
  key1004858: `您即将结束拣货单 {pickingGoodsNo} 的拣货复核，但系统检测到以下异常`,
  key1004859: `以下包裹货品已扫描但包裹正在打印中`,
  key1004860: `保存为Excel`,
  key1004861: `通常因打印机信息返回异常导致，需要人工确认地址标签是否已经正常打印。`,
  key1004862: `如果您标记为已打印，强制结束拣货复核时将认为这些包裹已经正常包装，包裹无法再生成新的拣货单。`,
  key1004863: `如果您标记为未打印，强制结束拣货复核时将认为这些包裹未打印包装，系统将把这些包裹从拣货单中移除，您可以重新生成新的拣货单。`,
  key1004864: `以下包裹尚未打印或包裹打印前被作废`,
  key1004865: `强制结束拣货复核时未打印包裹将从拣货单中移除，再次生成新的拣货单。`,
  key1004866: `拣货单打印之后，地址标签打印之前，包裹被作废，将会导致拣货的实物货品剩余。`,
  key1004867: `正常情况下，本项货品汇总应与您手中的货品实物一致。`,
  key1004868: `以下包裹打印之后被作废`,
  key1004869: `地址标签打印后，包裹被作废，会导致包裹被正常包装，建议立即拦截，并在[回收包裹]中进行确认。`,
  key1004870: `结束作业`,
  key1004871: `返回继续包装`,
  key1004872: `等待提交后获取包裹信息`,
  key1004873: `物流商/邮寄方式`,
  key1004874: `SKU及数量`,
  key1004875: `打印货品标签`,
  key1004876: `获取速卖通全托管货品条码失败！`,
  key1004877: `名称 / 规格`,
  key1004878: `校对`,
  key1004879: `当前SKU对应订单为速卖通全托管JIT订单，需打印对应货品条码。请注意纸张大小需为60mm*30mm。`,
  key1004880: `未获取到合规标签面单地址`,
  key1004881: `未获取到面单地址`,
  key1004882: `打印成功`,
  key1004883: `扫描货品`,
  key1004884: `获取包裹信息`,
  key1004885: `校对货品数量`,
  key1004886: `发送至打印机`,
  key1004887: `标记已打印`,
  key1004888: `SKU异常`,
  key1004889: `您扫描或输入的SKU【 {warnSku} 】在当前拣货单中未找到`,
  key1004890: `未匹配到指定`,
  key1004891: `当前拣货复核拣货单：`,
  key1004892: `当前操作员：`,
  key1004893: `退出当前作业`,
  key1004894: `自动匹配包裹：`,
  key1004895: `清空已扫描货品并重新扫描`,
  key1004896: `拣货单的出库单`,
  key1004897: `您需要先处理当前未打印的包裹`,
  key1004898: `您提交的扫描的结果，在当前拣货单中未能找到包裹信息，可能原因：`,
  key1004899: `*当前包裹拣货货品存在错误`,
  key1004900: `*您扫描的过程中存在遗漏或者重复。`,
  key1004901: `拣货单不存在或状态已改变,请刷新后重试`,
  key1004902: `拣货复核扫描的出库单不存在`,
  key1004903: `拣货复核扫描出库单已作废`,
  key1004904: `SKU未匹配合适出库单`,
  key1004905: `拣货复核已结束`,
  key1004906: `存在未完成包装的出库单`,
  key1004907: `名称/规格`,
  key1004908: `已扫描数量不能为空！`,
  key1004909: `已扫 / 未扫`,
  key1004910: `已扫`,
  key1004911: `未扫`,
  key1004912: `打印Temu标签`,
  key1004913: `（部分包装）`,
  key1004914: `（已包装）`,
  key1004915: `（已完结）`,
  key1004916: `超出拣货单数量，请检查实际货品数量!`,
  key1004917: `SKU非此订单所需货品，请确认货品所属订单！`,
  key1004918: `SKU不能为空!`,
  key1004919: `存在未完结出库单，请标记完结后再结束作业。`,
  key1004920: `所有货品均已扫描，请结束作业`,
  key1004921: `超出拣货单数量，请检查实际货品数量`,
  key1004922: `此出库单已标记完结，请勿重复标记！`,
  key1004923: `整单完结`,
  key1004924: `整单编辑完结后不可进行变更，请确认无误后再进行标记。`,
  key1004925: `标记完结`,
  key1004926: `完结异常提示`,
  key1004927: `当前出库单末进行包装作业，标记完结后状态将流转至待生成拣货单中，请确认无误后再进行标记。`,
  key1004928: `请结束小包后再标记整单完结。`,
  key1004929: `打印Temu条码`,
  key1004930: `当前出库单：`,
  key1004931: `已装货品数量：`,
  key1004932: `分拣容器及对应出库单`,
  key1004933: `拣货框`,
  key1004934: `未分配`,
  key1004935: `货品（已拣/待拣）`,
  key1004936: `异常原因`,
  key1004937: `未开始分拣`,
  key1004938: `分拣未完成`,
  key1004939: `已拣`,
  key1004940: `待拣`,
  key1004941: `您即将结束拣货单 {pickingGoodsNo} 的分拣作业，但系统检测到以下异常`,
  key1004942: `以下包裹未完成所有货品的分拣`,
  key1004943: `1.拣货货品小于拣货单要求数量。`,
  key1004944: `2.之前的分拣过程在某个拣货框中放入了过多的货品。`,
  key1004945: `3.等待分拣区尚有剩余货品未扫描。`,
  key1004946: `拣货与分拣过程均确保数量准确的情况下，待拣部分货品应该与等待分拣区的剩余货品数量一致。`,
  key1004947: `如果您觉得错误过多，无法追溯，您可以将所有拣货框中的货品全部放回等待分拣区，`,
  key1004948: `并`,
  key1004949: `撤销本次分拣`,
  key1004950: `拣货单可以再次开启分拣作业。`,
  key1004951: `返回继续分拣`,
  key1004952: `应扫数量`,
  key1004953: `实扫数量`,
  key1004954: `货品数量异常提示`,
  key1004955: `本次作业中存在以下SKU仍未扫描，请再次核对货品数量，若存在丢货情况请及时与管理人员联系。`,
  key1004956: `返回作业`,
  key1004957: `应发货品数量`,
  key1004958: `拣货框货品数量`,
  key1004959: `重置成功！`,
  key1004960: `多品常规分拣—结束分拣`,
  key1004961: `获取货品条码失败！`,
  key1004962: `打印货品条码`,
  key1004963: `不存在拣货单明细`,
  key1004964: `标记打印成功`,
  key1004965: `按出库单查看`,
  key1004966: `按商品查看`,
  key1004967: `物流下发状态`,
  key1004968: `未下发`,
  key1004969: `已下发`,
  key1004970: `从拣货单移除`,
  key1004971: `已拣货数量`,
  key1004972: `体积`,
  key1004973: `未拣货`,
  key1004974: `输入出库单号查找`,
  key1004975: `拣货单详情`,
  key1004976: `是否打印：`,
  key1004977: `创建人员：`,
  key1004978: `是否删除最后一条？如果删除该拣货单也会删除！`,
  key1004979: `按物流方式`,
  key1004980: `请先勾选需要生成拣货单的数据！`,
  key1004981: `当前筛选结果暂无数据，无法生成拣货单！`,
  key1004982: `多个出库单请用逗号分隔`,
  key1004983: `品类：`,
  key1004984: `按选中生成拣货单`,
  key1004985: `生成拣货单（所有结果集）`,
  key1004986: `请下载通途打印控件`,
  key1004987: `条形码未生成成功，请重新点击打印。`,
  key1004988: `打印SKU`,
  key1004989: `删除选中`,
  key1004990: `不自动关闭`,
  key1004991: `展示更多`,
  key1004992: `超出输入限制长度`,
  key1004993: `添加备注成功！`,
  key1004994: `添加备注失败！`,
  key1004995: `新增失败`,
  key1004996: `订单号，支持多个按行分隔`,
  key1004997: `请输入分销商商户号，支持多个按行分隔`,
  key1004998: `请输入分销商订单号，支持多个按行分隔`,
  key1004999: `请输入运单号，支持多个按行分隔`,
  key1005000: `出库人`,
  key1005001: `生成拣货单人`,
  key1005002: `物流分拣人`,
  key1005003: `发货数量（件）`,
  key1005004: `分配库存时间`,
  key1005005: `生成拣货单时间`,
  key1005006: `完成拣货时间`,
  key1005007: `完成分拣时间`,
  key1005008: `完成包装时间`,
  key1005009: `完成物流分拣时间`,
  key1005010: `出库时间`,
  key1005011: `物流商运单号`,
  key1005012: `发货数量`,
  key1005013: `操作人员`,
  key1005014: `SKU，支持多个按行分隔`,
  key1005015: `导出出库明细`,
  key1005016: `活动图片`,
  key1005017: `活动名称`,
  key1005018: `活动状态`,
  key1005019: `活动开始时间`,
  key1005020: `活动结束时间`,
  key1005021: `长期有效`,
  key1005022: `立即开始`,
  key1005023: `立即开始活动确认`,
  key1005024: `确认后将活动将立即开始并展示在商城端，请确认是否开始？`,
  key1005025: `立即结束`,
  key1005026: `立即结束活动确认`,
  key1005027: `确认后将活动将立即结束，请确认是否结束？`,
  key1005028: `活动名称：`,
  key1005029: `请输入活动名称关键字`,
  key1005030: `活动状态：`,
  key1005031: `新增活动`,
  key1005032: `入口`,
  key1005033: `金刚区图片为空，请上传后重试。`,
  key1005034: `名称不能为空！`,
  key1005035: `请先上传`,
  key1005036: `的图片！`,
  key1005037: `的点击跳转地址不能为空！`,
  key1005038: `图片成功`,
  key1005039: `图片失败`,
  key1005040: `请输入入口名称`,
  key1005041: `图片：`,
  key1005042: `点击跳转：`,
  key1005043: `更换`,
  key1005044: `效果图`,
  key1005045: `金刚区`,
  key1005046: `图片上传`,
  key1005047: `(建议尺寸：60*60)`,
  key1005048: `未填写`,
  key1005049: `效果预览`,
  key1005050: `跳转目标类型不能为空`,
  key1005051: `指定链接地址必须是https://或者http://开头的链接！`,
  key1005052: `不跳转`,
  key1005053: `跳转目标不能为空!`,
  key1005054: `点击跳转`,
  key1005055: `跳转目标类型：`,
  key1005056: `跳转目标：`,
  key1005057: `站点名称`,
  key1005058: `站点域名`,
  key1005059: `站点说明`,
  key1005060: `请输入站点名称`,
  key1005061: `查看站点信息`,
  key1005062: `编辑站点信息`,
  key1005063: `站点域名：`,
  key1005064: `请输入站点域名`,
  key1005065: `站点说明：`,
  key1005066: `请输入站点说明`,
  key1005067: `首页轮播图`,
  key1005068: `顶部广告位`,
  key1005069: `侧边广告位`,
  key1005070: `首页-个人信息下方广告位`,
  key1005071: `更改启用状态提示`,
  key1005072: `此操作将更改该广告位在商城端是否可见，请确认是否继续更改。`,
  key1005073: `banner图：`,
  key1005074: `广告图为空，请上传后重试。`,
  key1005075: `点击跳转地址不能为空！`,
  key1005076: `(建议尺寸：70*228)`,
  key1005077: `banner图为空，请上传后重试。`,
  key1005078: `(建议高度：80px)`,
  key1005079: `(建议尺寸：228*70)`,
  key1005080: `活动开始时间不能为空`,
  key1005081: `按上新天数匹配`,
  key1005082: `匹配规则不能为空`,
  key1005083: `上新天数不能为空`,
  key1005084: `活动`,
  key1005085: `标语：`,
  key1005086: `商品活动`,
  key1005087: `活动结束时间不能为空`,
  key1005088: `请先勾选参与活动的商品！`,
  key1005089: `请先配置匹配规则！`,
  key1005090: `统一定价不能为空！`,
  key1005091: `活动结束时间不能小于活动开始时间！`,
  key1005092: `统一定价(`,
  key1005093: `是否新增为首页tab：`,
  key1005094: `是否展示供应商信息：`,
  key1005095: `活动开始时间：`,
  key1005096: `选择活动开始时间`,
  key1005097: `活动结束时间：`,
  key1005098: `选择活动结束时间`,
  key1005099: `是否统一设置价格：`,
  key1005100: `配置匹配规则`,
  key1005101: `匹配规则：`,
  key1005102: `上新天数：`,
  key1005103: `移除商品确认`,
  key1005104: `活动信息`,
  key1005105: `(建议尺寸：1200*160)`,
  key1005106: `活动定价`,
  key1005107: `活动商品`,
  key1005108: `配置规则`,
  key1005109: `批量移除`,
  key1005110: `规则说明：`,
  key1005111: `1.系统将自动匹配满足一定上新天数内的商品，如：填写7天，则系统将按审核通过时间匹配与今天相差7天内的商品添加至活动中。`,
  key1005112: `移除后商品将不再参加此活动，价格可能发生改变，系统将提醒已订阅的分销商。`,
  key1005113: `移除商品`,
  key1005114: `轮播项`,
  key1005115: `轮播图为空，请上传后重试。`,
  key1005116: `轮播项1`,
  key1005117: `(建议尺寸：644*324)`,
  key1005118: `删除轮播项`,
  key1005119: `+添加轮播项`,
  key1005120: `补贴规则名称`,
  key1005121: `规则状态`,
  key1005122: `添加子规则`,
  key1005123: `运费补贴`,
  key1005124: `创建补贴规则`,
  key1005125: `订单续件`,
  key1005126: `件`,
  key1005127: `费用规则`,
  key1005128: `普通计费`,
  key1005129: `处理费 = 重量 * 单价`,
  key1005130: `首续重计费`,
  key1005131: `重量小于等于首重：处理费 = 首重收费`,
  key1005132: `重量大于首重：处理费 = 首重收费 + 向上取整(总重量-首重) / 续重单位重量 * 续重单价`,
  key1005133: `固定收费`,
  key1005134: `处理费 = 费用`,
  key1005135: `添加费用配置`,
  key1005136: `补贴对象不能为空`,
  key1005137: `补贴类型不能为空`,
  key1005138: `创建子规则`,
  key1005139: `编辑补贴规则`,
  key1005140: `编辑子规则`,
  key1005141: `补贴规则未完善，请完整填写后重试。`,
  key1005142: `提单内货品数量必须是大于等于0整数`,
  key1005143: `订单发货率必须是大于等于0`,
  key1005144: `补贴金额未完善，请完整填写后重试。`,
  key1005145: `补贴对象：`,
  key1005146: `补贴类型：`,
  key1005147: `选择时间`,
  key1005148: `多个商户号请用英文逗号，或换行分隔`,
  key1005149: `条件`,
  key1005150: `此名称客户可见，请合理命名`,
  key1005151: `补贴条件：`,
  key1005152: `添加条件`,
  key1005153: `补贴金额：`,
  key1005154: `子规则补贴将与主规则叠加，请合理配置`,
  key1005155: `单个提单补贴：`,
  key1005156: `0-1公斤补贴：`,
  key1005157: `续重每公斤补贴：`,
  key1005158: `单个提单补贴上限：`,
  key1005159: `入驻成功`,
  key1005160: `输入商户号`,
  key1005161: `服务器选择`,
  key1005162: `搜索：`,
  key1005163: `云卖刊登`,
  key1005164: `按姓名`,
  key1005165: `按邮箱`,
  key1005166: `更多角色`,
  key1005167: `最后登录时间`,
  key1005168: `是否要删除当前角色？`,
  key1005169: `搜索角色名称`,
  key1005170: `可输入员工姓名、邮箱、手机号`,
  key1005171: `账号状态：`,
  key1005172: `管理员工角色`,
  key1005173: `添加新员工`,
  key1005174: `添加新角色`,
  key1005175: `角色名称不能为空`,
  key1005176: `编辑角色`,
  key1005177: `角色名称：`,
  key1005178: `请输入角色名称`,
  key1005179: `组装加工 - `,
  key1005180: `拣货 - `,
  key1005181: `模块`,
  key1005182: `新增员工`,
  key1005183: `邮箱不能为空`,
  key1005184: `查看员工`,
  key1005185: `编辑员工`,
  key1005186: `基本资料`,
  key1005187: `所属角色`,
  key1005188: `数据权限`,
  key1005189: `仓库权限`,
  key1005190: `仓库所有数据权限`,
  key1005191: `拓客数据权限`,
  key1005192: `所有数据权限`,
  key1005193: `请输入规则名`,
  key1005194: `请添加物流方式`,
  key1005195: `时效和运单号请至少选择一个`,
  key1005196: `实际发货物流方式不能为空`,
  key1005197: `账户不能为空`,
  key1005198: `规则名：`,
  key1005199: `实际发货物流方式：`,
  key1005200: `帐号：`,
  key1005201: `选择指定物流`,
  key1005202: `选择符合条件物流`,
  key1005203: `已停用，请修改后重新保存`,
  key1005204: `物流相关设置`,
  key1005205: `时效：小于`,
  key1005206: `无`,
  key1005207: `有`,
  key1005208: `API对接`,
  key1005209: `新增物流`,
  key1005210: `物流类型：`,
  key1005211: `选择物流：`,
  key1005212: `接收方指定提交代码`,
  key1005213: `发件地址`,
  key1005214: `揽收地址`,
  key1005215: `退件地址`,
  key1005216: `请勾选要启用的物流方式`,
  key1005217: `是否复制此物流渠道？`,
  key1005218: `输入名称搜索`,
  key1005219: `物流渠道名称/代码：`,
  key1005220: `新增物流渠道`,
  key1005221: `未启用物流方式`,
  key1005222: `物流仅支持绑定一条渠道！`,
  key1005223: `确定要取消关联？`,
  key1005224: `取消关联`,
  key1005225: `请先添加关联物流！`,
  key1005226: `添加成功!`,
  key1005227: `请先选择完整的物流方式!`,
  key1005228: `关联物流`,
  key1005229: `添加关联`,
  key1005230: `编辑自定义物流`,
  key1005231: `标准报价`,
  key1005232: `操作费（元/票）`,
  key1005233: `首重（g）`,
  key1005234: `续重单位重量（g）`,
  key1005235: `续重单价（元）`,
  key1005236: `特例国家/地区不能为空`,
  key1005237: `物流服务商(Carrier)不能为空`,
  key1005238: `不能添加相同名称的配送服务！`,
  key1005239: `分区`,
  key1005240: `默认分区`,
  key1005241: `通达国家`,
  key1005242: `所有国家`,
  key1005243: `计费方式`,
  key1005244: `计重方式`,
  key1005245: `计费公式`,
  key1005246: `手动同步`,
  key1005247: `下发物流商成功后同步`,
  key1005248: `获取运单号成功后同步`,
  key1005249: `出库成功后同步`,
  key1005250: `折扣价`,
  key1005251: `寄件人地址`,
  key1005252: `揽收人地址`,
  key1005253: `退件人地址`,
  key1005254: `买家自送`,
  key1005255: `国内快递费用不能为空`,
  key1005256: `编辑物流渠道`,
  key1005257: `查看物流渠道`,
  key1005258: `复制物流渠道`,
  key1005259: `物流渠道代码不能为空`,
  key1005260: `接收方指定提交代码不能为空`,
  key1005261: `shipCompanyId不能为空`,
  key1005262: `履约方式不能为空`,
  key1005263: `请先完善物流单作废费配置！`,
  key1005264: `默认分区外计费模型国家不能为空`,
  key1005265: `导入失败，请检查导入模板内容重新尝试！`,
  key1005266: `未绑定`,
  key1005267: `已绑定`,
  key1005268: `首重`,
  key1005269: `元`,
  key1005270: `续重`,
  key1005271: `不能添加相同名称的物流商服务！`,
  key1005272: `支付作废费用不能为空！`,
  key1005273: `订单物流费不能为空！`,
  key1005274: `交运方式不能为空`,
  key1005275: `揽收时间不能为空`,
  key1005276: `交货方式：`,
  key1005277: `国内快递费用：`,
  key1005278: `若选择”第三方海外仓”中心仓为适用仓库时（如：万邑通、米云仓)，需要在下方”物流渠道绑定”中，绑定海外仓平台物流，否则会下发失败；`,
  key1005279: `物流服务商(Carrier)：`,
  key1005280: `发货国家：`,
  key1005281: `揽收方式：`,
  key1005282: `配送服务：`,
  key1005283: `交运方式：`,
  key1005284: `面单模板`,
  key1005285: `'面单尺寸'`,
  key1005286: `发货说明：`,
  key1005287: `(h)内（不包含`,
  key1005288: `渠道基础信息`,
  key1005289: `物流商类型：`,
  key1005290: `无对接`,
  key1005291: `Excel对接`,
  key1005292: `物流方案代码：`,
  key1005293: `接收方指定提交代码：`,
  key1005294: `履约方式：`,
  key1005295: `物流承运方：`,
  key1005296: `参考时效：`,
  key1005297: `保险服务：`,
  key1005298: `尺寸限制(cm)：`,
  key1005299: `适用重量`,
  key1005300: `周长限制(cm)：`,
  key1005301: `最长边限制(cm)：`,
  key1005302: `体积限制(cm³)：`,
  key1005303: `追踪信息查询网址：`,
  key1005304: `揽收点地址信息`,
  key1005305: `国内快递收货地址选择：`,
  key1005306: `使用固定地址模板`,
  key1005307: `使用订单地址`,
  key1005308: `物流商可选设置(默认设置)`,
  key1005309: `派送范围及运费`,
  key1005310: `派送范围`,
  key1005311: `计费模型`,
  key1005312: `从其他渠道引用`,
  key1005313: `批量导入`,
  key1005314: `新增分区`,
  key1005315: `运费币种：`,
  key1005316: `请注意，无折扣时，请输入1，八折时，请输入0.8`,
  key1005317: `此费用作用于订单已下发物流并获取运单号后，分销商取消时默认按照时间段收取物流单作废费用；`,
  key1005318: `若分销商取消时的时间不在下方时间范围内，则不收取此费用。`,
  key1005319: `是否收取此费用：`,
  key1005320: `不收取`,
  key1005321: `收取`,
  key1005322: `费用收取方式：`,
  key1005323: `固定金额收取`,
  key1005324: `按订单物流费比例收取`,
  key1005325: `计费币种：`,
  key1005326: `成功获取运单号后`,
  key1005327: `取消订单需要支付作废费用`,
  key1005328: `取消订单需要按照订单物流费`,
  key1005329: `进行支付`,
  key1005330: `适用仓库`,
  key1005331: `全部自营仓库`,
  key1005332: `平台标发货设置`,
  key1005333: `不填运单号`,
  key1005334: `（默认）`,
  key1005335: `添加特例国家`,
  key1005336: `面单打印设置`,
  key1005337: `打印配货清单`,
  key1005338: `更多仓库`,
  key1005339: `拖拽`,
  key1005340: `物流商/物流渠道`,
  key1005341: `适用范围`,
  key1005342: `平台/账号`,
  key1005343: `运费范围`,
  key1005344: `包含sku`,
  key1005345: `数量范围`,
  key1005346: `所有`,
  key1005347: `新建规则`,
  key1005348: `规则指定订单来源`,
  key1005349: `规则指定订单目的国家/地区包括`,
  key1005350: `规则指定发货指定方式`,
  key1005351: `适用平台：`,
  key1005352: `适用店铺：`,
  key1005353: `适用包裹金额($)：`,
  key1005354: `买家支付的运费范围($)：`,
  key1005355: `包裹包含SKU：`,
  key1005356: `支持多个SKU，请用逗号或空格分开`,
  key1005357: `商品总数量范围：`,
  key1005358: `智能物流匹配逻辑说明`,
  key1005359: `匹配物流渠道基础属性`,
  key1005360: `必要流程：找出可发物流商`,
  key1005361: `订单匹配物流渠道基础属性中的：`,
  key1005362: `1.尺寸限制`,
  key1005363: `2.重量限制`,
  key1005364: `3.接收类型限制`,
  key1005365: `4.配送范围限制`,
  key1005366: `匹配结果=1结束，匹配结果>1进行下一步`,
  key1005367: `5.发货仓库支持的物流渠道`,
  key1005368: `匹配物流规则`,
  key1005369: `上一步匹配成功的结果集跑物流匹配规则，通过规则引擎匹配，从上到下匹配`,
  key1005370: `匹配物流适用范围`,
  key1005371: `可选流程：适用范围`,
  key1005372: `用户可自定义物流渠道的适用范围，匹配所有渠道的适用范围`,
  key1005373: `运费/时效优先级`,
  key1005374: `必要流程：选择运费最低或时效最快`,
  key1005375: `计算所有符合条件物流渠道的运费/时效，根据设置的优先级选择运费最低或时效最快的`,
  key1005376: `新增物流规则`,
  key1005377: `已选发货指定方式：`,
  key1005378: `物流渠道适用范围`,
  key1005379: `物流名称`,
  key1005380: `关联物流渠道`,
  key1005381: `关联`,
  key1005382: `分销商物流`,
  key1005383: `物流名称：`,
  key1005384: `关联物流渠道：`,
  key1005385: `税率`,
  key1005386: `税率必须是大于等于0且最多允许2位小数`,
  key1005387: `默认分区外计费模型国家不能为空!`,
  key1005388: `必填项不能为空!`,
  key1005389: `内容不能为空`,
  key1005390: `适用范围：`,
  key1005391: `适用重量 (g)：`,
  key1005392: `体积限制(cm)：`,
  key1005393: `省州：`,
  key1005394: `街道：`,
  key1005395: `旺旺：`,
  key1005396: `揽件时间：`,
  key1005397: `代理人`,
  key1005398: `预扣物流费配置`,
  key1005399: `方案基础信息`,
  key1005400: `速卖通线上发货设置`,
  key1005401: `eDIS物流设置`,
  key1005402: `Logistics设置`,
  key1005403: `选择发件地址：`,
  key1005404: `选择揽收地址：`,
  key1005405: `交运地址：`,
  key1005406: `选择退件地址：`,
  key1005407: `交运方式与揽件时间`,
  key1005408: `卖家自送`,
  key1005409: `清关费用配置`,
  key1005410: `是否收取清关费用：`,
  key1005411: `比例配置：申报价值在`,
  key1005412: `至150EUR时，按如下税率计算后`,
  key1005413: `超出150欧的包裹将下发物流失败。`,
  key1005414: `是否可用：`,
  key1005415: `适用平台不能为空`,
  key1005416: `物流商名称`,
  key1005417: `分销商是否可用`,
  key1005418: `物流账户`,
  key1005419: `适用平台`,
  key1005420: `对接类型`,
  key1005421: `编辑账号`,
  key1005422: `修改适用范围`,
  key1005423: `分销商是否可用：`,
  key1005424: `物流商名称：`,
  key1005425: `获取申请授权回调地址失败！`,
  key1005426: `账号名称不能为空`,
  key1005427: `个人姓名/公司名称不能为空！`,
  key1005428: `地址信息不能为空！`,
  key1005429: `账号名称：`,
  key1005430: `授权状态：`,
  key1005431: `个人姓名/公司名称：`,
  key1005432: `联系电话：`,
  key1005433: `地址信息：`,
  key1005434: `重新授权`,
  key1005435: `去授权`,
  key1005436: `已授权`,
  key1005437: `未授权`,
  key1005438: `EU代理人`,
  key1005439: `请选择使用的IOSS`,
  key1005440: `请选择店铺`,
  key1005441: `添加规则`,
  key1005442: `使用的IOSS：`,
  key1005443: `条件类型：`,
  key1005444: `平台：`,
  key1005445: `店铺：`,
  key1005446: `此名称仅用于更好区分不同IOSS`,
  key1005447: `按店铺`,
  key1005448: `按平台`,
  key1005449: `手工订单`,
  key1005450: `IOSS管理`,
  key1005451: `IOSS规则配置`,
  key1005452: `IOSS名称`,
  key1005453: `IOSS编号`,
  key1005454: `使用IOSS名称`,
  key1005455: `使用IOSS编号`,
  key1005456: `适用平台/店铺`,
  key1005457: `适用店铺`,
  key1005458: `启用IOSS确认`,
  key1005459: `停用IOSS确认`,
  key1005460: `启用IOSS后，相关规则将可被匹配，请确认是否启用IOSS？`,
  key1005461: `停用IOSS后，使用此IOSS编号的规则将同时停用，请确认是否停用IOSS?`,
  key1005462: `启用IOSS规则`,
  key1005463: `停用IOSS规则`,
  key1005464: `请确认是否启用规则？`,
  key1005465: `请确认是否停用规则？`,
  key1005466: `将按照产品在`,
  key1005467: `中的销售价格，即对应`,
  key1005468: `订单的商品价格进行申报。`,
  key1005469: `当平台订单中存在IOSS号时，`,
  key1005470: `将优先使用平台返回的IOSS编号，若无法匹配到IOSS号时系统将拦截此订单。`,
  key1005471: `添加IOSS`,
  key1005472: `申报说明：`,
  key1005473: `查看税率`,
  key1005474: `原价`,
  key1005475: `销售价：`,
  key1005476: `调整后价格`,
  key1005477: `费率`,
  key1005478: `图片验证码不能为空`,
  key1005479: `手机号格式不正确!`,
  key1005480: `手机号和图片验证码不能为空！`,
  key1005481: `邮箱格式不正确!`,
  key1005482: `邮箱不能为空！`,
  key1005483: `验证码已发送！`,
  key1005484: `邮箱格式不正确`,
  key1005485: `验证身份`,
  key1005486: `设置新邮箱`,
  key1005487: `验证码：`,
  key1005488: `手机验证码：`,
  key1005489: `请输入手机验证码`,
  key1005490: `新邮箱：`,
  key1005491: `邮箱验证码：`,
  key1005492: `请输入邮箱验证码`,
  key1005493: `提`,
  key1005494: `交`,
  key1005495: `手机验证`,
  key1005496: `邮箱验证`,
  key1005497: `登录密码`,
  key1005498: `定期更换密码有助于账户安全`,
  key1005499: `订单异常通知`,
  key1005500: `停售通知`,
  key1005501: `调价通知`,
  key1005502: `店铺上新通知`,
  key1005503: `自动规则通知`,
  key1005504: `请先勾选要标记的数据！`,
  key1005505: `上新日期：`,
  key1005506: `上新SPU：`,
  key1005507: `已收藏`,
  key1005508: `全部标记已读`,
  key1005509: `标记已读`,
  key1005510: `仅看未读`,
  key1005511: `分销商名称：`,
  key1005512: `币种：`,
  key1005513: `修改币种`,
  key1005514: `修改手机`,
  key1005515: `修改邮箱`,
  key1005516: `IOSS名称不能为空`,
  key1005517: `编辑IOSS`,
  key1005518: `IOSS编号不能为空`,
  key1005519: `请输入IM+10位数字`,
  key1005520: `IOSS名称：`,
  key1005521: `IOSS编号：`,
  key1005522: `原密码不能为空`,
  key1005523: `新密码不能为空`,
  key1005524: `更新成功!`,
  key1005525: `新密码与确认新密码不一致`,
  key1005526: `原密码：`,
  key1005527: `新密码：`,
  key1005528: `再次确认新密码：`,
  key1005529: `邮箱和图片验证码不能为空！`,
  key1005530: `手机号码格式不正确!`,
  key1005531: `手机号不能为空！`,
  key1005532: `设置新手机`,
  key1005533: `新手机号：`,
  key1005534: `请输入新手机号`,
  key1005535: `综合`,
  key1005536: `销量`,
  key1005537: `上新时间`,
  key1005538: `请勾选需要取消收藏的商品`,
  key1005539: `取消收藏成功!`,
  key1005540: `请勾选需要收藏的商品`,
  key1005541: `商品收藏成功`,
  key1005542: `请勾选需要下载资料的商品`,
  key1005543: `最小库存`,
  key1005544: `最大库存`,
  key1005545: `¥最低价`,
  key1005546: `¥最高价`,
  key1005547: `价格：`,
  key1005548: `关联区域/国家`,
  key1005549: `关联商品详情`,
  key1005550: `请输入制造商全称`,
  key1005551: `请输入详细地址`,
  key1005552: `请输入电话号码`,
  key1005553: `请输入电子邮件`,
  key1005554: `请输入邮编`,
  key1005555: `创建制造商`,
  key1005556: `制造商全称(跟注册文件一致)：`,
  key1005557: `制造商地址-国家：`,
  key1005558: `详细地址,具体到门牌号`,
  key1005559: `电话号码：`,
  key1005560: `电子邮件：`,
  key1005561: `制造商官网：`,
  key1005562: `制造商信息`,
  key1005563: `请输入你所要创建制造商的信息。`,
  key1005564: `责任人名称不能为空`,
  key1005565: `请选择区域`,
  key1005566: `请选择责任人国家`,
  key1005567: `责任人邮箱不能为空`,
  key1005568: `请输入你所要创建的海外责任人信息。（以下内容至少输入其中一个）`,
  key1005569: `请输入你所要创建的合规责任人信息。`,
  key1005570: `创建合规负责人`,
  key1005571: `责任人电话、邮箱、官网至少输入一个`,
  key1005572: `区域：`,
  key1005573: `责任人名称：`,
  key1005574: `责任人国家：`,
  key1005575: `责任人电话：`,
  key1005576: `责任人邮箱：`,
  key1005577: `责任人官网：`,
  key1005578: `负责区域/地区`,
  key1005579: `请选择您创建的海外合规责任人所对应的区域/地址`,
  key1005580: `合规责任人信息`,
  key1005581: `已批量选中`,
  key1005582: `条制造商信息，请问是否确认删除该信息？删除后商品与其的关联关系也会被移除`,
  key1005583: `制造商信息名称`,
  key1005584: `关联商品`,
  key1005585: `请问是否确认删除该信息？删除后商品与其的关联关系也会被移除。`,
  key1005586: `请先选择要删除的制造商信息`,
  key1005587: ` 确定`,
  key1005588: `制造商信息名称：`,
  key1005589: `请尽快在本页面提供销售往欧盟、美国和土耳其地区的产品制造商信息，且应与商品实物标签中制造商信息保持一致。`,
  key1005590: `注释：速卖通全托管订单对应商品的制造商信息，以速卖通后台商品关联的制造商信息为准。`,
  key1005591: `区域/国家`,
  key1005592: `区域/国家选择`,
  key1005593: `您选择的合规责任人所对应的区域/国家为：`,
  key1005594: `请您选择商品关联制造商所对应的区域/国家。`,
  key1005595: `区域/国家：`,
  key1005596: `请选择您需要关联的商品（可多选）`,
  key1005597: `若商品在上述区域/国家已关联了其他信息，本次操作将会把此前已关联的内容覆盖。`,
  key1005598: `条责任人信息，请问是否确认删除该信息？删除后商品与其的关联关系也会被移除`,
  key1005599: `合规责任人名称`,
  key1005600: `负责区域`,
  key1005601: `请先选择要删除的合规责任人信息`,
  key1005602: `合规责任人名称：`,
  key1005603: `欧洲通用产品安全法规（GPSR）和土耳其《通过远程通信工具在市场上提供产品的市场监督和审核规定》已强制实施，`,
  key1005604: `请尽快提供商品的欧盟责任人、土耳其责任人信息和关联店铺内对欧和土耳其销售的在线商品`,
  key1005605: `（请确保关联商品在该欧盟责任人、土耳其责任人的职责范围内），同时需要将欧盟责任人和土耳其责任人信息体现在商品实物标签中。`,
  key1005606: `注释：速卖通全托管订单对应商品的海外合规责任人信息，以速卖通后台商品关联的海外合规责任人信息为准。`,
  key1005607: `创建合规责任人`,
  key1005608: `商品资料`,
  key1005609: `平台订单`,
  key1005610: `备货单`,
  key1005611: `商品别名`,
  key1005612: `商品关联关系`,
  key1005613: `订单规则`,
  key1005614: `每隔`,
  key1005615: `分钟一次`,
  key1005616: `可用数量=`,
  key1005617: `订单超过`,
  key1005618: `小时未装箱时自动取消`,
  key1005619: `库存同步规则`,
  key1005620: `商品状态同步规则`,
  key1005621: `店铺`,
  key1005622: `刊登模板`,
  key1005623: `同步时间`,
  key1005624: `启动`,
  key1005625: `库存同步`,
  key1005626: `商品状态同步`,
  key1005627: `价格同步`,
  key1005628: `商品停售时库存自动调整为0`,
  key1005629: `商品停售时自动同步状态至上架工具`,
  key1005630: `删除后将不可恢复，你确定要删除？`,
  key1005631: `请选择适用平台`,
  key1005632: `请选择适用店铺`,
  key1005633: `添加价格同步规则`,
  key1005634: `修改价格同步规则`,
  key1005635: `价格同步规则`,
  key1005636: `此规则适用于商品价格发生变动时自动通过`,
  key1005637: `调整价格，默认使用刊登时选择的发货仓价格进行同步`,
  key1005638: `可用数量不能为空`,
  key1005639: `添加库存规则`,
  key1005640: `编辑库存规则`,
  key1005641: `个平台`,
  key1005642: `地区仓库库存数量`,
  key1005643: `可能会因为库存数量基数较小，浮动后使库存为0，也可能因为库存基数较大，浮动后与浮动前库存没有变化，请谨慎设置浮动比例。`,
  key1005644: `公式计算结果四舍五入，比如：计算结果为9.5，实际取值为10。`,
  key1005645: `向下浮动：`,
  key1005646: `同步时间：`,
  key1005647: `订单超时不能为空`,
  key1005648: `订单同步规则`,
  key1005649: `添加商品状态同步规则`,
  key1005650: `修改商品状态同步规则`,
  key1005651: `此规则适用于商品停售时库存自动调0及与上架工具状态同步。`,
  key1005652: `当任一规则中勾选此项后，商品停售状态将同步至上架工具中。`,
  key1005653: `变动类型`,
  key1005654: `采购到货`,
  key1005655: `分配库存`,
  key1005656: `库存盘点`,
  key1005657: `变动时间`,
  key1005658: `上传状态`,
  key1005659: `已上传`,
  key1005660: `未上传`,
  key1005661: `上传文件格式有误，请上传条码PDF文件或PNG图片`,
  key1005662: `Temu店铺：`,
  key1005663: `已刊登`,
  key1005664: `未刊登`,
  key1005665: `刊登数量（item）`,
  key1005666: `刊登状态`,
  key1005667: `刊登店铺`,
  key1005668: `刊登状态：`,
  key1005669: `刊登平台：`,
  key1005670: `设置别名`,
  key1005671: `请输入别名`,
  key1005672: `该别名已与 `,
  key1005673: `设置商品别名后，出现平台订单，订单商品SKU与`,
  key1005674: `商品SKU匹配失败时，订单商品SKU可再与`,
  key1005675: `商品的别名进行匹配，匹配成功后订单自动匹配该商品，无需分销商手动选择匹配;`,
  key1005676: `不允许出现相同别名`,
  key1005677: `1、设置商品别名后，出现平台订单，订单商品SKU与`,
  key1005678: `商品SKU匹配失败时，订单商品SKU可再`,
  key1005679: `与`,
  key1005680: `商品的别名进行匹配，匹配成功后订单自动匹配该商品，无需分销商手动选择匹配；`,
  key1005681: `2、不同SKU的别名信息不能相同，请勿在模板文件中输入相同的别名信息，若有相同别名信息条目，系统默认仅取第一条生效；`,
  key1005682: `1、设置商品关联关系后，出现平台订单，订单商品SKU与`,
  key1005683: `商品SKU匹配失败时，订单商品可通`,
  key1005684: `过关联关系与`,
  key1005685: `商品进行匹配，匹配成功后订单自动匹配该商品，无需分销商手动选择匹配；当`,
  key1005686: `商品同时设置了“别名”和“关联关系”时，优先使用“关联关系”进行匹配；`,
  key1005687: `2、同一平台店铺中的平台SKU，仅允许与一个YMSSKU建立关联关系，请勿在模板文件中输入相同的平台店`,
  key1005688: `铺SKU信息，若有相同平台SKU信息条目，系统默认仅取第一条生效；`,
  key1005689: `勾选的`,
  key1005690: `条商品中有`,
  key1005691: `条已生成售卖记录，请选择是否重新生成?`,
  key1005692: `部分停售`,
  key1005693: `自有库存`,
  key1005694: `近30天内销量`,
  key1005695: `合规责任人`,
  key1005696: `（已关联）`,
  key1005697: `（未关联）`,
  key1005698: `上架时间`,
  key1005699: `收藏时间`,
  key1005700: `售卖资料`,
  key1005701: `生成售卖时间`,
  key1005702: `导出商品资料`,
  key1005703: `取消收藏`,
  key1005704: `重新刊登`,
  key1005705: `设置关联关系`,
  key1005706: `请输入商品SPU,支持多个按行分隔`,
  key1005707: `商品SKU`,
  key1005708: `请输入商品SKU,支持多个按行分隔`,
  key1005709: `请输入商品标题,支持多个按行分隔`,
  key1005710: `请输入供应商名称,支持多个按行分隔`,
  key1005711: `请输入供应商编号,支持多个按行分隔`,
  key1005712: `商品基本信息`,
  key1005713: `商品基本信息表`,
  key1005714: `商品图片`,
  key1005715: `轮播图`,
  key1005716: `属性图`,
  key1005717: `已刊登平台`,
  key1005718: `已刊登店铺`,
  key1005719: `未刊登平台`,
  key1005720: `未刊登店铺`,
  key1005721: `超出单次下载数量`,
  key1005722: `一次最多可下载10个商品，请重新选择后下载。`,
  key1005723: `请先勾选要取消收藏的数据！`,
  key1005724: `请先勾选要操作的数据！`,
  key1005725: `收藏状态：`,
  key1005726: `收藏时间：`,
  key1005727: `售卖资料：`,
  key1005728: `无子选项`,
  key1005729: `请输入整数`,
  key1005730: `生成售卖资料提示`,
  key1005731: `导入商品别名`,
  key1005732: `导入商品关联关系`,
  key1005733: `批量生成售卖资料`,
  key1005734: `批量导出商品资料`,
  key1005735: `批量取消收藏`,
  key1005736: `忽略已生成`,
  key1005737: `生成`,
  key1005738: `3.支持扩展名:`,
  key1005739: `设置商品关联关系后，出现平台订单，订单商品SKU与`,
  key1005740: `商品SKU匹配失败时，`,
  key1005741: `订单商品可通过关联关系与`,
  key1005742: `商品进行匹配，匹配成功后订单自动匹配该商品，`,
  key1005743: `无需分销商手动选择匹配；当`,
  key1005744: `商品同时设置了“别名”和“关联关系”时，`,
  key1005745: `优先使用“关联关系”进行匹配；需要将“平台”“店铺”“平台商品SKU”填写完整，`,
  key1005746: `才会创建对应的关联关系；`,
  key1005747: `请输入SKU`,
  key1005748: `此SKU已与`,
  key1005749: `形成关联关系`,
  key1005750: `平台商品SKU：`,
  key1005751: `一个平台商品仅允许形成一个绑定关系`,
  key1005752: `商品可用数量`,
  key1005753: `未生成`,
  key1005754: `生成中`,
  key1005755: `生成成功`,
  key1005756: `生成失败`,
  key1005757: `生成状态`,
  key1005758: `待生成`,
  key1005759: `发起生成售卖时间`,
  key1005760: `失败原因`,
  key1005761: `发起人`,
  key1005762: `停止生成`,
  key1005763: `只有待生成的状态可以停止生成售卖资料`,
  key1005764: `请先勾选要停止生成的数据！`,
  key1005765: `停止生成售卖资料确认`,
  key1005766: `正在操作停止生成售卖资料，确认后将取消所有未生成的任务，如需重新生成需重新在收藏的商品中进行操作，请确认是否停止生成？`,
  key1005767: `请输入商品SPU，支持多个按行分隔`,
  key1005768: `商品标题：`,
  key1005769: `发起生成时间：`,
  key1005770: `发起人：`,
  key1005771: `条预计`,
  key1005772: `分钟后生成完毕`,
  key1005773: `批量停止生成售卖资料`,
  key1005774: `库存优先级配置`,
  key1005775: `使用库存优先级`,
  key1005776: `是否等待在途库存`,
  key1005777: `优先使用其他在`,
  key1005778: `仓的库存`,
  key1005779: `优先使用本人货权的库存`,
  key1005780: `等待`,
  key1005781: `不等待`,
  key1005782: `查看&编辑定制内容`,
  key1005783: `7日：`,
  key1005784: `14日：`,
  key1005785: `最近销量`,
  key1005786: `我的可用库存`,
  key1005787: `我的在途库存`,
  key1005788: `平均货品成本`,
  key1005789: `SKU库存开始区间不能大于SKU库存结束区间`,
  key1005790: `SKU库存区间：`,
  key1005791: `导出库存`,
  key1005792: `原SKU`,
  key1005793: `原定制商品可用数量`,
  key1005794: `商品为定制商品，原SPU表示原基础定制商品模板的SPU`,
  key1005795: `原SPU：`,
  key1005796: `获取原始商品id异常！`,
  key1005797: `定制商品库存(件)`,
  key1005798: `近三十天内销量(件)`,
  key1005799: `原SPU`,
  key1005800: `请输入原SPU,支持多个按行分隔`,
  key1005801: `请输入原SKU,支持多个按行分隔`,
  key1005802: `请输入商品名称,支持多个按行分隔`,
  key1005803: `定制商品库存`,
  key1005804: `定制商品库存：`,
  key1005805: `定制商品销售状态：`,
  key1005806: `选择时长`,
  key1005807: `店铺时长`,
  key1005808: `价格CNY`,
  key1005809: `1个月`,
  key1005810: `3个月`,
  key1005811: `6个月`,
  key1005812: `12个月`,
  key1005813: `开通店铺`,
  key1005814: `续费确认`,
  key1005815: `确认续费`,
  key1005816: `正在充值中...`,
  key1005817: `开通成功`,
  key1005818: `续费成功`,
  key1005819: `开通失败`,
  key1005820: `续费失败`,
  key1005821: `授权状态`,
  key1005822: `前往授权`,
  key1005823: `首次授权时间`,
  key1005824: `授权更新时间`,
  key1005825: `通途状态`,
  key1005826: `到期时间`,
  key1005827: `永久有效`,
  key1005828: `未开通`,
  key1005829: `已过期`,
  key1005830: `开通`,
  key1005831: `续费`,
  key1005832: `授权成功！`,
  key1005833: `添加账号成功！`,
  key1005834: `请输入代号、账户名`,
  key1005835: `未添加店铺时，如果需要eDIS发货，请先在eDIS绑定eBayID后再添加店铺。`,
  key1005836: `已添加店铺时，如果需要eDIS发货，请在eDIS绑定eBayID后再重新授权店铺。`,
  key1005837: `新增角色`,
  key1005838: `查看角色`,
  key1005839: `角色描述：`,
  key1005840: `请输入角色描述`,
  key1005841: `权限分配`,
  key1005842: `角色名称`,
  key1005843: `角色描述`,
  key1005844: `用户数量（已启用）`,
  key1005845: `角色下已关联用户时，不能删除角色。`,
  key1005846: `确认要删除该角色？`,
  key1005847: `删除该角色后，将不可恢复，你确认要删除？`,
  key1005848: `删除角色成功！`,
  key1005849: `添加角色`,
  key1005850: `账号类型`,
  key1005851: `主账号`,
  key1005852: `子账号`,
  key1005853: `账号角色`,
  key1005854: `查看用户`,
  key1005855: `添加用户`,
  key1005856: `编辑用户`,
  key1005857: `新增成功，上架工具用户角色授权更新失败！`,
  key1005858: `生成密码`,
  key1005859: `店铺权限`,
  key1005860: `修改密码`,
  key1005861: `请输入手机号码、邮箱或姓名`,
  key1005862: `修改密码后，原密码将不可使用，请谨慎修改！`,
  key1005863: `是否确定取消关注？`,
  key1005864: `请输入供应商名称`,
  key1005865: `粉丝数：`,
  key1005866: `进入店铺`,
  key1005867: `货品费用退费`,
  key1005868: `包裹处理退费`,
  key1005869: `物流退费`,
  key1005870: `国内快递退费`,
  key1005871: `订单取消处理费`,
  key1005872: `货品费用`,
  key1005873: `包裹处理费`,
  key1005874: `物流费`,
  key1005875: `初始化额度`,
  key1005876: `剩余额度`,
  key1005877: `继续支付`,
  key1005878: `支付成功，后台入账中`,
  key1005879: `充值成功`,
  key1005880: `充值失败`,
  key1005881: `,第三方凭证号:`,
  key1005882: `当订单未完成发货时，此时订单消费金额为预扣金额`,
  key1005883: `当您可用余额不足时，系统会自动使用信用额度为您支付；当您进行充值时，充值金额会优先进行信用额度还款；`,
  key1005884: `活动说明`,
  key1005885: `信用额度修改记录`,
  key1005886: `您当前可用余额为`,
  key1005887: `预扣金额为`,
  key1005888: `总计信用额度为`,
  key1005889: `记录`,
  key1005890: `当前已用额度为`,
  key1005891: `当前汇率：1`,
  key1005892: `账户货币为`,
  key1005893: `充值金额不能为空`,
  key1005894: `充值金额格式有误`,
  key1005895: `充值金额不能小于等于0`,
  key1005896: `充值金额不能超过100000000`,
  key1005897: `===支付失败===`,
  key1005898: `余额充值`,
  key1005899: `其他金额`,
  key1005900: `”已开始加工，取消订单此商品费用不退回。`,
  key1005901: `订单取消手续费`,
  key1005902: `取消订单时已距离成功获取物流运单号`,
  key1005903: `min，需要收取物流单作废费用`,
  key1005904: `预扣物流费退费`,
  key1005905: `实扣物流费扣费`,
  key1005906: `预扣服务费退费`,
  key1005907: `实扣服务费扣费`,
  key1005908: `扣款`,
  key1005909: `退款`,
  key1005910: `交易流水号`,
  key1005911: `交易类型`,
  key1005912: `交易时间`,
  key1005913: `交易金额`,
  key1005914: `交易前余额`,
  key1005915: `交易后余额`,
  key1005916: `交易前可用信用额度`,
  key1005917: `交易后可用信用额度`,
  key1005918: `请输入交易流水号,支持多个按行分隔`,
  key1005919: `请输入相关单据号,支持多个按行分隔`,
  key1005920: `交易时间：`,
  key1005921: `交易类型：`,
  key1005922: `导出费用明细`,
  key1005923: `商品单价`,
  key1005924: `实付单价`,
  key1005925: `下单数量`,
  key1005926: `到仓数量`,
  key1005927: `部分货品未到仓，未到仓部分已退款。`,
  key1005928: `用户取消货品数量`,
  key1005929: `商品总重量(g)`,
  key1005930: `货品总值`,
  key1005931: `已付款`,
  key1005932: `供应商已发货`,
  key1005933: `已完结`,
  key1005934: `待备货`,
  key1005935: `未完结`,
  key1005936: `（已取消）`,
  key1005937: `备货至 `,
  key1005938: `取消金额：`,
  key1005939: `商品发货仓选择`,
  key1005940: `匹配商品发货仓`,
  key1005941: `商品发货仓不能为空！`,
  key1005942: `匹配发货仓不能为空`,
  key1005943: `匹配发货仓：`,
  key1005944: `数量（件）`,
  key1005945: `小计`,
  key1005946: `Temu店铺不能为空`,
  key1005947: `Temu订单号不能为空`,
  key1005948: `请先勾选要移除的商品！`,
  key1005949: `编辑收货地址`,
  key1005950: `是否要删除当前收货地址？`,
  key1005951: `取消提示`,
  key1005952: `取消后将不会保存已填写的内容，你确定要取消？`,
  key1005953: `继续填写`,
  key1005954: `订单信息填写不完整，请填写完订单信息再提交!`,
  key1005955: `请选择Temu店铺`,
  key1005956: `请填写Temu订单号`,
  key1005957: `你还未添加商品`,
  key1005958: `处理费=3+(商品数量-1)*0.5`,
  key1005959: `应付总额会在提交订单时进行预扣，请确保账户有足够的余额。`,
  key1005960: `2.发货订单，请务必按照TEMU后台备货单进行下单，不可将多张备货单置于同一`,
  key1005961: `订单下。`,
  key1005962: `收起地址`,
  key1005963: `更多地址`,
  key1005964: `发货订单`,
  key1005965: `寄样订单`,
  key1005966: `删除商品`,
  key1005967: `请注意：`,
  key1005968: `1.寄样订单，若一个SPU下需发多个SKU，请务必将SKU置于一个订单内进行下单。`,
  key1005969: `商品数量：`,
  key1005970: `商品总重量(g)：`,
  key1005971: `收货地址`,
  key1005972: `设为默认地址`,
  key1005973: `点击选择下方由第三方平台买家定制的图片用于定制商品的定制信息配置。（可多选）`,
  key1005974: `合规信息的责任人和制造商不能为空！`,
  key1005975: `请选择收货地址！`,
  key1005976: `商品数量和商品发货仓不能为空！`,
  key1005977: `请先添加商品！`,
  key1005978: `请先选择配送方式！`,
  key1005979: `请先配置IOSS！`,
  key1005980: `账户余额充足，预扣成功`,
  key1005981: `确定商品及发货信息`,
  key1005982: `选择订单商品及其对应的发货仓`,
  key1005983: `订单识别及物流选择`,
  key1005984: `系统将根据商品对应发货仓，自动进行订单拆分`,
  key1005985: `点击提交创建订单`,
  key1005986: `责任人：`,
  key1005987: `数量：`,
  key1005988: `小计：`,
  key1005989: `合规信息`,
  key1005990: `由于欧洲通用产品安全法规（GPSR)和土耳其《通过远程通信工具在市场上提供产品的市场监督和审核规定》已强制实施，按此订单收货地址要求，`,
  key1005991: `订单商品需要粘贴对应合规标签，系统检测到您还未对此商品关联合规信息（或缺少部分合规信息》，无法生成标签；`,
  key1005992: `点击此处创建`,
  key1005993: `订单物流选择`,
  key1005994: `IOSS配置`,
  key1005995: `日志详情`,
  key1005996: `调整前：`,
  key1005997: `调整后：`,
  key1005998: `录入IOSS`,
  key1005999: `使用IOSS：`,
  key1006000: `物流代缴时将产生额外费用，`,
  key1006001: `将代为收取。`,
  key1006002: `前往配置`,
  key1006003: `本单将额外收取`,
  key1006004: `匹配物流不能为空！`,
  key1006005: `匹配物流`,
  key1006006: `匹配物流：`,
  key1006007: `订单发货仓：`,
  key1006008: `更换物流后，清关费用将重新计算，原先收取的费用将退回本单将收取`,
  key1006009: `清关费用`,
  key1006010: `失败原因：`,
  key1006011: `地址更新失败提示`,
  key1006012: `标记已处理`,
  key1006013: `重试`,
  key1006014: `修改物流地址`,
  key1006015: `买家修改地址，修改前后信息如下，请确认是否修改阿里国际订单地址？`,
  key1006016: `原地址：`,
  key1006017: `收件人姓名`,
  key1006018: `联系方式`,
  key1006019: `新地址：`,
  key1006020: `订单中暂无商品`,
  key1006021: `取消订单后，订单不再发货，已装箱订单取消需收取手续费，取消后本单将收取`,
  key1006022: `费用，确定取消订单?`,
  key1006023: `整单取消`,
  key1006024: `取消部分商品`,
  key1006025: `取消部分商品时，取消数量不能全部为空！`,
  key1006026: `取消部分商品时，取消总数量不能大于等于订单总数量！`,
  key1006027: `确认取消订单`,
  key1006028: `订单原因，此原因仅`,
  key1006029: `可见。`,
  key1006030: `取消商品：`,
  key1006031: `请注意，部分取消后此订单将被作废，将会生成新的`,
  key1006032: `订单!`,
  key1006033: `揽收中，正送往ymsWarehouseName仓`,
  key1006034: ` 订单轨迹`,
  key1006035: `订单已确认，待商家拣货`,
  key1006036: `订单已拣货完成，待商家复核`,
  key1006037: `订单已复核完成，待商家打包`,
  key1006038: `快递运输中，正送往ymsWarehouseName,快递单号：expressageNo`,
  key1006039: `ymsWarehouseName已收货，待仓库处理`,
  key1006040: `ymsWarehouseName配货中`,
  key1006041: `货品拣货完成，待仓库包装`,
  key1006042: `货品包装完成，待仓库装箱`,
  key1006043: `仓库已发货，已通知shippingMethodName物流取件`,
  key1006044: `订单已出库，需要尾程物流轨迹，请自行到物流官方网站或第三方平台查询`,
  key1006045: `订单已取消`,
  key1006046: `订单轨迹`,
  key1006047: `请选择取消范围`,
  key1006048: `请选择取消原因`,
  key1006049: `取消平台订单`,
  key1006050: `平台订单交易号`,
  key1006051: `取消部分商品时，取消商品不能全部勾选！`,
  key1006052: `请先勾选需要取消的数据！`,
  key1006053: `当前平台订单中暂无商品`,
  key1006054: `买家提供地址存在问题`,
  key1006055: `应买家要求取消订单`,
  key1006056: `买家未付款`,
  key1006057: `商品缺货或存在其他履约问题`,
  key1006058: `买家不再想要该商品`,
  key1006059: `买家买错商品`,
  key1006060: `买卖双方对此商品存在争议`,
  key1006061: `商品缺货`,
  key1006062: `仅剩次品`,
  key1006063: `仲裁取消`,
  key1006064: `其他原因`,
  key1006065: `买家未领取订单`,
  key1006066: `无法送达该地区`,
  key1006067: `订单被运输途中丢失`,
  key1006068: `客户要求取消`,
  key1006069: `定价错误`,
  key1006070: `欺诈交易，取消订单`,
  key1006071: `买家地址不可用`,
  key1006072: `无法送达`,
  key1006073: `物品已损坏`,
  key1006074: `物品退回发件人`,
  key1006075: `取消范围：`,
  key1006076: `请选择平台订单取消原因，此原因买家可见。`,
  key1006077: `取消平台订单时，系统将自动调用平台接口取消订单,并同时给买家退款!`,
  key1006078: `已装箱订单取消需收取手续费，取消后本单将收取`,
  key1006079: `匹配仓库`,
  key1006080: `仓库选择：`,
  key1006081: `付款状态`,
  key1006082: `去付款`,
  key1006083: `更新状态`,
  key1006084: `付款确认`,
  key1006085: `是否付款成功？`,
  key1006086: `状态未更新提示`,
  key1006087: `获取到阿里国际订单信息状态仍为未付款，请稍后重试或手动标记为已成功。`,
  key1006088: `手动标记`,
  key1006089: `由于此订单由阿里国际多商家履约，已自动拆分为不同订单，需按订单进行支付。`,
  key1006090: `需更换数量`,
  key1006091: `需小于订单数量`,
  key1006092: `原订单内SKU信息`,
  key1006093: `替换SKU信息`,
  key1006094: `替换商品为当前商品`,
  key1006095: `更换商品数量需小于订单数量`,
  key1006096: `未选择更换订单商品`,
  key1006097: `未输入选择商品的替换数量`,
  key1006098: `请选择替换商品`,
  key1006099: `提交中`,
  key1006100: `更换订单商品`,
  key1006101: `订单！`,
  key1006102: `确认更换`,
  key1006103: `请选择需更换的商品及数量`,
  key1006104: `校验中...`,
  key1006105: `地址变更提示`,
  key1006106: `当前物流方式不支持此地区，更换地址后物流方式将被置空，请在待处理状态中重新匹配物流。请确认是否变更地址?`,
  key1006107: `确定变更`,
  key1006108: `修改中...`,
  key1006109: `修改收货人信息`,
  key1006110: `买家姓名：`,
  key1006111: `地址1：`,
  key1006112: `地址2：`,
  key1006113: `州/省：`,
  key1006114: `当前所选目的国家需要录入IOSS相关信息`,
  key1006115: `当前所选目的国家需要配置订单商品合规信息`,
  key1006116: `请注意，修改地址信息后此订单将作废并生成新的订单!`,
  key1006117: `已处理`,
  key1006118: `预计 `,
  key1006119: ` 到货`,
  key1006120: `此时间为供应商仓预计到货时间，距尾程包裹发出时间仍需2~3天。`,
  key1006121: `出库单编号`,
  key1006122: `收货人名称`,
  key1006123: `买家识别号`,
  key1006124: `详细地址1`,
  key1006125: `详细地址2`,
  key1006126: `邮寄方式`,
  key1006127: `物流商称重（g）`,
  key1006128: `物流商运费`,
  key1006129: `待物流揽收`,
  key1006130: `供应商备货中`,
  key1006131: `物流已揽收`,
  key1006132: `平台订单自动创建`,
  key1006133: `订单中存在定制商品，在运营系统没有标记允许取消之前，只允许更换订单非定制商品。`,
  key1006134: `订单中存在定制商品，若需要取消订单请联系平台运营。`,
  key1006135: `订单详情`,
  key1006136: `计费重量(`,
  key1006137: `由于价格调整待供应商接单暂无法付款`,
  key1006138: `商品已停售`,
  key1006139: `部分取消成功！`,
  key1006140: `取消数量不能为空`,
  key1006141: `部分取消`,
  key1006142: `订单商品信息`,
  key1006143: `订单号,支持多个按行分隔`,
  key1006144: `第三方单号：`,
  key1006145: `获取运单号失败，请联系平台运营`,
  key1006146: `需通过快递发至揽收点的包裹将加收国内快递费。具体费用可在自有物流模块中点击对应渠道查看。`,
  key1006147: `订单备注`,
  key1006148: `目的地及买家信息`,
  key1006149: `目的地：`,
  key1006150: `买家ID：`,
  key1006151: `自动取消倒计时：`,
  key1006152: `商品费：`,
  key1006153: `实扣处理费：`,
  key1006154: `预扣处理费：`,
  key1006155: `实扣物流费：`,
  key1006156: `清关费用：`,
  key1006157: `预扣物流费：`,
  key1006158: `取消订单确认`,
  key1006159: `是否确认取消该订单，取消后的订单将会移入“已取消”列表，订单信息无法直接恢复，请谨慎操作!`,
  key1006160: `全部 `,
  key1006161: `下发物流失败`,
  key1006162: `请输入第三方单号,支持多个按行分隔`,
  key1006163: `请输入运单号,支持多个按行分隔`,
  key1006164: `实扣处理费(CNY)`,
  key1006165: `预扣处理费(CNY)`,
  key1006166: `待处理`,
  key1006167: `第三方订单：`,
  key1006168: `请输入第三方订单,支持多个按行分隔`,
  key1006169: `订单备注：`,
  key1006170: `付款状态：`,
  key1006171: `添加订单`,
  key1006172: `批量导入订单`,
  key1006173: `批量付款`,
  key1006174: `账户补充信息：`,
  key1006175: `账户完整信息`,
  key1006176: `非`,
  key1006177: `是否确认下`,
  key1006178: `订单？`,
  key1006179: `执行发货后，`,
  key1006180: `将自动流转Temu订单状态，勾选的订单将作为一个物流包裹发出。`,
  key1006181: `正在确认通过`,
  key1006182: `履约速卖通全托管JIT订单，由于JIT订单限制较多，若出现平台处罚，`,
  key1006183: `将按照售后条款进行处理，无额外赔付，请确认是否接单？`,
  key1006184: ` 平台订单信息`,
  key1006185: `PO单号：`,
  key1006186: `平台订单商品信息`,
  key1006187: `待接单`,
  key1006188: `是否有退款：`,
  key1006189: `是否标发货：`,
  key1006190: `执行发货状态：`,
  key1006191: `下单数量：`,
  key1006192: `买家备注：`,
  key1006193: `平台订单异常`,
  key1006194: `分销订单信息`,
  key1006195: `阿里国际站订单`,
  key1006196: `发货物流：`,
  key1006197: `分销订单商品信息`,
  key1006198: `分销订单状态`,
  key1006199: `分销订单金额`,
  key1006200: `分销订单异常`,
  key1006201: `匹配商品`,
  key1006202: `处理订单`,
  key1006203: `标发货`,
  key1006204: `确认等待`,
  key1006205: `接单`,
  key1006206: `修改物流`,
  key1006207: `Temu发货仓匹配`,
  key1006208: `关联合规信息`,
  key1006209: `已下单`,
  key1006210: `已标发货`,
  key1006211: `平台订单已取消`,
  key1006212: `待匹配商品`,
  key1006213: `匹配物流失败`,
  key1006214: `PO单号`,
  key1006215: `所属平台`,
  key1006216: `平台订单标发货状态`,
  key1006217: `订单原始SKU*数量`,
  key1006218: `平台订单是否有退款`,
  key1006219: `平台订单异常状态`,
  key1006220: `买家ID`,
  key1006221: `买家姓名`,
  key1006222: `买家备注`,
  key1006223: `分销订单号`,
  key1006224: `分销订单SKU信息`,
  key1006225: `实付处理费(CNY)`,
  key1006226: `物流费(CNY)`,
  key1006227: `分销订单创建时间`,
  key1006228: `分销订单发货时间`,
  key1006229: `分销订单发货时效`,
  key1006230: `可输入平台订单号、PO单号、分销订单号、包裹号、买家ID、 买家姓名、SKU、平台产品编码`,
  key1006231: `可输入平台订单号、分销订单号、包裹号、买家ID、 买家姓名、SKU、平台产品编码`,
  key1006232: `请输入平台订单号，支持多个逗号或换行分隔`,
  key1006233: `请输入PO单号，支持多个逗号或换行分隔`,
  key1006234: `请先勾选要标发货的数据！`,
  key1006235: `标记发货中，请稍后刷新页面查看。`,
  key1006236: `请先勾选要下单的数据！`,
  key1006237: `下单提示`,
  key1006238: `部分下单异常`,
  key1006239: `不同店铺的订单不可同时执行发货！`,
  key1006240: `仅待执行发货的订单可执行发货，请重新选择！`,
  key1006241: `执行发货`,
  key1006242: `执行发货成功!`,
  key1006243: `手工订单和平台订单不可同时执行发货，请分批操作！`,
  key1006244: `样品订单与发货订单不可同时执行发货，请分批操作！`,
  key1006245: `请先勾选要执行发货的数据！`,
  key1006246: `确认等待订单`,
  key1006247: `正在操作确认等待订单，若订单未按时间到达，仍会进行二次提醒，请确认是否等待订单到货？`,
  key1006248: `手动标记发货`,
  key1006249: `系统向平台标记发货失败，请前往平台后台进行标记发货，在平台后台标记发货后可在此处点击确认已标记发货按钮将此订单异常状态消除。`,
  key1006250: `确认已标记发货`,
  key1006251: `只有待接单的订单才能进行接单！`,
  key1006252: `请先勾选需要接单的数据！`,
  key1006253: `确认接单`,
  key1006254: `接单成功！`,
  key1006255: `部分接单异常`,
  key1006256: `样品订单`,
  key1006257: `货品订单`,
  key1006258: `常规订单`,
  key1006259: `速卖通全托管订单`,
  key1006260: `平台订单已取消，请自行前往阿里国际中取消订单，取消后请手动标记已处理。`,
  key1006261: `所属平台：`,
  key1006262: `分销订单状态：`,
  key1006263: `所属店铺：`,
  key1006264: `平台订单异常状态：`,
  key1006265: `分销订单异常状态：`,
  key1006266: `导出平台订单`,
  key1006267: `批量标记非`,
  key1006268: `批量接单`,
  key1006269: `标发货设置`,
  key1006270: `备货单信息`,
  key1006271: `采购状态：`,
  key1006272: `备货仓：`,
  key1006273: `采购商品信息`,
  key1006274: `货品总值：`,
  key1006275: `时间信息`,
  key1006276: `取消时间：`,
  key1006277: `部分补货中`,
  key1006278: `取消交易`,
  key1006279: `缺货-补货中`,
  key1006280: `缺货-已停售`,
  key1006281: `采购状态`,
  key1006282: `备货仓`,
  key1006283: `已取消金额`,
  key1006284: `已退款金额`,
  key1006285: `SKU实付单价`,
  key1006286: `取消交易提示`,
  key1006287: `正在操作取消备货单，请确认是否取消？`,
  key1006288: `取消交易成功！`,
  key1006289: `可搜索商品名称、`,
  key1006290: `关键词搜索：`,
  key1006291: `导出备货单`,
  key1006292: `该渠道账户已被停用，请联系运营人员或选择其他支付渠道账户`,
  key1006293: `编辑支付凭证`,
  key1006294: `查看支付凭证`,
  key1006295: `修改支付凭证`,
  key1006296: `支付流水图片不能为空！`,
  key1006297: `请选择责任人和制造商！`,
  key1006298: `条码缺失提示`,
  key1006299: `以下商品无`,
  key1006300: `信息，请在`,
  key1006301: `我的商品`,
  key1006302: `中上传后重试。`,
  key1006303: `来源备注只能输入英文！`,
  key1006304: `文件格式有误,仅支持 xls、xlsx格式文件`,
  key1006305: `请输入订单备注`,
  key1006306: `3、文件上传成功后，解析对应的订单内容会存入“`,
  key1006307: `订单-待付款”状态列表，需用户二次`,
  key1006308: `确认下单后才会创建`,
  key1006309: `订单。`,
  key1006310: `1、请确保文件内容中订单商品信息以及文件表头字段对应关系的准确无误，若文件中存在无`,
  key1006311: `效内容，会导致文件上传失败;`,
  key1006312: `2、当前仅支持xls、xlsx格式文件`,
  key1006313: `应付总额`,
  key1006314: `退回原因`,
  key1006315: `取消付款`,
  key1006316: `取消确认`,
  key1006317: `是否确认取消该付款信息？`,
  key1006318: `到仓详情`,
  key1006319: `平台商品匹配`,
  key1006320: `定制商品已进入加工环节，无法删除/修改其任何信息，如需调整请联系运营。`,
  key1006321: `调整订单`,
  key1006322: `提交调整`,
  key1006323: `点击提交调整订单`,
  key1006324: `点击提交添加订单`,
  key1006325: `调整成功`,
  key1006326: `请问是否确认将此订单中最后一件商品标记为“不匹配YMSSKU”？`,
  key1006327: `若确定，由于此订单中所有商品均被标记为“不匹配YMSSKU”，系`,
  key1006328: `统将自动把此平台订单标记为“`,
  key1006329: `国内快递单号`,
  key1006330: `Temu后台发货仓库`,
  key1006331: `下载订单`,
  key1006332: `已标记发货`,
  key1006333: `待标记发货`,
  key1006334: `订单已整单取消`,
  key1006335: `订单已部分取消`,
  key1006336: `阿里国际商家已发货`,
  key1006337: `，预计到货时间：`,
  key1006338: `，已停售`,
  key1006339: `标记确认提示`,
  key1006340: `匹配成功!`,
  key1006341: `若未匹配平台商品，可能会导致线上物流发货失败`,
  key1006342: `匹配SKU成功`,
  key1006343: `匹配SKU成功(人工匹配)`,
  key1006344: `不匹配`,
  key1006345: `订单未接单，系统将在您接单之后自动匹配`,
  key1006346: `提示：匹配的`,
  key1006347: `商品中存在支持定制的商品，请先配置对应定制信息；`,
  key1006348: `（原SKU：`,
  key1006349: `阿里国际单号：`,
  key1006350: `分销单号：`,
  key1006351: `展开`,
  key1006352: `原始SKU：`,
  key1006353: `物流服务：`,
  key1006354: `价格及数量`,
  key1006355: `已解码SKU：`,
  key1006356: `商品为空，无法关联`,
  key1006357: `重新匹配`,
  key1006358: `匹配SKU失败`,
  key1006359: `手动匹配`,
  key1006360: `SKU已停售，请取消或更换商品`,
  key1006361: `点击配置定制信息`,
  key1006362: `点击关联合规信息`,
  key1006363: `总费用=商品+处理费+物流费`,
  key1006364: `处理费=3+（商品数量-1）*0.5`,
  key1006365: `总费用(`,
  key1006366: `商品费(`,
  key1006367: `处理费(`,
  key1006368: `物流费(`,
  key1006369: `国内快递费(`,
  key1006370: `清关费用(`,
  key1006371: `拆分订单`,
  key1006372: `平台商品匹配：`,
  key1006373: `商品对应发货仓库存不足，请操作调整此商品的订单数量或商品发货仓`,
  key1006374: `收货地址信息：`,
  key1006375: `查看&修改`,
  key1006376: `阿里国际订单信息`,
  key1006377: `平台订单地址信息`,
  key1006378: `暂无更多数据...`,
  key1006379: `删除模板确认`,
  key1006380: `是否确认删除模板，删除后信息不可恢复，请谨慎操作！`,
  key1006381: `创建日期：`,
  key1006382: `新建模板`,
  key1006383: `第三方订单号`,
  key1006384: `配送至（国家）`,
  key1006385: `收货人姓名`,
  key1006386: `邮箱地址`,
  key1006387: `IOSS号`,
  key1006388: `内容性质`,
  key1006389: `处理方式`,
  key1006390: `映射`,
  key1006391: `Excel文件列标题`,
  key1006392: `映射的Excel文件列标题不能为空！`,
  key1006393: `订单多SKU导入方式：`,
  key1006394: `模板字段映射`,
  key1006395: `多商品时，第二个商品SKU列标题以第一个商品SKU列标题按数字递增；`,
  key1006396: `如：商品SKU原列标题名称为“商品SKU”，如果存在多个商品，那么第一`,
  key1006397: `个商品SKU列标题名称则设为“商品SKU1”，`,
  key1006398: `第二个商品SKU列标题名称`,
  key1006399: `设为“商品SKU2”，以此递增；`,
  key1006400: `注:输入框内仅需输入第一个商品SKU列标题即可，“数量`,
  key1006401: `内容同理;`,
  key1006402: `文件中出现相同订单号时：`,
  key1006403: `认为是包含多SKU的订单`,
  key1006404: `报错`,
  key1006405: `文件中订单号在系统相同备注中已存在时：`,
  key1006406: `忽略并导入其他订单`,
  key1006407: `仓库存`,
  key1006408: `请选择备货仓库!`,
  key1006409: `账户余额充足，支付成功`,
  key1006410: `备货仓库`,
  key1006411: `下单后自动付款`,
  key1006412: `可选择以下任一`,
  key1006413: `订单节点作为标发货节点：`,
  key1006414: `配置方式：`,
  key1006415: `全局统一配置`,
  key1006416: `按平台配置`,
  key1006417: `物流不能为空`,
  key1006418: `物流：`,
  key1006419: `此信息需与买手确认，未填写时将不在包裹上额外粘贴收货信息`,
  key1006420: `收货人：`,
  key1006421: `请填写收货人`,
  key1006422: `收货组：`,
  key1006423: `请填写收货组`,
  key1006424: `运费将附加在执行发货的首个订单中`,
  key1006425: `第一步：选择物流`,
  key1006426: `第二步：填写收件信息`,
  key1006427: `包裹编号`,
  key1006428: `包裹重量（g）`,
  key1006429: `包裹货品总数`,
  key1006430: `上传打包标签`,
  key1006431: `无需上传标签`,
  key1006432: `请先上传打包标签!`,
  key1006433: `物流单号不能为空!`,
  key1006434: `请填写物流单号`,
  key1006435: `第一步：上传打包标签`,
  key1006436: `第二步：填写物流单号`,
  key1006437: `订单内需保持发货仓唯一！`,
  key1006438: `订单内需保持发货仓唯一，若有特殊需求请增加新订单操作`,
  key1006439: `商品数量不能为空`,
  key1006440: `负责人和制造商不能为空！`,
  key1006441: `拆单成功`,
  key1006442: `拆分订单确认`,
  key1006443: `重量：`,
  key1006444: `原数量：`,
  key1006445: `拆分后数量：`,
  key1006446: `拆分后订单信息`,
  key1006447: `增加订单`,
  key1006448: `待选择物流渠道`,
  key1006449: `删除订单`,
  key1006450: `订单拆分前后货品数量不一致，请确认是否拆包？`,
  key1006451: `仓库发货可用物流`,
  key1006452: `规则状态：`,
  key1006453: `请输入规格名称`,
  key1006454: `新增仓库规则`,
  key1006455: `规则名不能为空`,
  key1006456: `订单商品发货仓不能为空`,
  key1006457: `订单商品发货仓选择：`,
  key1006458: `派送范围：`,
  key1006459: `帐号名称不能为空`,
  key1006460: `账户授权`,
  key1006461: `帐号名称：`,
  key1006462: `正在启用`,
  key1006463: `账户，请确认后操作。`,
  key1006464: `停用该`,
  key1006465: `账户后，相关联的店铺将无法下发物流，请确认是否停用账户？`,
  key1006466: `物流渠道代码`,
  key1006467: `物流类型`,
  key1006468: `关联店铺`,
  key1006469: `停用物流提示`,
  key1006470: `停用该物流后，将无法适用该物流进行下发，请确认是否停用？`,
  key1006471: `启用物流提示`,
  key1006472: `正在启用物流，请确认后操作。`,
  key1006473: `启用渠道提示`,
  key1006474: `正在启用物流渠道，请确认后操作。`,
  key1006475: `启用账户提示`,
  key1006476: `停用渠道提示`,
  key1006477: `停用该物流渠道后，将无法适用该物流渠道进行下发，请确认是否停用？`,
  key1006478: `停用账户提示`,
  key1006479: `帐号`,
  key1006480: `平台店铺：`,
  key1006481: `未启用`,
  key1006482: `请您按照以下要求上传营业执照，如您没有按要求上传，您的申请可能会被拒绝`,
  key1006483: `请确保营业执照图片字体清晰，边角完整，无任何无关水印，不可故意遮盖二维码或信息。若拍摄模糊建议上传扫描件。`,
  key1006484: `请您先自行在国家企业信用信息公示系统查询您填写的统一社会信用代码/注册号，确保能查询到您的主体信息，且登记状态为“存续（在营、开业、在册）”。`,
  key1006485: `若公司名称或法定代表人等信息发生过变更，请上传最新核准日期的营业执照图片。`,
  key1006486: `示例图`,
  key1006487: `请您按照以下要求上传，不符合以下规范将会被审核驳回`,
  key1006488: `请确保您所上传法定代表人身份证上的姓名与营业执照上的法定代表人姓名一致。`,
  key1006489: `请确认法定代表人身份证字体清晰无反光、边角完整，无任何无关水印及故意遮盖。`,
  key1006490: `平台隐私政策`,
  key1006491: `请选择[jpg、jpeg、png]`,
  key1006492: `公司名称不能为空`,
  key1006493: `法人身份证国徽面`,
  key1006494: `法人身份证人像面`,
  key1006495: `请先上传法人身份证国徽面`,
  key1006496: `请先上传法人身份证人像面`,
  key1006497: `法定代表人身份证照规范`,
  key1006498: `营业执照规范`,
  key1006499: `请填写营业执照上公司全称`,
  key1006500: `密码长度必须为8~26位`,
  key1006501: `请先填写手机号和图形验证码！`,
  key1006502: `账号注册成功`,
  key1006503: `你的账号已注册成功，请继续完善入驻信息，完成入驻！`,
  key1006504: `请先勾选我已阅读并同意`,
  key1006505: `设置密码不能为空`,
  key1006506: `设置密码与确认密码不一致`,
  key1006507: `图形验证码：`,
  key1006508: `请输入短信验证码`,
  key1006509: `设置密码：`,
  key1006510: `8~26位（建议使用两种或两种以上字符组合）`,
  key1006511: `确认密码：`,
  key1006512: `请再次输入密码`,
  key1006513: `此手机号已注册分销商，继续则视为以此账户入驻供应商`,
  key1006514: `我已阅读并同意`,
  key1006515: `填写账号信息`,
  key1006516: `填写企业信息`,
  key1006517: `入驻资料审核`,
  key1006518: `注册成功`,
  key1006519: `已有账号？`,
  key1006520: `立即登录`,
  key1006521: `提交成功`,
  key1006522: `你的申请材料已提交，通常我们会在3个工作日`,
  key1006523: `内完成审核，请耐心等待，如你有任何疑问，请`,
  key1006524: `联系在线客服！`,
  key1006525: `入驻信息审核中，请耐心等待~`,
  key1006526: `审核通过后，即可正常使用供应商后台，如你有`,
  key1006527: `任何疑问，请联系在线客服！`,
  key1006528: `你的申请，审核未通过`,
  key1006529: `请核对并修改以下信息后，再重新提交。`,
  key1006530: `重新修改`,
  key1006531: `一切就绪`,
  key1006532: `你的申请，已经审核通过！`,
  key1006533: `去发布商品`,
  key1006534: `正在退出`,
  key1006535: `手机号码/邮箱/通途账号不能为空`,
  key1006536: `短信验证码不能为空`,
  key1006537: `账号登录`,
  key1006538: `手机号码/邮箱/通途账号`,
  key1006539: `密码`,
  key1006540: `验证码`,
  key1006541: `短信登录`,
  key1006542: `短信验证码`,
  key1006543: `立即授权`,
  key1006544: `找回密码`,
  key1006545: `注册成功！`,
  key1006546: `手机号注册`,
  key1006547: `邮箱注册`,
  key1006548: `邮箱（可不填）`,
  key1006549: `通途登录`,
  key1006550: `登录将为您开通`,
  key1006551: `商城分销权限。`,
  key1006552: `欢迎注册`,
  key1006553: `已有账号，请登录`,
  key1006554: `通途账号登录`,
  key1006555: `如果您已有通途账号，可直接使用通途账号登录。`,
  key1006556: `手机号/邮箱不能为空`,
  key1006557: `确认密码不能为空`,
  key1006558: `提 交`,
  key1006559: `设置密码`,
  key1006560: `请输入邮箱 / 已验证手机号`,
  key1006561: `去登录`,
  key1006562: `首页`,
  key1006563: `供应商只需发货至`,
  key1006564: `集运仓库`,
  key1006565: `协助进行产品调研，确定产品符合市场需求，且具备价格竞争优势。`,
  key1006566: `入驻资料提交后，`,
  key1006567: `将在3个工作日内完成审核。`,
  key1006568: `专`,
  key1006569: `专注跨境电商`,
  key1006570: `10余年专业跨境电商服装产品团队`,
  key1006571: `广`,
  key1006572: `覆盖主流电商平台`,
  key1006573: `分销店铺覆盖Amazon、eBay等主流电商平台`,
  key1006574: `集`,
  key1006575: `订单集中处理`,
  key1006576: `免`,
  key1006577: `免仓储服务费`,
  key1006578: `入驻即获得仓储免费服务`,
  key1006579: `快速代发`,
  key1006580: `一站式代发系统托管，节省仓储精力，控制人工成本`,
  key1006581: `女 装`,
  key1006582: `男 装`,
  key1006583: `女 童`,
  key1006584: `男 童`,
  key1006585: `婴 童`,
  key1006586: `产品调研`,
  key1006587: `注册账号`,
  key1006588: `按要求填写账号信息，注册企业账号。`,
  key1006589: `填写入驻资料`,
  key1006590: `提交营业执照、法定代表人身份证，填写店铺相关信息。`,
  key1006591: `入驻完成`,
  key1006592: `审核通过后，供应商登录后台，发布商品开始销售。`,
  key1006593: `欢迎加入`,
  key1006594: `分销平台`,
  key1006595: `是中国领先的跨境服装一站式分销平台，创始团队成员深耕跨境行业十多年，有着丰富且优质的跨境电商供应链资源，`,
  key1006596: `量标准及`,
  key1006597: `上架规范；`,
  key1006598: `• 认同`,
  key1006599: `发展理念，抱有真诚长远的合作态度。`,
  key1006600: `• 保证商品在发货期内到达`,
  key1006601: `仓库。`,
  key1006602: `即刻入驻`,
  key1006603: `供应商，即享快速代发新模式`,
  key1006604: `诚邀你加入我们，成为我们的优质伙伴，赶快点击入驻！`,
  key1006605: `供应商入驻指南`,
  key1006606: `立即入驻`,
  key1006607: `可提供集货、仓储、物流、分销等一体化服务，可帮助源头工厂、品牌代理商、工贸一体企业等类型供应商拓展海外销路，`,
  key1006608: `秉承着“合作共赢、共同发展”的经营理念，现诚邀优质跨境电商货源供应商加入，助力您的海外市场。`,
  key1006609: `我们的优势`,
  key1006610: `招商品类`,
  key1006611: `供应商资质要求`,
  key1006612: `企业资料`,
  key1006613: `入驻材料`,
  key1006614: `材料要求`,
  key1006615: `三证合一的企业营业执照；`,
  key1006616: `确保申请入驻的企业不在《经营异常名录》中，且所销售的`,
  key1006617: `商品在其经营范围内；`,
  key1006618: `距离有效期截止时间应大于3个月。`,
  key1006619: `身份证`,
  key1006620: `法人身份证；`,
  key1006621: `距离有效期截止时间应大于1个月。`,
  key1006622: `支持银行卡或支付宝。`,
  key1006623: `产品要求`,
  key1006624: `产品资质`,
  key1006625: `商品合法合规`,
  key1006626: `承诺提供的商品合法合规，符合销售目的地的法律法规、质`,
  key1006627: `专利产品，需提供销售区域专利证书；`,
  key1006628: `有品牌的供应商，需提供品牌授权书；`,
  key1006629: `具备稳定的供货渠道，愿意遵循平台规则。`,
  key1006630: `真诚长远合作`,
  key1006631: `保证商品价格全网最低；`,
  key1006632: `订单履约`,
  key1006633: `入驻流程`,
  key1006634: `帮助首页`,
  key1006635: `请描述你的问题，如：物流`,
  key1006636: `视频教程`,
  key1006637: `自助服务`,
  key1006638: `定期更换密码有助于保障账户安全`,
  key1006639: `修改手机号码`,
  key1006640: `手机号涉及登录、认证等关键业务，保障账户安全`,
  key1006641: `邮箱涉及登录、消息通知等关键业务，并保障账户安全`,
  key1006642: `搜索“`,
  key1006643: `”的相关结果，共`,
  key1006644: `无匹配搜索结果`,
  key1006645: `每日上新`,
  key1006646: `HOT 热销商品`,
  key1006647: `潮流女装`,
  key1006648: `时尚男装`,
  key1006649: `精品童装`,
  key1006650: `好货推荐`,
  key1006651: `登录查看价格`,
  key1006652: `请先勾选要删除的数据！`,
  key1006653: `商品数量总计：`,
  key1006654: `此商品已停售，点击`,
  key1006655: `此商品信息`,
  key1006656: `请先添加商品至购物车`,
  key1006657: `立即结算`,
  key1006658: `商城（www.yms.com）是深圳云卖供应链管理有限公司建立的一个专注跨境电商服装品类的供应链服务平台。平台集成源头工厂服装商城、通途Listing刊登平台、通途ERP平台和通途物流平台，为跨境电商卖家与源头工厂打通了一条高效的订单履约链路，国外销售终端的顾客订单直接由源头工厂一件代发。`,
  key1006659: `免费注册账号，在`,
  key1006660: `商城订阅商品`,
  key1006661: `店铺出单后，即可在`,
  key1006662: `商城下单，支持一件代发`,
  key1006663: `商城跨境电商，专注于服装分销`,
  key1006664: `现在你可以把成千上万的服装商品从`,
  key1006665: `商城刊登到海外各大平台，从而赢得更多的销售机会`,
  key1006666: `商城提供开放接口，可实现商品管理、订单管理、仓储管理等诸多功能`,
  key1006667: `只需3步，让跨境生意更简单`,
  key1006668: `你只需专注于运营，其他的，我们来帮你解决`,
  key1006669: `选品`,
  key1006670: `刊登`,
  key1006671: `直连通途Listing刊登系统，一键快速上架到eBay、Amazon等多平台店铺`,
  key1006672: `海量商品选购`,
  key1006673: `40000+服装SKU，1000+每月上新`,
  key1006674: `0库存风险`,
  key1006675: `无需国货备货，0库存风险`,
  key1006676: `无资金压力`,
  key1006677: `先出单后付款，提升资金周转率`,
  key1006678: `你只需专注于商品销售，就算只卖出一件商品，我们也会贴心地帮你发货`,
  key1006679: `快速上架到多平台`,
  key1006680: `自有品牌标识，让客户更信赖`,
  key1006681: `可以通过包裹、包装标识自有品牌，让客户更信赖`,
  key1006682: `订单自动跟踪`,
  key1006683: `销售订单系统自动跟踪，无需复制和粘贴客户订单详细信息`,
  key1006684: `发货快，出货时效有保障`,
  key1006685: `开放API接口`,
  key1006686: `平台业务介绍`,
  key1006687: `① 注册成为`,
  key1006688: `商城分销商`,
  key1006689: `在`,
  key1006690: `商城选品收藏商品，通途Listing系统快速刊登到eBay、Walmart、速卖通等平台销售。`,
  key1006691: `通途ERP抓取平台订单，匹配分销商设定的国际物流方式，下发至`,
  key1006692: `商城。订单即可履约一件代发给国外顾客。`,
  key1006693: `1）服务内容：跨境电商服装品类的工厂入驻`,
  key1006694: `商城开设直营店铺。`,
  key1006695: `1）服务内容：为`,
  key1006696: `商城供应商提供仓储服务。`,
  key1006697: `商城供应商开通云仓。`,
  key1006698: `② 中心仓备货和发货，供应商创建备货计划，贴`,
  key1006699: `商城商品条码入仓，中心仓自动匹配订单发货。`,
  key1006700: `分销商业务`,
  key1006701: `1）服务内容：为跨境电商服装卖家的eBay、Walmart、速卖通、Wish、Shopify等平台订单提供源头工厂现货一件代发服务。`,
  key1006702: `2）服务流程：`,
  key1006703: `方案1：通过通途ERP账户（http:`,
  key1006704: `方案2：直接手机号注册开通。`,
  key1006705: `刊登销售`,
  key1006706: `订单发货`,
  key1006707: `供应商业务`,
  key1006708: `服装工厂联系供应商招商经理注册进驻。`,
  key1006709: `经营店铺，规范上架商品，管理库存，操作订单发货。`,
  key1006710: `中心仓仓储业务`,
  key1006711: `深圳云卖供应链管理有限公司`,
  key1006712: `联系地址：深圳市南山区学苑大道南山智园C1栋6楼`,
  key1006713: `联系电话：400-0600-405`,
  key1006714: `关注店铺`,
  key1006715: `可定制部位`,
  key1006716: `可定制区域(长*宽cm)`,
  key1006717: `可定制区域`,
  key1006718: `(长*宽cm)`,
  key1006719: `定制工艺`,
  key1006720: `定制费用`,
  key1006721: `费用：登录后展示`,
  key1006722: `定制说明`,
  key1006723: `已停售商品不能收藏`,
  key1006724: `取消收藏成功`,
  key1006725: `此商品已停售！`,
  key1006726: `★ 已关注`,
  key1006727: `库存不足，无法购买！`,
  key1006728: `加入购物车成功！`,
  key1006729: `免费`,
  key1006730: `官方闪电发货品质无忧之选`,
  key1006731: `平台供应商直发仓`,
  key1006732: `商品暂无库存，请先购买其他商品`,
  key1006733: `达到上一销量后可查看`,
  key1006734: `三方仓`,
  key1006735: `单件包装尺寸(cm)：`,
  key1006736: `预计交货时间(天)：`,
  key1006737: `运费(`,
  key1006738: `邮编`,
  key1006739: `当前位置：`,
  key1006740: `上架时间：`,
  key1006741: `库存：登录后展示`,
  key1006742: `价格：登录后展示`,
  key1006743: `优惠`,
  key1006744: `30天内累计分销`,
  key1006745: `折`,
  key1006746: `减`,
  key1006747: `件以上`,
  key1006748: `暂无物流可达`,
  key1006749: `收藏`,
  key1006750: `一键刊登支持以下平台`,
  key1006751: `提前定制设计，稍后来单轻松处理`,
  key1006752: `价格：登录后可见`,
  key1006753: `商品详细信息`,
  key1006754: `物品参数`,
  key1006755: `供应商建议`,
  key1006756: `暂无权限查看，请联系客服开通权限。`,
  key1006757: `入门视频`,
  key1006758: `新用户入门操作`,
  key1006759: `新用户注册`,
  key1006760: `授权店铺`,
  key1006761: `一键刊登流程`,
  key1006762: `一键刊登成功前提：成功授权店铺`,
  key1006763: `设置店铺刊登模板`,
  key1006764: `一键刊登规则`,
  key1006765: `第一步：刊登模板设置`,
  key1006766: `刊登模板设置`,
  key1006767: `第二步：刊登规则设置`,
  key1006768: `刊登规则设置`,
  key1006769: `第三步：一键刊登`,
  key1006770: `更换成功！`,
  key1006771: `操作失败！`,
  key1006772: `更换规格`,
  key1006773: `创建成功提示`,
  key1006774: `订单创建成功，是否点击查看订单列表？`,
  key1006775: `公司档案`,
  key1006776: `地址：`,
  key1006777: `是否收藏：`,
  key1006778: `一键刊登支持平台：`,
  key1006779: `是否支持定制：`,
  key1006780: `修改商品原产地`,
  key1006781: `设置商品原产地`,
  key1006782: `您更改提交的`,
  key1006783: `已被平台驳回！请查看驳回原因后重新提交审核。`,
  key1006784: `，平台正在审核中......`,
  key1006785: `平台已审核通过！`,
  key1006786: `商户工商信息`,
  key1006787: `工商信息已经在审核中，暂不支持修改！`,
  key1006788: `店铺信息已经在审核中，暂不支持修改！`,
  key1006789: `确认后不保存已编辑信息`,
  key1006790: `结算币种：`,
  key1006791: `商品默认原产地：`,
  key1006792: `修改原产地 >`,
  key1006793: `请设置原产地 >`,
  key1006794: `查看驳回原因>>>`,
  key1006795: `绑定收款账户`,
  key1006796: `（推荐）`,
  key1006797: `绑定`,
  key1006798: `绑定账户`,
  key1006799: `更换账户`,
  key1006800: `更换绑定`,
  key1006801: `变更时间`,
  key1006802: `暂未添加`,
  key1006803: `添加收款账户`,
  key1006804: `暂未绑定`,
  key1006805: `更换收款账户`,
  key1006806: `收款信息已经在审核中，暂不支持修改！`,
  key1006807: `(推荐)`,
  key1006808: `变更日志`,
  key1006809: `修改失败`,
  key1006810: `角色`,
  key1006811: `审核中,审核后将展示补贴金额。`,
  key1006812: `符合`,
  key1006813: `不满足现有补贴规则、如有疑问请联系您的`,
  key1006814: `对接人员`,
  key1006815: `收货时间`,
  key1006816: `应发部分实到数量`,
  key1006817: `多发数量`,
  key1006818: `发往仓库`,
  key1006819: `追加货品`,
  key1006820: `作废提单`,
  key1006821: `作废提单提示`,
  key1006822: `提单作废后，提单内所有订单将流转至待重发状态，出库单将流转至待拣货状态，请确认是否作废提单?`,
  key1006823: `三方提单号`,
  key1006824: `物流单号`,
  key1006825: `请输入提单编号,支持多个逗号或换行分隔`,
  key1006826: `请输入订单号,支持多个逗号或换行分隔`,
  key1006827: `作废成功!`,
  key1006828: `运营商操作`,
  key1006829: `无法备货提示`,
  key1006830: `以下商品为未维护目标备货仓库“`,
  key1006831: `”对应国家“`,
  key1006832: `”的供货价格，请于`,
  key1006833: `商品列表-商品详情-价格库存`,
  key1006834: `”信息模块处进行维护；`,
  key1006835: `去维护`,
  key1006836: `修改后数量`,
  key1006837: `未输入时视为不修改`,
  key1006838: `请输入需修改的商品数量`,
  key1006839: `修改备货数量成功!`,
  key1006840: `修改备货数量`,
  key1006841: `目的仓库或发货仓不能为空！`,
  key1006842: `备货单导入`,
  key1006843: `目的仓库：`,
  key1006844: `1、一次性上传过多备货信息容易读取超时失败，建议单批次上传不超过100条备货信息;`,
  key1006845: `2、文件内容SKU若无商品SKU匹配项，或SKU对应数量内容非正整数，则视为无效内容;`,
  key1006846: `3、仅支持xls、xlsx格式文件;`,
  key1006847: `4、若文件中存在无效内容，则会上传失败;`,
  key1006848: `仅出库单类型为自有仓备货的备货单可打印`,
  key1006849: `条码！`,
  key1006850: `扫描SKU打印`,
  key1006851: `打印所选订单条码`,
  key1006852: `请先勾选需要标记发货的数据！`,
  key1006853: `当前筛选结果暂无数据，无法标记发货！`,
  key1006854: `当前订单中出库状态为待发货状态的订单，才可以执行发货！`,
  key1006855: `当前订单中备货状态为待发货状态的订单，才可以执行发货！`,
  key1006856: `请选择同发货仓的备货单进行批量发货`,
  key1006857: `发货台内当前无商品，无法打印配货清单。`,
  key1006858: `请先勾选需要打印的订单条码数据！`,
  key1006859: `当前筛选结果暂无数据！无法打印订单条码`,
  key1006860: `取消备货`,
  key1006861: `请确认是否取消备货？`,
  key1006862: `发起备货`,
  key1006863: `批量发货`,
  key1006864: `已选订单`,
  key1006865: `筛选结果订单`,
  key1006866: `配货清单格式`,
  key1006867: `清单格式：`,
  key1006868: `纸质清单`,
  key1006869: `表格文件`,
  key1006870: `sku不能为空！`,
  key1006871: `获取打印地址失败！`,
  key1006872: `扫描换单`,
  key1006873: `请扫描/输入SKU`,
  key1006874: `请扫描/输入SKU：`,
  key1006875: `批量打印：`,
  key1006876: `关闭弹窗`,
  key1006877: `收货信息`,
  key1006878: `国家/省州/城市：`,
  key1006879: `物流费：`,
  key1006880: `仓库处理费：`,
  key1006881: `商品加工状态`,
  key1006882: `工厂名称`,
  key1006883: `拒绝`,
  key1006884: `收货人`,
  key1006885: `国家/省州/城市`,
  key1006886: `货品总金额`,
  key1006887: `请确保选中的多条订单中对应物流均为第三方物流，且无需快递至揽收点`,
  key1006888: `缺货订单需标记到货后再进行发货！`,
  key1006889: `当前订单中出库单为待发货状态的订单，才可以执行发货！`,
  key1006890: `标记发货成功！`,
  key1006891: `当前筛选结果暂无数据，无法操作！`,
  key1006892: `请先勾选需要标记的数据！`,
  key1006893: `标记到货提示`,
  key1006894: `标记到货后订单将流转为待发货，请确认是否标记到货？`,
  key1006895: `仅可对缺货订单标记到货，请重新选择！`,
  key1006896: `仅可对非缺货订单标记缺货，请重新选择！`,
  key1006897: `接单确认`,
  key1006898: `拒绝接单确认`,
  key1006899: `正在操作接单，确认接单后将按照此订单金额进行结算，需等待客户付款，请确认是否接单？`,
  key1006900: `拒绝接单后，订单将可能被取消，请确认是否拒绝接单？`,
  key1006901: `拒绝接单`,
  key1006902: `接单成功`,
  key1006903: `拒绝接单成功`,
  key1006904: `工厂名称：`,
  key1006905: `请输入工厂名称`,
  key1006906: `切换发货仓`,
  key1006907: `发货仓选择：`,
  key1006908: `发货提醒`,
  key1006909: `目的仓库不能为空！`,
  key1006910: `商品数量不能为空或为0`,
  key1006911: `数量必须是大于0的整数`,
  key1006912: `发货仓不能为空！`,
  key1006913: `编码信息`,
  key1006914: `装箱提示`,
  key1006915: `你扫描的出库单号，与当前已装箱的出库单目的仓库不同，请扫描同一仓库的出库单号装箱。`,
  key1006916: `请输入sku`,
  key1006917: `扫描`,
  key1006918: `请扫描或输入扫描`,
  key1006919: `提货单号：`,
  key1006920: `请输入提货单号`,
  key1006921: `完成追加`,
  key1006922: `已扫描出库单`,
  key1006923: `国内快递单号不能为空`,
  key1006924: `物流运单号：`,
  key1006925: `打印数量不能为空`,
  key1006926: `结算金额：`,
  key1006927: `收货仓：`,
  key1006928: `收货姓名：`,
  key1006929: `联系方式：`,
  key1006930: `待客户付款`,
  key1006931: `收货仓`,
  key1006932: `收货姓名`,
  key1006933: `请选择收货信息与发货仓信息一致的订单进行批量发货`,
  key1006934: `请先在“仓库管理”中维护仓库地址再进行此操作`,
  key1006935: `统计本月（自然月）店铺已完成`,
  key1006936: `仓已发出`,
  key1006937: `的订单总金额。`,
  key1006938: `统计本月（自然月）已完成`,
  key1006939: `的订单总数。`,
  key1006940: `上月销售额`,
  key1006941: `本月订单量（单）`,
  key1006942: `上月订单量`,
  key1006943: `昨日订单量`,
  key1006944: `今日订单量`,
  key1006945: `在售SPU总数`,
  key1006946: `统计在售SPU总数量，不包含、停售、暂存状态的SPU。`,
  key1006947: `在售SKU总数`,
  key1006948: `统计在售SKU总数量，不包含、停售、暂存状态的SKU。`,
  key1006949: `订阅商品数（SPU）`,
  key1006950: `统计分销商订阅商品的总数，同一个商品多个分销商订阅只计算1次。`,
  key1006951: `本月订阅数`,
  key1006952: `昨日订阅数`,
  key1006953: `今日订阅数`,
  key1006954: `统计分销商已上架到平台的SPU总数量，同一个SPU不同的Item只计算一次。`,
  key1006955: `统计分销商已发布刊登SPU的总数量，按Item数量统计。`,
  key1006956: `近30天发货时效（小时）`,
  key1006957: `统计近30天所有订单从待拣货到已出库（快递揽收）的平均耗时`,
  key1006958: `近7天发货时效`,
  key1006959: `近3天发货时效`,
  key1006960: `在售中`,
  key1006961: `已售罄`,
  key1006962: `已驳回`,
  key1006963: `近7天`,
  key1006964: `近30天`,
  key1006965: `销售额(CNY)： ¥ `,
  key1006966: `订单量(单)：`,
  key1006967: `商品管理`,
  key1006968: `发布新商品`,
  key1006969: `销售趋势图`,
  key1006970: `热销商品排行榜`,
  key1006971: `库存明细日志`,
  key1006972: `提单`,
  key1006973: `上架/停售`,
  key1006974: `sku,支持多个按行分隔`,
  key1006975: `更新时间：`,
  key1006976: `请输入供应商sku,支持多个按行分隔`,
  key1006977: `修改价格`,
  key1006978: `批量改价`,
  key1006979: `批量上架/停售`,
  key1006980: `，该商品正在被映射商品使用，不能删除`,
  key1006981: `，SKU不存在`,
  key1006982: `，该SKU有库存不允许删除`,
  key1006983: `，系统繁忙，请重新尝试`,
  key1006984: `请输入中文标题`,
  key1006985: `审核状态：`,
  key1006986: `导出商品`,
  key1006987: `仓库信息完善提示`,
  key1006988: `获取1688商品`,
  key1006989: `采集1688商品`,
  key1006990: `1.导入销售价后将覆盖原来价格，请谨慎导入;`,
  key1006991: `1.按照SKU维度进行上架/停售，停售后分销商将无法继续下单;`,
  key1006992: `您还未配置发货仓库，或运营人员还未针对于您创建的发货仓配置仓库权限，`,
  key1006993: `暂不能添加商品，请先创建仓库并联系运营配置仓库权限后添加商品。`,
  key1006994: `去配置发货仓`,
  key1006995: `将尽快补充映射。`,
  key1006996: `匹配映射失败，`,
  key1006997: `SKU重复`,
  key1006998: `时间范围不能为空`,
  key1006999: `店铺不能为空`,
  key1007000: `1688店铺未绑定`,
  key1007001: `暂未绑定1688店铺，请绑定后重试。`,
  key1007002: `获取商品失败`,
  key1007003: `获取商品部分失败`,
  key1007004: `复制失败SPU`,
  key1007005: `匹配映射失败，可点击`,
  key1007006: `获取商品成功`,
  key1007007: `查看商品`,
  key1007008: `获取商品成功，可在商品页面`,
  key1007009: `商品获取中，请稍等!`,
  key1007010: `商品链接不能为空!`,
  key1007011: `指定链接地址必须是https://或者http://开头的链接!`,
  key1007012: `获取类型：`,
  key1007013: `选择店铺：`,
  key1007014: `商品链接：`,
  key1007015: `请输入1688商品链接，如:https://detail.1688.com/offer/673838787879.html支持多个按行分隔`,
  key1007016: `请选择1688商品创建时间`,
  key1007017: `指定商品`,
  key1007018: `获取`,
  key1007019: `商品采集中，请稍等!`,
  key1007020: `1688类目：`,
  key1007021: `批量采集`,
  key1007022: `近90天成交：`,
  key1007023: `按品牌状态`,
  key1007024: `按品牌名称`,
  key1007025: `品牌LOGO`,
  key1007026: `品牌名称`,
  key1007027: `品牌描述`,
  key1007028: `品牌网址`,
  key1007029: `品牌状态`,
  key1007030: `是否要删除当前品牌？`,
  key1007031: `新增品牌`,
  key1007032: `编辑品牌`,
  key1007033: `品牌名称不能为空`,
  key1007034: `品牌名称：`,
  key1007035: `请输入品牌名称`,
  key1007036: `品牌描述：`,
  key1007037: `请输入品牌描述`,
  key1007038: `品牌状态：`,
  key1007039: `品牌网址：`,
  key1007040: `请输入品牌网址`,
  key1007041: `品牌LOGO：`,
  key1007042: `单击或拖动此处上传文件`,
  key1007043: `价格不能为空！`,
  key1007044: `等待收款`,
  key1007045: `已收款`,
  key1007046: `商品原价`,
  key1007047: `货品金额（应收）：`,
  key1007048: `补贴金额（应收）：`,
  key1007049: `国内物流费用（应付）：`,
  key1007050: `自有物流费用（应收）：`,
  key1007051: `国内物流费用为供应商应付项，货品金额、补贴金额及自有物流费用为供应商应收项，计算时请注意`,
  key1007052: `确认账单即表示已对账单内容、金额核对无误，请确认账单后操作，确认账单后`,
  key1007053: `后台将发起打款流程，资金将转入所绑定的收款账户。`,
  key1007054: `货品结算金额(CNY)`,
  key1007055: `收款账户未绑定`,
  key1007056: `当前账户未绑定收款账户，无法完成收款流程，请绑定后重试。`,
  key1007057: `去绑定`,
  key1007058: `账单编号`,
  key1007059: `账单状态更新时间`,
  key1007060: `请输入账单编号，支持多个逗号或换行分隔`,
  key1007061: `同一个出库单中未拣数量至少要有一个是大于0`,
  key1007062: `未拣货/打印出库单明细`,
  key1007063: `物流面单`,
  key1007064: `云仓面单`,
  key1007065: `无面单`,
  key1007066: `混合面单`,
  key1007067: `包材`,
  key1007068: `重打面单`,
  key1007069: `拣货复核`,
  key1007070: `没有正在扫描的拣货单`,
  key1007071: `当前勾选中的数据都已打印！`,
  key1007072: `个拣货篮：`,
  key1007073: `打印选中面单`,
  key1007074: `入库单`,
  key1007075: `冻结单`,
  key1007076: `产品ID`,
  key1007077: `库位使用`,
  key1007078: `收货库位`,
  key1007079: `拣货库位`,
  key1007080: `冻结数量`,
  key1007081: `冻结分配`,
  key1007082: `解冻并分配`,
  key1007083: `已出库数量`,
  key1007084: `货品(已拣/待拣)`,
  key1007085: `多品分拣—结束分拣`,
  key1007086: `重打数量`,
  key1007087: `已打印数量`,
  key1007088: `已扫描完成`,
  key1007089: `匹配失败`,
  key1007090: `存在空的通途sku`,
  key1007091: `存在空的skuCode`,
  key1007092: `通途sku系统不存在`,
  key1007093: `skuCode 系统不存在`,
  key1007094: `头程成本必须是数字`,
  key1007095: `选择导入文件：`,
  key1007096: `选择文件`,
  key1007097: `下载模板`,
  key1007098: `作废出库单`,
  key1007099: `勾选重置出库单，会重新生成一个出库单`,
  key1007100: `重置出库单`,
  key1007101: `条出库单被重置状态，成功执行后的记录，将回到【等待分配】状态,同时出库单会执行以下操作：`,
  key1007102: `1.出库单如果已经下发物流成功，会尝试调用物流商接口取消下单`,
  key1007103: `2.出库单如果已经分配库存成功，会归还已分配库存`,
  key1007104: `供货优先级配置`,
  key1007105: `若存在多仓同时可以向同一个平台集货仓进行供货，系统将会按照下发设置的供货顺序，校验仓库库存，向对应仓库下发集货订单`,
  key1007106: `汇率：1CNY = `,
  key1007107: `设置物流渠道`,
  key1007108: `新增物流商`,
  key1007109: `设置物流商`,
  key1007110: `请输入物流商名称`,
  key1007111: `启用状态不能为空`,
  key1007112: `发货地址模板选择不能为空`,
  key1007113: `退货地址模板选择不能为空`,
  key1007114: `新建仓库`,
  key1007115: `请选择供货目标集货/备货仓`,
  key1007116: `请选择直发可用物流`,
  key1007117: `请先选择仓库发货地`,
  key1007118: `上门揽收或自行交货`,
  key1007119: `快递至揽收点`,
  key1007120: `查看&编辑物流`,
  key1007121: `参考时效(天)：`,
  key1007122: `适用重量(g)：`,
  key1007123: `确定要停用此该物流方式？`,
  key1007124: `请先选择要启用的物流方式`,
  key1007125: `启用物流方式`,
  key1007126: `是否确认启用此物流？`,
  key1007127: `是否确认停用此物流？`,
  key1007128: `是否确认停用此仓库？`,
  key1007129: `确认停用后，发货仓仅此仓库的商品将会同步停售。`,
  key1007130: `仓库编码`,
  key1007131: `是否确认启用此仓库？`,
  key1007132: `账号名`,
  key1007133: `授权时间`,
  key1007134: `数据同步`,
  key1007135: `授权`,
  key1007136: `新增商品`,
  key1007137: `代号：`,
  key1007138: `请输入代号`,
  key1007139: `账号名：`,
  key1007140: `请输入授权的平台账号`,
  key1007141: `到期时间：`,
  key1007142: `主仓实际库存`,
  key1007143: `订单占有数`,
  key1007144: `仓库待发数`,
  key1007145: `虚拟库存`,
  key1007146: `采购在途数`,
  key1007147: `销退仓库存`,
  key1007148: `进货仓库存`,
  key1007149: `次品库存`,
  key1007150: `库存 = `,
  key1007151: `规则项不能为空!`,
  key1007152: `库存 =`,
  key1007153: `选择仓库`,
  key1007154: `第三方平台仓库`,
  key1007155: `供应商仓库`,
  key1007156: `库存同步至`,
  key1007157: `您没有权限访问该资源,请与管理员联系`,
  key1007158: `系统繁忙，请重新尝试（接口报错了，请在控制台查看接口错误）`,
  key1007159: `账号已被停用`,
  key1007160: `供应商结算状态需为等待结算且`,
  key1007161: `出库状态需为已出库`,
  key1007162: `客户结算状态需为等待结算且`,
  key1007163: `确认支付账单失败，该账单已作废`,
  key1007164: `包裹不存在`,
  key1007165: `分类ID已存在`,
  key1007166: `父节点不存在`,
  key1007167: `分类名称不能包含->`,
  key1007168: `名称不能包含空格`,
  key1007169: `已到最大分类层级`,
  key1007170: `同级分类名已存在`,
  key1007171: `邮箱已经被占用`,
  key1007172: `手机号已经被占用`,
  key1007173: `包裹非已揽收状态`,
  key1007174: `查询不到相关出库单`,
  key1007175: `提单不为已分拣状态`,
  key1007176: `存在多个包裹`,
  key1007177: `提单状态需为已揽收或分拣中`,
  key1007178: `存在非分拣中状态`,
  key1007179: `出库单非已拣货状态`,
  key1007180: `交接单非已装箱状态`,
  key1007181: `已是客户`,
  key1007182: `图形验证码错误`,
  key1007183: `验证码错误`,
  key1007184: `邮箱未注册`,
  key1007185: `页面重复提交`,
  key1007186: `发送短信失败`,
  key1007187: `查询用户失败`,
  key1007188: `手机号为空`,
  key1007189: `密码错误`,
  key1007190: `短信验证码校验错误`,
  key1007191: `图形验证码失效`,
  key1007192: `超过错误次数,请输入图形验证码再重试`,
  key1007193: `重复提交`,
  key1007194: `非当前用户邮箱`,
  key1007195: `非当前用户手机`,
  key1007196: `登录失败,用户不存在`,
  key1007197: `请使用通途管理员账号登录注册分销账户`,
  key1007198: `通途帐号登录自动创建客户帐号成功,审核通过后再访问`,
  key1007199: `当前用户请审核通过之后登录`,
  key1007200: `商品不存在`,
  key1007201: `客户等级已绑定供应商等级`,
  key1007202: `供应商已设置该供应商等级`,
  key1007203: `查询的拣货单编号不存在`,
  key1007204: `品牌名已存在`,
  key1007205: `非草稿状态不能删除`,
  key1007206: `待审核不能修改中文名称,英文名称,标题,图片`,
  key1007207: `不能包含逗号`,
  key1007208: `存在相同属性SKU`,
  key1007209: `SPU或SKU存在重复`,
  key1007210: `变参商品SKU不能与SPU重复`,
  key1007211: `该商品正在被映射商品使用，不能删除`,
  key1007212: `包裹存在待完成的补拣单`,
  key1007213: `sku不存在`,
  key1007214: `物流渠道名称不可重复`,
  key1007215: `异常包裹中存在正常拣货包裹`,
  key1007216: `包裹已作废`,
  key1007217: `标出库失败，此包裹已作废待回收`,
  key1007218: `完成包装失败，包装状态已变更!`,
  key1007219: `不是多品多件拣货单，无法开启分拣作业。`,
  key1007220: `系统每个操作员同一时间只允许开启一个分拣作业`,
  key1007221: `拣货单正在被别人分拣中`,
  key1007222: `已经分拣完成，您可以对该拣货单重新开启分拣作业。`,
  key1007223: `存在已进行普通打印出库单`,
  key1007224: `拣货篮不能找到唯一没包装完成的拣货单`,
  key1007225: `拣货篮没有待完成的拣货单`,
  key1007226: `拣货单未打印，不能开始拣货复核`,
  key1007227: `拣货单已完成`,
  key1007228: `拣货单下不存在出库单`,
  key1007229: `拣货单下不存在有效出库单`,
  key1007230: `拣货单下存在商品备注`,
  key1007231: `拣货单下存在普通打印出库单`,
  key1007232: `拣货单未进行多品分拣`,
  key1007233: `拣货单下存在出库单未下发物流商成功`,
  key1007234: `拣货单拣货未完成`,
  key1007235: `分拣仅支持销售出库拣货单`,
  key1007236: `sku与upc不可重复`,
  key1007237: `upc已存在`,
  key1007238: `UPC存在重复`,
  key1007239: `存在重复SKU`,
  key1007240: `非销售出库单拣货单不支持拣货复核`,
  key1007241: `包裹已截留`,
  key1007242: `用户正在包装其他拣货单`,
  key1007243: `未找到可以分配的库存，无法分配`,
  key1007244: `包裹已出库`,
  key1007245: `包裹信息不存在`,
  key1007246: `箱号不能为空`,
  key1007247: `sku不能为空`,
  key1007248: `未找到对应出库单`,
  key1007249: `出库单号错误`,
  key1007250: `SKU不存在在`,
  key1007251: `拣货单不存在`,
  key1007252: `清空扫描失败，该包裹已经扫描完成`,
  key1007253: `装箱数量错误`,
  key1007254: `该拣货单下只有一个包裹，不能移除`,
  key1007255: `拣货单已完成拣货复核,无法重新分拣`,
  key1007256: `仓库正在配货中，请稍后再试`,
  key1007257: `包裹没有待补拣的货品`,
  key1007258: `入库单已关闭,不能进行收货!`,
  key1007259: `当前包裹不是已打印状态`,
  key1007260: `扫描的sku数量与应包装数量不一致`,
  key1007261: `未匹配合适出库单`,
  key1007262: `无效key`,
  key1007263: `扫描sku数量与身份码数量不一致`,
  key1007264: `当前提单状态不是装箱中不可以继续装箱`,
  key1007265: `结束分拣的拣货单分拣状态不是分拣中,不能结束分拣`,
  key1007266: `该包裹已提单`,
  key1007267: `已拣货的拣货单不能再次标记为已拣货`,
  key1007268: `包裹状态已变更,操作异常`,
  key1007269: `提单号不存在`,
  key1007270: `提单非等待揽收/正在装箱状态,`,
  key1007271: `不能删除`,
  key1007272: `当前属性正在被引用，不可删除`,
  key1007273: `同名属性已存在`,
  key1007274: `请停售被删除的SKU后重试`,
  key1007275: `该SKU有库存不允许删除`,
  key1007276: `SKU已存在`,
  key1007277: `订单已作废`,
  key1007278: `存在非等待揽收状态`,
  key1007279: `提单揽收包裹数量不统一`,
  key1007280: `属性不合法`,
  key1007281: `颜色的中文名称已存在`,
  key1007282: `库区编码重复`,
  key1007283: `库区名称重复`,
  key1007284: `仓库名称重复`,
  key1007285: `仓库编码重复`,
  key1007286: `该`,
  key1007287: `订单已换单无法取消`,
  key1007288: `操作人已完成拣货，请勿重复提交`,
  key1007289: `已分拣完成处于带包装状态，请勿重复提交`,
  key1007290: `已经撤销成功，请勿重复提交`,
  key1007291: `库位编号重复`,
  key1007292: `拣货单正在分拣`,
  key1007293: `没有匹配到待包装`,
  key1007294: `当前拣货单状态为非待拣货/拣货中状态`,
  key1007295: `拣货单不是待包装或者包装中`,
  key1007296: `状态已变更,请刷新后重试!`,
  key1007297: `只有已换单的包裹才可以扫描`,
  key1007298: `分类下存在商品`,
  key1007299: `分类下存在子分类`,
  key1007300: `重量不能为空`,
  key1007301: `剩下一个sku时`,
  key1007302: `不可以删除`,
  key1007303: `获取分类信息异常`,
  key1007304: `非物流面单类型不允许标记出库`,
  key1007305: `面单异常`,
  key1007306: `不能映射被删除的属性`,
  key1007307: `存在映射属性，不允许删除`,
  key1007308: `提单已删除`,
  key1007309: `变更的类别下存在映射属性，请先进行映射属性删除`,
  key1007310: `当前充值的客户编号不存在`,
  key1007311: `同一平台下不能存在相同站点/无站点则不能存在相同分类`,
  key1007312: `货品没有图片信息，请及时上传`,
  key1007313: `货品没有颜色图片信息，请及时上传`,
  key1007314: `物流商不存在`,
  key1007315: `物流商账号名称已存在`,
  key1007316: `平台帐号已停用`,
  key1007317: `服务名称或者编号重复`,
  key1007318: `物流商代码已存在`,
  key1007319: `存在相同名称的自动规则`,
  key1007320: `货代物理关联重复`,
  key1007321: `店铺编号已存在`,
  key1007322: `店铺名称已存在`,
  key1007323: `店铺名称和编号已存在`,
  key1007324: `已授权店铺不能切换店铺`,
  key1007325: `订单状态异常`,
  key1007326: `没有满足`,
  key1007327: `物流特殊规则的`,
  key1007328: `物流范围规则的`,
  key1007329: `取消订单异常`,
  key1007330: `更新用户信息异常`,
  key1007331: `更新物流信息异常`,
  key1007332: `创建订单失败`,
  key1007333: `订单已下单`,
  key1007334: `包裹已经出库`,
  key1007335: `正在处理下发物流操作`,
  key1007336: `取消物流失败`,
  key1007337: `供应商系统作废子单失败`,
  key1007338: `查询指定货品信息为空`,
  key1007339: `手工下单失败`,
  key1007340: `生成发货信息失败`,
  key1007341: `物流渠道停用失败，已关联`,
  key1007342: `物流无法停用`,
  key1007343: `物流渠道代码不可重复`,
  key1007344: `该包裹不处于等待出库状态`,
  key1007345: `指定拣货单列表为空`,
  key1007346: `中心仓备货的出库单已经生成拣货单，不允许作废`,
  key1007347: `面单正在拣货复核中`,
  key1007348: `出库单不是`,
  key1007349: `中心仓备货的出库单`,
  key1007350: `存在已出库的供应商子单`,
  key1007351: `没有找到sku对应的货品信息`,
  key1007352: `中心仓备货拣货单正在被扫描`,
  key1007353: `同类型通知消息模板已存在`,
  key1007354: `商户未设置刊登地址`,
  key1007355: `角色名称已存在`,
  key1007356: `角色在使用中`,
  key1007357: `未设置默认客户等级`,
  key1007358: `出库单已标缺货`,
  key1007359: `供应商未进行直接发货设置，不允许直接发货`,
  key1007360: `当前容器入库状态不是待换单`,
  key1007361: `同名容器类型已存在`,
  key1007362: `当前容器类型已被绑定`,
  key1007363: `容器与提单不在同一个仓库`,
  key1007364: `分拣容器中不存在该`,
  key1007365: `容器不存在`,
  key1007366: `容器已被绑定`,
  key1007367: `容器状态异常或已变更`,
  key1007368: `容器为空，不可结束分拣`,
  key1007369: `提单分拣数量异常，存在未完成分拣的sku或运单`,
  key1007370: `当前容器入库状态不是换单中`,
  key1007371: `订单已被分拣`,
  key1007372: `提单正在分拣`,
  key1007373: `容器状态不存在`,
  key1007374: `提单状态需为已入库或分拣中`,
  key1007375: `存在分拣中提单`,
  key1007376: `该提单其他用户正在分拣中`,
  key1007377: `已绑定同类型容器`,
  key1007378: `请完成当前的容器贴单作业`,
  key1007379: `容器正在贴单`,
  key1007380: `请完成当前的容器上架作业`,
  key1007381: `容器正在上架`,
  key1007382: `存在处理中的容器`,
  key1007383: `分拣交接单中已存在该`,
  key1007384: `订单需要先走商品分拣`,
  key1007385: `订单已发货，不可被移除`,
  key1007386: `正在处理下发物流,请稍后再试`,
  key1007387: `当前尺码类型正在被使用`,
  key1007388: `模板已被使用，不允许删除`,
  key1007389: `部位中文名称已被使用，不允许修改`,
  key1007390: `尺码值已存在`,
  key1007391: `规格属性已被使用，不允许删除`,
  key1007392: `规格属性已被使用，不允许修改`,
  key1007393: `当前尺码值,正在被使用,不允许删除`,
  key1007394: `主属性的规格属性已被使用，不允许修改`,
  key1007395: `导出模板异常`,
  key1007396: `聚水潭商户未授权`,
  key1007397: `未添加聚水潭商户`,
  key1007398: `未找到已勾选同步库存并且已启用的聚水潭商户`,
  key1007399: `Sku值为空`,
  key1007400: `不是在售的spu不能停售`,
  key1007401: `上架数量与拣货数量不一致`,
  key1007402: `导出账单信息为空`,
  key1007403: `手机未注册`,
  key1007404: `SPU不能包含中文`,
  key1007405: `当前尺码属性模板正在被使用`,
  key1007406: `已存在相同名称的属性，请修改属性名称后再提交`,
  key1007407: `没有创建仓库，请先创建仓库`,
  key1007408: `该订单已取消，请在线下补货到中心仓`,
  key1007409: `已装箱的出库单不能作废`,
  key1007410: `存在多个主属性`,
  key1007411: `未满足重复刊登条件`,
  key1007412: `入驻商户不存在`,
  key1007413: `密码校验错误`,
  key1007414: `未查询到收款人信息`,
  key1007415: `拣货单不是待分拣或者分拣中`,
  key1007416: `拣货单已取消`,
  key1007417: `拣货单不处于包装中`,
  key1007418: `正在装箱的出库单不能作废`,
  key1007419: `活动结束时间不能小于活动开始时间`,
  key1007420: `该商品已经存在其他活动中`,
  key1007421: `未找到商品对应类型的容器，请绑定后重新扫描。`,
  key1007422: `暂未授权WishPost，请在自有物流管理中授权并关联店铺后重试`,
  key1007423: `订单对应店铺暂未关联WishPost账户，请在自有物流管理中关联后重试`,
  key1007424: `WishPost授权无效，请在自有物流管理中重新授权后重试`,
  key1007425: `店铺已关联其他账号`,
  key1007426: `关联店铺未启用`,
  key1007427: `同名问卷已存在`,
  key1007428: `当前问卷下同名问题已存在`,
  key1007429: `仓库已关联供应商`,
  key1007430: `扫描包裹与交接单发货仓库不相同`,
  key1007431: `1688平台未授权店铺`,
  key1007432: `链接不存在`,
  key1007433: `币种配置已存在`,
  key1007434: `此拣货单为常规单，请至常规包装模块进行作业`,
  key1007435: `此拣货单为备货拣货单，请至备货分拣进行作业`,
  key1007436: `客户暂未执行发货，请下轮作业重试`,
  key1007437: `未查到相关小包信息`,
  key1007438: `当前小包已经被分拣扫描`,
  key1007439: `存在未包装完成小包`,
  key1007440: `存在未被物流分拣小包,请分拣完成后再结袋`,
  key1007441: `修改订单同步状态为同步中失败`,
  key1007442: `物流交接单所在仓未授权,请申请对应仓库权限`,
  key1007443: `交接单不存在`,
  key1007444: `请先开通Temu虚拟物流`,
  key1007445: `平台订单已存在`,
  key1007446: `物流商单号已存在`,
  key1007447: `已充值币种不可修改`,
  key1007448: `创建商品后币种不可修改`,
  key1007449: `正在进行中的作业不是分拣中或包装中`,
  key1007450: `扫描的sku数量超出拣货单的应拣数量`,
  key1007451: `已存在商品使用此属性作为规格属性，不可删除`,
  key1007452: `还原库存失败`,
  key1007453: `账单已经生成，补贴审核失败`,
  key1007454: `物流仅支持绑定一条渠道`,
  key1007455: `上传包裹失败`,
  key1007456: `获取面单失败`,
  key1007457: `仓库地址不存在`,
  key1007458: `物流未关联基础物流`,
  key1007459: `物流商获取token失败`,
  key1007460: `不允许扫描temu出库单`,
  key1007461: `速卖通oaid不存在`,
  key1007462: `解密失败`,
  key1007463: `账单已经生成，补贴重新审核失败`,
  key1007464: `打印所选订单条码异常`,
  key1007465: `打印sku条码异常`,
  key1007466: `存在非缺货中的货品无法标记到货`,
  key1007467: `无此商品订单，请核对订单`,
  key1007468: `提单非等待揽收状态`,
  key1007469: `出库单已出库,不可进行其他操作`,
  key1007470: `当前订单中存在出库单为非待发货状态的订单`,
  key1007471: `此拣货单内只有一个订单，此拣货单无需分拣，请进行备货包装作业`,
  key1007472: `此拣货单为常规单，请至常规分拣进行作业`,
  key1007473: `此拣货单为备货单，请至备货分拣进行作业`,
  key1007474: `追加货品，同步运营提单失败`,
  key1007475: `当前订单中存在出库单为缺货状态的订单`,
  key1007476: `中间标签码不可为空`,
  key1007477: `无发货订单`,
  key1007478: `该拣货单存在在未整单完结的`,
  key1007479: `手工订单和平台订单不可同时执行发货`,
  key1007480: `货品订单和样品订单不可同时执行发货`,
  key1007481: `不同店铺的订单不可同时执行发货`,
  key1007482: `不同收货地址的订单不可同时执行发货`,
  key1007483: `该订单存在未结袋的小包`,
  key1007484: `订单已经完结,不可以再次扫描`,
  key1007485: `手动修改的扫描数必须是大于0的正整数`,
  key1007486: `所选出库单批次下出库单超出最大限制，请调整最大包裏数`,
  key1007487: `每张拣货单最大出库单数不能为空或小于1`,
  key1007488: `拣货单正在被其他用户作业，不可再次作业`,
  key1007489: `temu_s拣货单存在未打印`,
  key1007490: `提单与容器所属仓库不同,请检查后重试`,
  key1007491: `创建订单失败,客户余额不足`,
  key1007492: `非待匹配商品或匹配物流失败或下单失败状态，无法标记为非`,
  key1007493: `订单操作`,
  key1007494: `同系统同模块下已存在该标题的标题指引，请重新定义标题`,
  key1007495: `物流/基础物流不能同时传`,
  key1007496: `物流/基础物流必传其一`,
  key1007497: `基础物流trackingNumber,labelPath必传`,
  key1007498: `sku已停售`,
  key1007499: `商品发货仓库匹配到多个，请拆分平台订单后，再下单`,
  key1007500: `匹配仓库失败`,
  key1007501: `商品可用库存为空或不合法`,
  key1007502: `账号未绑定店铺，或者账号已过期`,
  key1007503: `同名客户标签已存在`,
  key1007504: `该客户分组名已存在`,
  key1007505: `该用户已开启其他拣货作业`,
  key1007506: `手机已绑定,不支持更新手机`,
  key1007507: `商品所属类目未映射平台`,
  key1007508: `获取供应商币种接口失败`,
  key1007509: `SPU存在重复，请修改`,
  key1007510: `查询三方平台订单失败`,
  key1007511: `支付宝支付订单失败`,
  key1007512: `新增充值记录失败`,
  key1007513: `获取分销商币种失败`,
  key1007514: `未查询到可操作订单`,
  key1007515: `回传发货状态失败`,
  key1007516: `店铺地址为空`,
  key1007517: `物流交接单内订单为空`,
  key1007518: `已换单后不允许多品分拣移除拣货单`,
  key1007519: `未申请预约单`,
  key1007520: `容器类型已被使用，请删除已使用此类型的容器后，再编辑此容器类型`,
  key1007521: `未找到物流追踪记录`,
  key1007522: `未匹配到有效物流渠道`,
  key1007523: `存在下单失败的`,
  key1007524: `订单,请完成后再更换商品`,
  key1007525: `客户等级名称已存在,请更换后重试`,
  key1007526: `已装箱后不允许修改买家收件地址`,
  key1007527: `邮箱注册方式邮箱不可为空`,
  key1007528: `邮箱和手机至少需要填写一个`,
  key1007529: `此物流渠道暂不可用，详情请咨询客服`,
  key1007530: `已选商品正在生成资料中`,
  key1007531: `生成售卖资料失败`,
  key1007532: `已存在供应商账号`,
  key1007533: `请重新登录`,
  key1007534: `已存在分销商账号，请重新登录`,
  key1007535: `暂未开通供应商账号权限，请联系主账号开通，如有疑问，请联系在线客服咨询！`,
  key1007536: `html类型面单只允许单个打印`,
  key1007537: `销售价小于或等于0`,
  key1007538: `标记缺货的时候，缺货数量必须大于1`,
  key1007539: `该账号为运营商系统账号，请更换账号再试`,
  key1007540: `此发货仓已有此类型费用配置，请检查后重试`,
  key1007541: `未设置仓库处理费`,
  key1007542: `固定计费未设置常规或多品订单处理费`,
  key1007543: `分层计费未设置分层价或多频订单处理费`,
  key1007544: `当前勾选的账单存在已被确认过的账单`,
  key1007545: `此规格属性已被使用，不可修改为普通属性`,
  key1007546: `存在相同模板名称的地址薄`,
  key1007547: `备注内容过长,添加失败`,
  key1007548: `上架工具权限授权更新失败`,
  key1007549: `备货单所在提单已装箱`,
  key1007550: `同平台配置已存在`,
  key1007551: `未配置指定平台`,
  key1007552: `未配置指定店铺`,
  key1007553: `未配置刊登模板`,
  key1007554: `店铺token失效`,
  key1007555: `未设置超时时间`,
  key1007556: `请先开通速卖通全托管物流`,
  key1007557: `IOSS编码格式不正确`,
  key1007558: `目的国税率设置已存在`,
  key1007559: `同名IOSS配置已存在`,
  key1007560: `其中有原料正在被组装商品使用，不能删除`,
  key1007561: `平台订单IOSS已录入`,
  key1007562: `物流代缴，清关费用不可为空`,
  key1007563: `此物流渠道已停用,请重新选择物流渠道`,
  key1007564: `存在已经生成售卖资料的数据`,
  key1007565: `分销商备货单不是待支付状态`,
  key1007566: `分销商取消备货单货品数量校验异常`,
  key1007567: `分销商备货单不是待调价状态`,
  key1007568: `分销商备货单不是供应商待接价状态`,
  key1007569: `分配备货单上架库存失败`,
  key1007570: `设置组装商品中包含已删除货品`,
  key1007571: `设置组装商品中原材料包含组装货品`,
  key1007572: `组装商品原材料不能和当前商品一致`,
  key1007573: `存在相同名称的导出模板`,
  key1007574: `未配置组装商品虚拟库位`,
  key1007575: `组装商品原料及成品出入库失败`,
  key1007576: `物流交接单非分拣中状态`,
  key1007577: `没有匹配买家邮政编码的`,
  key1007578: `可操作单数量与选择不一致`,
  key1007579: `保存申报信息失败`,
  key1007580: `不支持的库存操作`,
  key1007581: `库存操作失败`,
  key1007582: `调接口获取供应商数据失败`,
  key1007583: `当前提单非自有物流且处在等待揽收状态，不可修改物流`,
  key1007584: `货品分配数失败`,
  key1007585: `撤回`,
  key1007586: `调速卖通创建揽收接口失败`,
  key1007587: `打印揽收面单图片访问失败`,
  key1007588: `调速卖通全托管打印揽收面单接口失败`,
  key1007589: `速卖通预约交货接口调用API异常`,
  key1007590: `超出此物流尺寸限制，请更换物流后重试`,
  key1007591: `超出此物流重量限制，请更换物流后重试`,
  key1007592: `超出此物流配送范围，请更换物流后重试`,
  key1007593: `待接单状态无法匹配商品`,
  key1007594: `由于货品数量过多，请在详情中进行单个打印`,
  key1007595: `商品属性未填写属性占比`,
  key1007596: `当前交接单内存在已取消的包裹，请移除已取消包裹后重试`,
  key1007597: `存在非已装箱的订单`,
  key1007598: `导入新增库存货主角色存在异常，请核对后重试`,
  key1007599: `导入新增库存货品供应商商户错误`,
  key1007600: `此商品已停售，`,
  key1007601: `仓库存数量小于订单货品数量，暂无法下单`,
  key1007602: `生成拣货单失败`,
  key1007603: `存在分销商未取消订单，请稍后再试`,
  key1007604: `当前物流不可达，请取消订单后重新下单`,
  key1007605: `暂未开通分销商账号权限，请联系主账号开通，如有疑问，请联系在线客服咨询！`,
  key1007606: `更换收货地址取消`,
  key1007607: `订单异常`,
  key1007608: `更换收货地址失败，订单已取消`,
  key1007609: `存在重复快递单号，此包裹请通过提单号进行扫描`,
  key1007610: `非等待揽收状态不可作废`,
  key1007611: `作废供应商提单失败`,
  key1007612: `站点名称已经被使用，请更改其他站点名`,
  key1007613: `仅支持已创建、备货中订单进行取消，请刷新数据查看`,
  key1007614: `未设置云卖物流规则`,
  key1007615: `回传样品发货信息失败`,
  key1007616: `获取大仓收货地址失败`,
  key1007617: `商品条码查询失败`,
  key1007618: `查询寄样单列表`,
  key1007619: `未匹配到发货方式`,
  key1007620: `物流代缴，清关费不可为空`,
  key1007621: `无有效的发货信息`,
  key1007622: `平台单不存在交易信息`,
  key1007623: `订单已发货`,
  key1007624: `出库单非已出库状态`,
  key1007625: `商品非待审核状态`,
  key1007626: `已关注该店铺`,
  key1007627: `商品分类信息不存在`,
  key1007628: `已取消收藏`,
  key1007629: `当前待上架提单不是已入库状态`,
  key1007630: `重置包裹状态失败`,
  key1007631: `未匹配到仓库，请联系客服处理`,
  key1007632: `容器非货品分拣完成状态`,
  key1007633: `已经处于完成上架状态，请勿重复操作`,
  key1007634: `该货品已经分拣完成`,
  key1007635: `未设置刊登规则`,
  key1007636: `未匹配到库区，请联系客服处理`,
  key1007637: `SKU与货位号不匹配，请检查后重试`,
  key1007638: `SKU已完拣`,
  key1007639: `账单不是付款状态`,
  key1007640: `必传其一`,
  key1007641: `供应商未设置归属仓库`,
  key1007642: `未完全分配ymsWarehouseLocation`,
  key1007643: `速卖通线上发货UserNick必传`,
  key1007644: `包裹所在仓未授权`,
  key1007645: `物流交接单仓库与包裹仓库不匹配`,
  key1007646: `物流交接单仓库与包裹物流不一致`,
  key1007647: `缺少包裹`,
  key1007648: `物流商编号已存在`,
  key1007649: `三方平台不存在`,
  key1007650: `获取店铺的发货,退货地址失败`,
  key1007651: `当前云卖订单未发货`,
  key1007652: `当前订单物流方式不是云卖物流`,
  key1007653: `速卖通打印面单接口失败`,
  key1007654: `单次最多可处理200个包裹，请移出后再结袋`,
  key1007655: `分销商备货单已经支付，不可再次支付`,
  key1007656: `所选仓库内无此库区，请核对后重试`,
  key1007657: `所选仓库内无此库位，请核对后重试`,
  key1007658: `存在重复数据，请确认后重试`,
  key1007659: `分类不存在`,
  key1007660: `订单编号查询订单Id集合异常`,
  key1007661: `包裹信息保存失败`,
  key1007662: `获取物流商异常`,
  key1007663: `打印面单异常`,
  key1007664: `订单已经存在包裹`,
  key1007665: `物流商帐号不存在`,
  key1007666: `存在未回收包裹`,
  key1007667: `包裹订单数据异常`,
  key1007668: `获取订单异常`,
  key1007669: `更新订单打印时间失败`,
  key1007670: `发货系统包裹数据与订单系统数据不一致`,
  key1007671: `出库单下发物流未成功`,
  key1007672: `出库单标记打印失败,部分包裹已经进行其他打印方式`,
  key1007673: `包裹未交运`,
  key1007674: `无效的可用库存数请输入大于0可用库存数`,
  key1007675: `发货台内当前无商品，无法打印配货清单`,
  key1007676: `修改备货单货品数量失败`,
  key1007677: `当前提单非等待揽收状态，不可修改物流`,
  key1007678: `当前提单非自有物流，不可修改物流`,
  key1007679: `获取仓库异常`,
  key1007680: `更新包裹包装状态异常`,
  key1007681: `用户没有开启分拣时打印地址面单`,
  key1007682: `存在商品在使用该品牌，不能删除!`,
  key1007683: `提交存在相同属性`,
  key1007684: `变参商品空属性`,
  key1007685: `属性key不一致`,
  key1007686: `删除SKU异常`,
  key1007687: `上传图片路径为空`,
  key1007688: `普通商品spu与sku必须一致`,
  key1007689: `变参商品属性不能为空`,
  key1007690: `特性标签包含逗号`,
  key1007691: `非变参不能添加格外sku`,
  key1007692: `spu不能为空`,
  key1007693: `cnName不能为空`,
  key1007694: `分类ID不能为空`,
  key1007695: `productGoodsList不能为空`,
  key1007696: `sku未匹配`,
  key1007697: `请求参数为空`,
  key1007698: `取消分配失败`,
  key1007699: `取消分配失败出库单不存在`,
  key1007700: `取消分配失败已发货、已取消、已生成拣货单或已拣货的不可取消`,
  key1007701: `取消分配失败删除拣货单失败`,
  key1007702: `取消分配失败还原原库存数据`,
  key1007703: `(分配之前`,
  key1007704: `)失败`,
  key1007705: `取消分配失败修改库存产品明细数据失败`,
  key1007706: `(已分配数量`,
  key1007707: `取消分配失败产品分配记录删除失败`,
  key1007708: `操作出库单失败`,
  key1007709: `明细数据为空`,
  key1007710: `未找到出库单`,
  key1007711: `操作货品失败`,
  key1007712: `拣货状态不正确`,
  key1007713: `发货状态状态不正确`,
  key1007714: `物流地址为空，请填写物流地址`,
  key1007715: `地址不匹配，请联系在线客服咨询`,
  key1007716: `调用支付宝转账异常`,
  key1007717: `同步平台地址失败`,
  key1007718: `仅待审核客户可进行审核，请重新选择`,
  key1007719: `速卖通接口异常`,
  key1007720: `pms物流账号token为空`,
  key1007721: `包裹号为空`,
  key1007722: `商品链接为空`,
  key1007723: `物流取消异常`,
  key1007724: `获取ioss税率配置失败`,
  key1007725: `当前订单不是手工单`,
  key1007726: `未查询到客户编号所对应的联系人`,
  key1007727: `未查询到库存统计表中要更新的数据YmsInventoryWarehouse`,
  key1007728: `修改alibabagj收货地址失败`,
  key1007729: `当前订单中存在出库单为非尾程物流的POD订单`,
  key1007730: `确认订单付款报错，接口异常`,
  key1007731: `阿里国际平台单非手工取消`,
  key1007732: `发货重试`,
  key1007733: `未找到已匹配商品的分销商平台订单`,
  key1007734: `wms发货失败`,
  key1007735: `未找到符合订单条件的云卖物流`,
  key1007736: `wms取消失败`,
  key1007737: `仓库为空`,
  key1007738: `当前拣货单中包含状态为非`,
  key1007739: `待拣货/拣货中`,
  key1007740: `包裹下的ordershipingid已经存在`,
  key1007741: `获取发货设置异常`,
  key1007742: `出库单列表数量无效`,
  key1007743: `分配库存异常`,
  key1007744: `未出库的包裹`,
  key1007745: `更新账单和出库单状态失败`,
  key1007746: `同一平台下不能存在相同站点`,
  key1007747: `请确认商户号是否正确`,
  key1007748: `店铺不存在`,
  key1007749: `拣货单正在包装中`,
  key1007750: `容器非待拣货状态`,
  key1007751: `拣货单不是待拣货或拣货中`,
  key1007752: `当前云卖面单正在拣货复核中`,
  key1007753: `商品状态错误`,
  key1007754: `拣货单状态异常`,
  key1007755: `获取包装设置异常`,
  key1007756: `未匹配到指定云卖订单`,
  key1007757: `未获取面单异常`,
  key1007758: `分销商不可选择阿里国际商品下单`,
  key1007759: `库区名称name重复`,
  key1007760: `库区库位不能都为null`,
  key1007761: `可用库存不能小于0`,
  key1007762: `商品生成面单标签异常`,
  key1007763: `生成云卖面单异常`,
  key1007764: `无效的仓储库存信息ID`,
  key1007765: `仅支持对待审核状态账单进行批量审核，请检查后重试`,
  key1007766: `仅支持对待打款状态账单进行批量审核，请检查后重试`,
  key1007767: `无此API权限，请联系客服开通`,
  key1007768: `备货单拆单失败`,
  key1007769: `订单同名标签已存在`,
  key1007770: `此订单中含有特殊需加工商品，无法直接取消，若需取消请联系客服`,
  key1007771: `同名商品标签已存在`,
  key1007772: `同名订单导入模板已存在`,
  key1007773: `存在相同Excel文件标题`,
  key1007774: `等级折扣系数值设置无效`,
  key1007775: `存在非待确认支付信息`,
  key1007776: `取消失败，运营已对账通过，请刷新后查看`,
  key1007777: `未匹配平台仓库`,
  key1007778: `查询卖家发货仓库基础信息接口失败`,
  key1007779: `仅普通属性可选值可关联子属性`,
  key1007780: `商品属性之间存在循环关联`,
  key1007781: `被关联属性不可修改为规格属性`,
  key1007782: `必须满足`,
  key1007783: `总计信用额度≥预扣金额+已使用额度-余额`,
  key1007784: `此物流渠道需发快递至揽收点，国内快递或物流商、物流单号不能为空`,
  key1007785: `发货地国家为空`,
  key1007786: `仓库名称或编码重复`,
  key1007787: `该地址模板正在被使用，不可停用`,
  key1007788: `供货仓配置不可为空`,
  key1007789: `直发仓配置不可为空`,
  key1007790: `供货仓与目标集货仓发货地不一致`,
  key1007791: `查询订单发货地址解密接口失败`,
  key1007792: `发货地重复`,
  key1007793: `更新仓库设置失败`,
  key1007794: `更新供应商仓库类型失败`,
  key1007795: `分销商未设置智能仓库规则`,
  key1007796: `没有满足条件的仓库规则`,
  key1007797: `订单未指定发货仓`,
  key1007798: `云卖平台订单云卖订单关系不存在`,
  key1007799: `云卖平台订单云卖订单关系正在处理`,
  key1007800: `选择指定物流时物流商或渠道为空`,
  key1007801: `定制商品不支持备货`,
  key1007802: `非直发订单不可直接发货`,
  key1007803: `自有物流发货物流运单号不可为空`,
  key1007804: `第三方物流发货快递至揽收点物流渠道或快递单号不可为空`,
  key1007805: `存在未匹配物流的发货信息`,
  key1007806: `没有待付款`,
  key1007807: `发货仓无法往中心仓供货`,
  key1007808: `此物流商名称已存在`,
  key1007809: `无效的邮寄方式`,
  key1007810: `此商品对应分类未映射平台信息，请联系运营设置后操作`,
  key1007811: `全球可达运费相同只能有一个默认分区`,
  key1007812: `第三方物流交货方式不可为空`,
  key1007813: `备货单spu不允许备货当前仓库`,
  key1007814: `请“商品管理列表-供应商库存”清空商品对应发货仓库存后再进行发货仓移除`,
  key1007815: `当前已有供应商仓库与其形成供货/备货关系，请勿修改仓库发货地`,
  key1007816: `请先清空对应仓库的库存后再进行停用操作`,
  key1007817: `分类下已存在支持定制的商品，不可将分类设置为不允许商品定制`,
  key1007818: `当前无已启用的定制部位信息，请维护后保存`,
  key1007819: `订单中存在定制商品，若需要取消订单请联系平台运营`,
  key1007820: `定制商品未设置定制信息`,
  key1007821: `定制商品未设置定制信息图片`,
  key1007822: `订单货品未关联合规信息`,
  key1007823: `修改地址失败，如需修改请联系运营进行调整`,
  key1007824: `定制商品订单仅支持装箱前订单进行取消，请刷新数据查看状态`,
  key1007825: `获取定制商品失败`,
  key1007826: `定制商品订单加工状态不可为空`,
  key1007827: `手机、邮箱、官网至少填写一个`,
  key1007828: `商品未设置发货仓所在国价格`,
  key1007829: `合并合规标签失败`,
  key1007830: `关联区域不可为空`,
  key1007831: `同名制造商已存在`,
  key1007832: `类目id不能为空`,
  key1007833: `一级类目不允许删除`,
  key1007834: `类目存在下级类目，不允许删除`,
  key1007835: `类目下存在文档，不允许删除`,
  key1007836: `批量新增类目数据不能为空`,
  key1007837: `帮助中心文档类目id不能为空`,
  key1007838: `帮助中心文档信息不存在`,
  key1007839: `批量新增帮助中心文档数据不能为空`,
  key1007840: `审核商品不存在，请刷新列表后重试`,
  key1007841: `当前文档为官方文档，不能删除`,
  key1007842: `平台id不能为空`,
  key1007843: `帮助中心文档id不能为空`,
  key1007844: `获取邮寄方式失败`,
  key1007845: `模块id不能为空`,
  key1007846: `待更新的文档类目数据不能为空`,
  key1007847: `商品销售价规则正在执行中，请刷新`,
  key1007848: `新增板块数据不能为空`,
  key1007849: `更新板块数据不能为空`,
  key1007850: `物流单作废配置区间不合法`,
  key1007851: `定制部位不存在`,
  key1007852: `定制部位不可重复`,
  key1007853: `定制商品成品预览图不可为空且最多上传两张`,
  key1007854: `定制商品素材图不可为空且最多上传一张`,
  key1007855: `定制商品素材图或成品图不可为空`,
  key1007856: `定制内容不可为空`,
  key1007857: `特殊销售价配置每组规则必选一个`,
  key1007858: `请先配置正常状态的规则信息`,
  key1007859: `非三方仓物流渠道未关联三方仓物流`,
  key1007860: `第三方仓配置项不可编辑`,
  key1007861: `SAAS未开启三方仓配置`,
  key1007862: `买家信息当前周期，用户无解密次数。请申请解密额度`,
  key1007863: `1688买家收件人信息查询失败`,
  key1007864: `商品原产地不可为空`,
  key1007865: `合规信息缺少商品信息`,
  key1007866: `管理员用户不能停用`,
  key1007867: `商品规格属性已停用或不存在，请重新填写`,
  key1007868: `导入新增库存货品平台自营商户错误`,
  key1007869: `暂不支持查询平台自营货主库存`,
  key1007870: `提单入库类型错误`,
  key1007871: `盘点货主不可为空`,
  key1007872: `新建提单货品信息不可为空`,
  key1007873: `新建提单货品操作数量有误`,
  key1007874: `提单仓库不可为空`,
  key1007875: `供货阶梯价起始价格不可为空`,
  key1007876: `付款方式不可为空`,
  key1007877: `支付凭证不可为空`,
  key1007878: `支付凭证资料不全`,
  key1007879: `线下支付失败,保存支付凭证异常`,
  key1007880: `订单已走线下支付，请到付款管理处理`,
  key1007881: `没有填写平台销售链接`,
  key1007882: `联系人不可为空`,
  key1007883: `店铺id不可为空`,
  key1007884: `当前存在使用此仓库作为发货仓的订单，请处理后再停用仓库`,
  key1007885: `部分国家供货价不可为空`,
  key1007886: `订单已获取运单号`,
  key1007887: `后台获取运单号中,请稍后重试`,
  key1007888: `平台自营商品`,
  key1007889: `编辑平台自营商品`,
  key1007890: `供应商商品`,
  key1007891: `编辑商品`,
  key1007892: `尺码表模板`,
  key1007893: `新增/编辑尺码表模板`,
  key1007894: `新品审核`,
  key1007895: `新品审核/编辑商品`,
  key1007896: `在售商品修改审核`,
  key1007897: `在售商品修改审核/编辑商品`,
  key1007898: `商品销售价配置`,
  key1007899: `供应商订单详情`,
  key1007900: `分销商备货单`,
  key1007901: `供应商备货单`,
  key1007902: `供应商备货单详情`,
  key1007903: `订单收款账户`,
  key1007904: `入库管理`,
  key1007905: `提单管理`,
  key1007906: `提单管理详情`,
  key1007907: `查看出库单详情`,
  key1007908: `拣货单列表`,
  key1007909: `见货出单`,
  key1007910: `见货出单设置`,
  key1007911: `物流商交接单管理`,
  key1007912: `物流商交接单管理详情`,
  key1007913: `供应商管理`,
  key1007914: `供应商列表`,
  key1007915: `供应商审核`,
  key1007916: `供应商等级管理`,
  key1007917: `客户管理`,
  key1007918: `客户列表`,
  key1007919: `拓客链接`,
  key1007920: `平台账单详情`,
  key1007921: `供应商账单`,
  key1007922: `供应商账单详情`,
  key1007923: `客户账单详情`,
  key1007924: `物流账单详情`,
  key1007925: `仓储账单详情`,
  key1007926: `客户余额变动`,
  key1007927: `密码管理`,
  key1007928: `物流管理`,
  key1007929: `基础物流`,
  key1007930: `智能物流规则`,
  key1007931: `仓库管理`,
  key1007932: `库区管理`,
  key1007933: `库位管理`,
  key1007934: `消息模板`,
  key1007935: `容器管理`,
  key1007936: `容器类型设置`,
  key1007937: `地址库管理`,
  key1007938: `出入库流程配置`,
  key1007939: `IOSS税率设置`,
  key1007940: `系统配置`,
  key1007941: `规则`,
  key1007942: `自动分仓规则`,
  key1007943: `第三方平台管理`,
  key1007944: `发货地管理`,
  key1007945: `内容管理`,
  key1007946: `问卷调查`,
  key1007947: `编辑问卷`,
  key1007948: `数据中心`,
  key1007949: `营销管理`,
  key1007950: `站点管理`,
  key1007951: `活动管理`,
  key1007952: `新增/编辑活动`,
  key1007953: `广告管理`,
  key1007954: `分销商费用配置`,
  key1007955: `消息、邮箱查看`,
  key1007956: `员工管理`,
  key1007957: `任务中心`,
  key1007958: `导入任务`,
  key1007959: `导出任务`,
  key1007960: `订单中心`,
  key1007961: `集货订单列表`,
  key1007962: `直发订单列表`,
  key1007963: `备货单详情`,
  key1007964: `发货记录`,
  key1007965: `发货记录详情`,
  key1007966: `商品中心`,
  key1007967: `新增/编辑商品`,
  key1007968: `品牌管理`,
  key1007969: `仓储与物流`,
  key1007970: `仓库费用配置`,
  key1007971: `第三方平台`,
  key1007972: `平台授权`,
  key1007973: `对账管理`,
  key1007974: `账户管理`,
  key1007975: `分销市场`,
  key1007976: `收藏的商品`,
  key1007977: `我设计的商品`,
  key1007978: `生成售卖记录`,
  key1007979: `自动规则`,
  key1007980: `店铺管理`,
  key1007981: `平台订单详情`,
  key1007982: `添加Temu订单`,
  key1007983: `付款管理`,
  key1007984: `订单导入模板`,
  key1007985: `仓库列表`,
  key1007986: `智能仓库规则`,
  key1007987: `合规责任人管理`,
  key1007988: `制造商信息管理`,
  key1007989: `权限管理`,
  key1007990: `角色管理`,
  key1007991: `用户管理`,
  key1007992: `价格变动详情`,
  key1007993: `账号管理`,
  key1007994: `安全信息`,
  key1007995: `商品、店铺列表`
}
